import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link, Routes, Route, Navigate } from 'react-router-dom';
import get from 'lodash/get';
import set from 'lodash/set';
import map from 'lodash/map';
import words from 'lodash/words';
import findIndex from 'lodash/findIndex';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import replace from 'lodash/replace';
import round from 'lodash/round';
import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';
import every from 'lodash/every';
import each from 'lodash/each';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { AnimatePresence, motion } from 'framer-motion';
import { Badge, FloatingLabel, Form, Col, Button, Offcanvas, Container, Row, Image } from 'react-bootstrap';
import { Datepicker } from '@mobiscroll/react';
import moment from 'dayjs';
import MaskedInput from 'react-maskedinput';
import { ReactSVG } from 'react-svg';
import Button$1 from 'react-bootstrap/Button';
import Recaptcha from 'react-google-invisible-recaptcha';
import { CaretDownFill } from 'react-bootstrap-icons';

var FlowContext = React__default.createContext(null);
var FlowProvider = function (props) {
    // Debugging logs
    // console.log("[Debug] FlowProvider render start");
    // Sử dụng useRef để theo dõi giá trị trước đó của activeStep
    var prevStepRef = React__default.useRef();
    // Định nghĩa state
    var _a = React__default.useState(), activeStep = _a[0], setActiveStepInternal = _a[1];
    // Force update state để trigger renders khi cần
    var _b = React__default.useState(0), updateCounter = _b[0], setUpdateCounter = _b[1];
    var forceUpdate = React__default.useCallback(function () {
        // console.log("[Debug] FlowProvider forceUpdate called");
        setUpdateCounter(function (c) { return c + 1; });
    }, []);
    // Custom setter để debug
    var setActiveStep = React__default.useCallback(function (newStep) {
        // console.log("[Debug] FlowProvider setActiveStep called with:", 
        //   typeof newStep === 'function' 
        //     ? 'function updater' 
        //     : (newStep ? `step: ${newStep.slug}` : 'undefined step'));
        setActiveStepInternal(function (prevActiveStep) {
            var nextStep = typeof newStep === 'function'
                ? newStep(prevActiveStep)
                : newStep;
            // console.log("[Debug] FlowProvider updating from", 
            //   prevActiveStep?.slug, 
            //   "to", 
            //   nextStep?.slug);
            // Cập nhật biến global
            if (nextStep) {
                window.__CURRENT_ACTIVE_STEP__ = nextStep;
                // console.log("[Debug] Updated global __CURRENT_ACTIVE_STEP__ to:", nextStep.slug);
            }
            return nextStep;
        });
    }, []);
    // Effect để log mỗi khi activeStep thay đổi
    React__default.useEffect(function () {
        // console.log(
        //   "[Debug] FlowProvider activeStep changed to:", 
        //   activeStep?.slug, 
        //   "previous was:", prevStepRef.current,
        //   "update counter:", updateCounter
        // );
        // Cập nhật global variable
        if (activeStep) {
            window.__CURRENT_ACTIVE_STEP__ = activeStep;
            // console.log("[Debug] Set global __CURRENT_ACTIVE_STEP__ to:", activeStep.slug);
        }
        // Cập nhật giá trị trước đó
        prevStepRef.current = activeStep === null || activeStep === void 0 ? void 0 : activeStep.slug;
    }, [activeStep, updateCounter]);
    // console.log("[Debug] FlowProvider render end, current activeStep:", activeStep?.slug);
    // Provide context
    var contextValue = React__default.useMemo(function () { return ({
        activeStep: activeStep,
        setActiveStep: setActiveStep,
        forceUpdate: forceUpdate
    }); }, [activeStep, setActiveStep, forceUpdate, updateCounter]);
    return (React__default.createElement(FlowContext.Provider, { value: contextValue }, props.children));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// Tạo đối tượng và ép kiểu
var lodashUtils = {
    get: get,
    set: set,
    map: map,
    words: words,
    findIndex: findIndex,
    has: has,
    isNumber: isNumber,
    toNumber: toNumber,
    isEmpty: isEmpty,
    capitalize: capitalize,
    replace: replace,
    round: round,
    assign: assign,
    cloneDeep: cloneDeep,
    every: every,
    each: each,
};

var StringFormats;
(function (StringFormats) {
    StringFormats["AddPercent"] = "add_percent";
    StringFormats["Currency"] = "currency";
    StringFormats["CurrencyNoCents"] = "currency_no_cents";
    StringFormats["Date_dd_mmm_yyyy"] = "date_dd_mmm_yyyy";
    StringFormats["EndOf_Date_dd_mmm_yyyy"] = "endof_date_dd_mmm_yyyy";
    StringFormats["CapitalizeFirstLetter"] = "capitalize_first_letter";
    StringFormats["YesNo_to_IncludedExcluded"] = "yesno_to_includedexcluded";
    StringFormats["AUPhoneNumber"] = "au_phone_number";
})(StringFormats || (StringFormats = {}));
function formatString(input, format) {
    if (input === undefined || input == null)
        return '';
    switch (format) {
        case StringFormats.AddPercent:
            if (input)
                return input + '%';
            else
                return '';
        case StringFormats.Currency:
            if (lodashUtils.isNumber(input))
                return new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD',
                    maximumFractionDigits: 2,
                }).format(lodashUtils.toNumber(input));
            else
                return input;
        case StringFormats.CurrencyNoCents:
            if (!isNaN(input))
                return new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD',
                    maximumFractionDigits: 0,
                }).format(lodashUtils.toNumber(input));
            else
                return input.toString();
        case StringFormats.Date_dd_mmm_yyyy:
            var date = new Date(input);
            var month = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(date);
            return "".concat(date.getDate(), " ").concat(month, " ").concat(date.getFullYear());
        case StringFormats.EndOf_Date_dd_mmm_yyyy:
            return formatString(input, StringFormats.Date_dd_mmm_yyyy) + ' 23:59';
        case StringFormats.CapitalizeFirstLetter:
            var result = input.toString();
            return (result.charAt(0).toUpperCase() +
                (result.length > 1 ? result.slice(1) : ''));
        case StringFormats.YesNo_to_IncludedExcluded:
            if (input === 'yes')
                return 'Included';
            else if (input === 'no')
                return 'Excluded';
        case StringFormats.AUPhoneNumber:
            if (input.toString().length === 10) {
                if (input.toString().startsWith('04')) {
                    return (input.toString().slice(0, 4) +
                        ' ' +
                        input.toString().slice(4, 7) +
                        ' ' +
                        input.toString().slice(7, 10));
                }
                else if (input.toString().startsWith('0')) {
                    return (input.toString().slice(0, 2) +
                        ' ' +
                        input.toString().slice(2, 6) +
                        ' ' +
                        input.toString().slice(6, 10));
                }
            }
        default:
            return input.toString();
    }
}

// ==== Notify data changes ===================================================
// These functions are used to notify components when data has changed.
// Components can use these functions to subscribe and unsubscribe notification
// of data changes.
// ============================================================================
function notifyDataChange(dataPath, dataField, data) {
    dataChangeSubscriptions.forEach(function (subscription) {
        subscription.callback(dataPath, dataField, data);
    });
}
var dataChangeSubscriptions = [];
function subscribeDataChange(key, callback) {
    if (!dataChangeSubscriptions.find(function (subscription) { return subscription.key === key; })) {
        dataChangeSubscriptions.push({ key: key, callback: callback });
    }
}
function unsubscribeDataChange(key) {
    dataChangeSubscriptions = dataChangeSubscriptions.filter(function (subscription) { return subscription.key !== key; });
}
function clearDataChangeSubscriptions() {
    dataChangeSubscriptions = [];
}
function getCurrentDataChangeSubscriptions() {
    return lodashUtils.map(dataChangeSubscriptions, 'key');
}

var emailValidationPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z]{2,63}$";

// const PetsyTracker = (window as any).PetsyTracker;
var flowPathDataStore = {};
var flowCacheStore = {};
var flowTelemetryStore = {};
var flowConfigStore;
var flowHelpTipsStore;
var currentActiveStepValue;
var tracker;
var trackEventRouterLocation;
/** Gọi khi user bấm Next thành công (đã qua validation) trước khi chuyển bước — dùng để tích hợp analytics từ app (vd. Session Rewind). */
var flowStepNextHooks = {};
function registerFlowStepNextHook(stepSlug, fn) {
    flowStepNextHooks[stepSlug] = fn;
}
function unregisterFlowStepNextHook(stepSlug) {
    delete flowStepNextHooks[stepSlug];
}
function invokeFlowStepNextHook(stepSlug) {
    var _a;
    (_a = flowStepNextHooks[stepSlug]) === null || _a === void 0 ? void 0 : _a.call(flowStepNextHooks);
}
var getFlowPathData = function () { return flowPathDataStore; };
var getFlowTelemetry = function () { return flowTelemetryStore; };
var setPetsyTracker = function (petsyTracker) {
    tracker = petsyTracker;
};
var getPetsyTracker = function () { return tracker; };
var getFlowConfig = function () { return flowConfigStore; };
var setFlowConfig = function (config) {
    flowConfigStore = config;
};
var getFlowHelpTips = function () { return flowHelpTipsStore; };
var setFlowHelpTips = function (tips) {
    flowHelpTipsStore = tips;
};
function useFlowData() {
    // Using context instead of useFlowController() to avoid circular dependency
    var flowContext = React__default.useContext(FlowContext);
    var location = useLocation();
    trackEventRouterLocation = {
        pathname: location.pathname,
        search: location.search,
    };
    // Lưu giá trị hiện tại của activeStep vào biến static mỗi khi context thay đổi
    React__default.useEffect(function () {
        if (flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep) {
            currentActiveStepValue = flowContext.activeStep;
            // console.log("[Debug] useFlowData updating currentActiveStepValue to:", currentActiveStepValue.slug);
        }
    }, [flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep]);
    function setActiveStepIsValid(value) {
        // Sử dụng location.pathname để xác định step hiện tại
        var pathSegment = location.pathname.split("/")[1];
        var flowConfig = getFlowConfig();
        var currentStep = flowConfig.find(function (step) { return step.slug === pathSegment; });
        // Luôn sử dụng functional update để đảm bảo có state mới nhất
        flowContext === null || flowContext === void 0 ? void 0 : flowContext.setActiveStep(function (prevStep) {
            // Nếu có currentStep từ URL, sử dụng nó, nếu không thì dùng prevStep
            var baseStep = currentStep || prevStep;
            var result = __assign(__assign({}, baseStep), { isValid: value });
            // Cập nhật biến static
            currentActiveStepValue = result;
            return result;
        });
    }
    function getCurrentUrlKey() {
        var _a;
        return (_a = location.pathname.split("/")[2]) !== null && _a !== void 0 ? _a : "";
    }
    function getData(dataField) {
        var _a, _b;
        if (!dataField)
            return "";
        // Sử dụng location.pathname để xác định step hiện tại thay vì dựa vào activeStep
        // Điều này tránh được vấn đề timing với React 18 batching
        var pathSegment = location.pathname.split("/")[1];
        var flowConfig = getFlowConfig();
        // Fix sentry error undefined flowConfig
        if (!Array.isArray(flowConfig)) {
            console.error("flowConfig is not ready", flowConfig);
            return "";
        }
        var currentStep = flowConfig.find(function (step) { return step.slug === pathSegment; });
        // Fallback về các giá trị khác nếu không tìm thấy step từ URL
        var globalActiveStep = window.__CURRENT_ACTIVE_STEP__;
        var actualActiveStep = currentStep ||
            globalActiveStep ||
            currentActiveStepValue ||
            (flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep);
        var field = dataField;
        // if dataField starts with '.root' get the root object, not the key
        var isRoot = dataField.substring(0, 5) === "root.";
        if (isRoot)
            field = dataField.substring(5);
        var validSubStep = actualActiveStep &&
            actualActiveStep.isSubStep &&
            actualActiveStep.subStepDataObject &&
            actualActiveStep.subStepDataObjectKeyName;
        if (validSubStep && !isRoot) {
            // Sub step
            field = getSubStepDataPath((_a = actualActiveStep.subStepDataObject) !== null && _a !== void 0 ? _a : "", (_b = actualActiveStep.subStepDataObjectKeyName) !== null && _b !== void 0 ? _b : "", getCurrentUrlKey(), dataField);
        }
        // Normal step
        return lodashUtils.get(flowPathDataStore, field);
    }
    function setData(dataField, data) {
        var _a, _b, _c, _d;
        if (!dataField)
            return;
        // Sử dụng location.pathname để xác định step hiện tại thay vì dựa vào activeStep
        // Điều này tránh được vấn đề timing với React 18 batching
        var pathSegment = location.pathname.split("/")[1];
        var flowConfig = getFlowConfig();
        var currentStep = flowConfig.find(function (step) { return step.slug === pathSegment; });
        // Fallback về activeStep nếu không tìm thấy step từ URL
        var currentActiveStep = currentStep || (flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep);
        var field = dataField;
        // if dataField starts with '.root' path starts from the get the root object
        var isRoot = dataField.substring(0, 5) === "root.";
        var isSettedPath = dataField.substring(0, 5) === "pets[";
        if (isRoot)
            field = dataField.substring(5);
        var dataPath = field;
        var validSubStep = currentActiveStep &&
            currentActiveStep.isSubStep &&
            currentActiveStep.subStepDataObject &&
            currentActiveStep.subStepDataObjectKeyName;
        if (validSubStep && !isRoot && !isSettedPath) {
            // Sub step
            dataPath = getSubStepDataPath((_a = currentActiveStep === null || currentActiveStep === void 0 ? void 0 : currentActiveStep.subStepDataObject) !== null && _a !== void 0 ? _a : "", (_b = currentActiveStep === null || currentActiveStep === void 0 ? void 0 : currentActiveStep.subStepDataObjectKeyName) !== null && _b !== void 0 ? _b : "", getCurrentUrlKey(), dataField);
        }
        // Normal step
        // console.warn("Hung coupon setData", flowPathDataStore, dataPath, data);
        lodashUtils.set(flowPathDataStore, dataPath, data);
        if (dataField !== "updatePetData") {
            setActiveStepIsValid(isStepValid((_c = currentActiveStep === null || currentActiveStep === void 0 ? void 0 : currentActiveStep.slug) !== null && _c !== void 0 ? _c : "", getCurrentUrlKey()) >= 0);
        }
        notifyDataChange(dataPath, field, data);
        // console.log("dataField", dataField);
        if (["breed", "name", "petDOB", "petSex", "isDesexed", "startDate"].includes(dataField)) {
            setFlowDataDirect("isSavedQuote", false);
            setFlowDataDirect("isChangedData", true);
        }
        logDataChange((_d = currentActiveStep === null || currentActiveStep === void 0 ? void 0 : currentActiveStep.slug) !== null && _d !== void 0 ? _d : "", DataAction.SetData);
    }
    function injectData(input, dataObject, keyName, key) {
        if (!dataObject || !keyName || !key) {
            // Inject based on the activeStep
            return injectFlowDataIntoString(input, function (field) {
                return getData(field);
            });
        }
        else {
            // Inject from an element in an array in the root
            return injectFlowDataIntoString(input, function (field) {
                return getDataFromArray(dataObject, keyName, key, field);
            });
        }
    }
    return {
        getData: getData,
        setData: setData,
        injectData: injectData,
        getDataFromArray: getDataFromArray,
    };
}
function injectFlowDataIntoString(input, getData) {
    if (input.indexOf("{") >= 0) {
        var fieldNames = lodashUtils.words(input, /{(.*?)}/g);
        var result_1 = input;
        fieldNames.forEach(function (element) {
            var _a;
            var formatSplit = element.slice(1, -1).split("|");
            if (formatSplit.length === 2) {
                // Has formatting rule
                var fieldName = formatSplit[0];
                var format = formatSplit[1];
                result_1 = result_1.replace(element, formatString(getData(fieldName), format));
            }
            else {
                // No formatting rule
                result_1 = result_1.replace(element, (_a = getData(element.slice(1, -1))) !== null && _a !== void 0 ? _a : "");
            }
        });
        return result_1;
    }
    else {
        return input;
    }
}
function getStepDataPath(step, dataField, dataKey) {
    var stepDataPath = "";
    if (step.isSubStep) {
        if (!(step === null || step === void 0 ? void 0 : step.subStepDataObject) || !(step === null || step === void 0 ? void 0 : step.subStepDataObjectKeyName) || !dataKey)
            return "";
        stepDataPath = getSubStepDataPath(step.subStepDataObject, step.subStepDataObjectKeyName, dataKey, dataField);
    }
    else {
        stepDataPath = dataField;
    }
    return stepDataPath;
}
function getSubStepDataPath(arrayDataField, arrayKeyField, arrayKey, dataField) {
    var flowDataStore = getFlowPathData();
    var index = lodashUtils.findIndex(lodashUtils.get(flowDataStore, arrayDataField), function (element) {
        return element[arrayKeyField] === arrayKey;
    });
    if (dataField)
        return arrayDataField + "[" + index + "]." + dataField;
    else
        return arrayDataField + "[" + index + "]";
}
function getDataFromArray(arrayDataField, arrayKeyField, arrayKey, dataField) {
    var flowDataStore = getFlowPathData();
    if (dataField) {
        return lodashUtils.get(flowDataStore, getSubStepDataPath(arrayDataField, arrayKeyField, arrayKey, dataField));
    }
    else {
        return lodashUtils.get(flowDataStore, getSubStepDataPath(arrayDataField, arrayKeyField, arrayKey));
    }
}
function getFlowDataDirect(dataPath) {
    return lodashUtils.get(flowPathDataStore, dataPath);
}
function setFlowDataDirect(dataPath, data) {
    if (dataPath === "") {
        flowPathDataStore = data;
        return data;
    }
    else {
        return lodashUtils.set(flowPathDataStore, dataPath, data);
    }
}
// === Validation =============================================================
// Check if a step is valid according to the rules in the flowConfig.
// Returns: -1 = not valid | 0 = no validation required | 1 = valid
function isStepValid(stepSlug, dataKey) {
    var flowConfig = getFlowConfig();
    var flowDataStore = getFlowPathData();
    // Load validation rules for the step
    var step = flowConfig.find(function (element) { return element.slug === stepSlug; });
    if (!step)
        return 0;
    if (step.isSubStep) {
        if (!(step === null || step === void 0 ? void 0 : step.subStepDataObject) || !(step === null || step === void 0 ? void 0 : step.subStepDataObjectKeyName))
            return 0;
    }
    var validationRules = step.validationRules;
    if (!validationRules)
        return 0;
    for (var _i = 0, validationRules_1 = validationRules; _i < validationRules_1.length; _i++) {
        var rule = validationRules_1[_i];
        // Check if field exists for each validation rule in flowDataStore
        if (!lodashUtils.has(flowDataStore, getStepDataPath(step, rule.dataField, dataKey)) &&
            rule.isRequired) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' not found in flowDataStore and is required."));
            return -1;
        }
        var data = lodashUtils.get(flowDataStore, getStepDataPath(step, rule.dataField, dataKey));
        // Check if field is the correct type each rule is expecting
        var dataType = typeof data;
        var ruleType = "";
        switch (rule.type) {
            case "number":
                ruleType = "number";
                break;
            case "string":
                ruleType = "string";
                break;
            case "date":
                ruleType = "string";
                break;
            case "every":
                ruleType = "object";
                break;
            case "boolean":
                ruleType = "boolean";
                break;
            case "email":
                ruleType = "email";
                break;
        }
        //console.log('isStepValid dataType, ruleType, data = ' + dataType + ", " + ruleType + ", " + data);
        if (dataType !== ruleType && ruleType !== "email") {
            console.log("Validation fail: Field '".concat(rule.dataField, "' is the wrong type. ") +
                "Expected type: ".concat(rule.type, ", actual type ").concat(dataType, "."));
            return -1;
        }
        // String: Check is field has a value
        if (dataType === "string" && !data) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' does not ") + "have a value");
            return -1;
        }
        // String: Check is field meets minLengh requiements
        if (dataType === "string" &&
            rule.minLength &&
            data.length < rule.minLength) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' does not ") +
                "have a minLength of ".concat(rule.minLength));
            return -1;
        }
        // Number: Check is field meets min max requiements
        // Min
        if (dataType === "number" && rule.minValue && data < rule.minValue) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' is less than ") +
                "the minValue of ".concat(rule.minValue));
            return -1;
        }
        // Max
        if (dataType === "number" && rule.maxValue && data > rule.maxValue) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' is more than ") +
                "the maxValue of ".concat(rule.maxValue));
            return -1;
        }
        // Every: Check if the values in an array of objects meet the given condition
        if (rule.type === "every" && dataType === "object") {
            if (!lodashUtils.every(data, rule.condition)) {
                console.log("Validation fail: Every condition failed for field '".concat(rule.dataField, "'"));
                return -1;
            }
        }
        // Boolean - designed for TickBox
        if (dataType === "boolean" && data !== true) {
            console.log("Validation fail: Field '".concat(rule.dataField, "' is false "));
            return -1;
        }
        // Email
        if (rule.type === "email" && dataType === "string") {
            var re = new RegExp(emailValidationPattern);
            if (!re.test(data)) {
                console.log("Validation fail: Field '".concat(rule.dataField, "' is not a valid email ") +
                    "address '".concat(data, "'"));
                return -1;
            }
        }
    }
    return 1;
}
// === Flow Cache =============================================================
function getFlowCache(dataPath) {
    if (dataPath)
        return lodashUtils.get(flowCacheStore, dataPath);
    else
        return flowCacheStore;
}
// === Console Logging ================================================================
var DataAction;
(function (DataAction) {
    DataAction["GetData"] = "getData()";
    DataAction["SetData"] = "setData()";
})(DataAction || (DataAction = {}));
// Function to log colour coded FlowController messages to the console
function logDataChange(stepSlug, action, dataField, data) {
    switch (action) {
        case DataAction.GetData:
            break;
        case DataAction.SetData:
            break;
    }
    // console.log(
    //   `%cStore :>> %c${stepSlug} %c${action} %c${dataFieldMessage} `,
    //   'color: yellow',
    //   'color: deepskyblue',
    //   'color: ' + messageColor,
    //   dataFieldMessage ? 'color: orange' : '',
    //   data
    // );
}
function getAFXProfile$1() {
    var a = "afx_profile";
    a =
        decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
            encodeURIComponent(a).replace(/[\-\.\+\*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    return a ? ((a = JSON.parse(a)), a.acid) : "";
}
function convertPhoneNumber(phoneNumber) {
    if (!phoneNumber) {
        return "";
    }
    // Kiểm tra nếu số điện thoại đã bắt đầu bằng +61 thì không cần chuyển
    if (phoneNumber.startsWith("+61")) {
        return phoneNumber;
    }
    // Nếu số điện thoại bắt đầu bằng 0, thay thế 0 bằng +61
    if (phoneNumber.startsWith("0")) {
        return "+61" + phoneNumber.slice(1);
    }
    // Trường hợp không có 0 ở đầu mà cũng không phải +61 thì trả về số đã cho
    return phoneNumber;
}
// function buildPurchasedData() {
//   let returnData: any[] = [];
//   let pets = getFlowDataDirect("pets");
//   let landingPage = getFlowDataDirect("landingPage");
//   pets.forEach((pet: any) => {
//     // console.log("PPP-155-buildPurchasedData", pet);
//     let { customCover } = pet;
//     let { paymentFrequency, premiums, promoCode } = customCover;
//     returnData.push({
//       email: flowPathDataStore.holderEmail ?? "",
//       Session_id: flowPathDataStore.sessionId,
//       "Post Code 1": flowPathDataStore.holderAddress
//         ? flowPathDataStore.holderAddress.postcode
//         : "",
//       "Instalment 1": premiums ? premiums.installment : "",
//       "Pet species 1": pet ? pet.petType : "",
//       "Pet DOB 1": pet ? pet.petDOB : "",
//       "Promo Code 1": promoCode ? promoCode : "",
//       "Pet Gender 1": pet ? pet.petSex : "",
//       // "Annual Premium 1": premiums ? premiums.installment : "",
//       "Start Date": pet ? pet.startDate : "",
//       "Age 1": (pet.petAgeOnStartDatePolicy / 365).toFixed(2),
//       Frequency1: paymentFrequency,
//       "Pet Name 1": pet ? pet.name : "",
//       "Quote Source 1": "ctm-petsy",
//       "Pet Breed 1": pet ? pet.breed : "",
//       "Dental Wait": "Not covered",
//       $value_currency: "AUD",
//       $value: premiums ? (premiums.totalPayable / 12).toFixed(2) : "",
//       channel: "PetsyQT",
//       Adfixus_ID: getAFXProfile(),
//       landingPage,
//     });
//   });
//   return returnData;
// }
function buildPurchasedData() {
    var _a;
    var pets = getFlowDataDirect("pets") || [];
    var landingPage = getFlowDataDirect("landingPage");
    var data = {
        email: (_a = flowPathDataStore.holderEmail) !== null && _a !== void 0 ? _a : "",
        Session_id: flowPathDataStore.sessionId,
        $value_currency: "AUD",
        channel: "PetsyQT",
        Adfixus_ID: getAFXProfile$1(),
        landingPage: landingPage,
    };
    pets.forEach(function (pet, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var petIndex = index + 1;
        var customCover = (pet || {}).customCover;
        var _k = customCover || {}, paymentFrequency = _k.paymentFrequency, premiums = _k.premiums, promoCode = _k.promoCode;
        data["Post Code ".concat(petIndex)] =
            (_b = (_a = flowPathDataStore.holderAddress) === null || _a === void 0 ? void 0 : _a.postcode) !== null && _b !== void 0 ? _b : "";
        data["Instalment ".concat(petIndex)] = (_c = premiums === null || premiums === void 0 ? void 0 : premiums.installment) !== null && _c !== void 0 ? _c : "";
        data["Pet species ".concat(petIndex)] = (_d = pet === null || pet === void 0 ? void 0 : pet.petType) !== null && _d !== void 0 ? _d : "";
        data["Pet DOB ".concat(petIndex)] = (_e = pet === null || pet === void 0 ? void 0 : pet.petDOB) !== null && _e !== void 0 ? _e : "";
        data["Promo Code ".concat(petIndex)] = promoCode !== null && promoCode !== void 0 ? promoCode : "";
        data["Pet Gender ".concat(petIndex)] = (_f = pet === null || pet === void 0 ? void 0 : pet.petSex) !== null && _f !== void 0 ? _f : "";
        data["Pet Name ".concat(petIndex)] = (_g = pet === null || pet === void 0 ? void 0 : pet.name) !== null && _g !== void 0 ? _g : "";
        data["Pet Breed ".concat(petIndex)] = (_h = pet === null || pet === void 0 ? void 0 : pet.breed) !== null && _h !== void 0 ? _h : "";
        data["Frequency ".concat(petIndex)] = paymentFrequency !== null && paymentFrequency !== void 0 ? paymentFrequency : "";
        data["Quote Source ".concat(petIndex)] = "ctm-petsy";
        data["Start Date ".concat(petIndex)] = (_j = pet === null || pet === void 0 ? void 0 : pet.startDate) !== null && _j !== void 0 ? _j : "";
        data["Age ".concat(petIndex)] = (pet === null || pet === void 0 ? void 0 : pet.petAgeOnStartDatePolicy)
            ? (pet.petAgeOnStartDatePolicy / 365).toFixed(2)
            : "";
        data["$value_".concat(petIndex)] = premiums
            ? (premiums.totalPayable / 12).toFixed(2)
            : "";
        data["Dental Wait ".concat(petIndex)] = "Not covered";
    });
    return [data];
}
function updateQuoteNumberToPets(quoteNumbers) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var quoteNumber, adfixusID, parentQuoteNumber, pets;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!quoteNumbers || !quoteNumbers.success) {
                        return [2 /*return*/];
                    }
                    quoteNumber = (_b = (_a = quoteNumbers.data) === null || _a === void 0 ? void 0 : _a.quoteNumber) !== null && _b !== void 0 ? _b : "";
                    adfixusID = getAFXProfile$1();
                    if (quoteNumbers &&
                        quoteNumbers.success &&
                        adfixusID &&
                        adfixusID !== "(not set)" &&
                        localStorage) {
                        try {
                            localStorage.setItem(adfixusID, JSON.stringify({ addedAt: new Date().getTime(), quoteNumber: quoteNumber }));
                        }
                        catch (e) {
                            // Có thể log lỗi hoặc xử lý fallback ở đây
                            console.error("ERROR: Save quote to localStorage:", e);
                        }
                    }
                    return [4 /*yield*/, getFlowDataDirect("parentQuoteNumber")];
                case 1:
                    parentQuoteNumber = _c.sent();
                    if (!!parentQuoteNumber) return [3 /*break*/, 3];
                    return [4 /*yield*/, setFlowDataDirect("parentQuoteNumber", quoteNumber)];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3: return [4 /*yield*/, setFlowDataDirect("quoteNumber", quoteNumber)];
                case 4:
                    _c.sent();
                    return [4 /*yield*/, getFlowDataDirect("pets")];
                case 5:
                    pets = _c.sent();
                    pets.forEach(function (pet) {
                        if (pet.customCover) {
                            pet.customCover.quoteNumber = quoteNumber;
                            if (!parentQuoteNumber) {
                                pet.customCover.parentQuoteNumber = quoteNumber;
                            }
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function handleSendKlaviyoEvents(eventName, pets) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var eventData, addHolderData, setTraskerProfile, sessionId, quoteNumber, parentQuoteNumber, landingPage, currentPath, petId, regexID, petSelected, adfixusID, dogsNumber, pet, cleanedAlternateQuotes;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    eventData = {};
                    addHolderData = function () {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                        return ({
                            Holder_Email: (_a = flowPathDataStore.holderEmail) !== null && _a !== void 0 ? _a : "",
                            Holder_First_Name: (_b = flowPathDataStore.holderFirstName) !== null && _b !== void 0 ? _b : "",
                            Holder_Last_Name: (_c = flowPathDataStore.holderLastName) !== null && _c !== void 0 ? _c : "",
                            Holder_DOB: (_d = flowPathDataStore.holderDOB) !== null && _d !== void 0 ? _d : "",
                            Holder_Phone: convertPhoneNumber(flowPathDataStore.holderPhone),
                            Holder_Post_Code: (_f = (_e = flowPathDataStore.holderAddress) === null || _e === void 0 ? void 0 : _e.postcode) !== null && _f !== void 0 ? _f : "",
                            Holder_State: (_h = (_g = flowPathDataStore.holderAddress) === null || _g === void 0 ? void 0 : _g.state) !== null && _h !== void 0 ? _h : "",
                            Holder_Suburb: (_k = (_j = flowPathDataStore.holderAddress) === null || _j === void 0 ? void 0 : _j.suburb) !== null && _k !== void 0 ? _k : "",
                            Holder_Address_Line_1: (_m = (_l = flowPathDataStore.holderAddress) === null || _l === void 0 ? void 0 : _l.line1) !== null && _m !== void 0 ? _m : "",
                            Holder_Address_Line_2: (_p = (_o = flowPathDataStore.holderAddress) === null || _o === void 0 ? void 0 : _o.line2) !== null && _p !== void 0 ? _p : "",
                            Session_id: flowPathDataStore.sessionId,
                            Holder_Costco_Member_Number: (_q = flowPathDataStore.costcoMemberNumber) !== null && _q !== void 0 ? _q : "",
                            channel: "PetsyQT",
                        });
                    };
                    setTraskerProfile = function (adfixusIDValue) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                        var profile = tracker.getProfile();
                        if (!profile.email && flowPathDataStore.holderEmail) {
                            tracker.updateProfile({
                                email: (_a = flowPathDataStore.holderEmail) !== null && _a !== void 0 ? _a : "",
                                firstName: (_b = flowPathDataStore.holderFirstName) !== null && _b !== void 0 ? _b : "",
                                lastName: (_c = flowPathDataStore.holderLastName) !== null && _c !== void 0 ? _c : "",
                                phoneNumber: convertPhoneNumber(flowPathDataStore.holderPhone),
                                postcode: (_e = (_d = flowPathDataStore.holderAddress) === null || _d === void 0 ? void 0 : _d.postcode) !== null && _e !== void 0 ? _e : "",
                                state: (_g = (_f = flowPathDataStore.holderAddress) === null || _f === void 0 ? void 0 : _f.state) !== null && _g !== void 0 ? _g : "",
                                suburb: (_j = (_h = flowPathDataStore.holderAddress) === null || _h === void 0 ? void 0 : _h.suburb) !== null && _j !== void 0 ? _j : "",
                                address1: (_l = (_k = flowPathDataStore.holderAddress) === null || _k === void 0 ? void 0 : _k.line1) !== null && _l !== void 0 ? _l : "",
                                address2: (_o = (_m = flowPathDataStore.holderAddress) === null || _m === void 0 ? void 0 : _m.line2) !== null && _o !== void 0 ? _o : "",
                                adfixusID: adfixusIDValue,
                            });
                        }
                    };
                    sessionId = flowPathDataStore.sessionId;
                    return [4 /*yield*/, getFlowDataDirect("petsyQuoteNumber")];
                case 1:
                    quoteNumber = _d.sent();
                    return [4 /*yield*/, getFlowDataDirect("parentQuoteNumber")];
                case 2:
                    parentQuoteNumber = _d.sent();
                    return [4 /*yield*/, getFlowDataDirect("landingPage")];
                case 3:
                    landingPage = _d.sent();
                    currentPath = window.location.pathname;
                    petId = currentPath.split("/").pop();
                    regexID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                    if (petId && !regexID.test(petId)) {
                        petId = "";
                    }
                    adfixusID = getAFXProfile$1();
                    if (adfixusID === "(not set)") {
                        adfixusID = "";
                    }
                    switch (eventName) {
                        case "Clicked_Get_Started":
                            setTraskerProfile(adfixusID);
                            tracker.updateJourney({
                                landingUrl: landingPage,
                                sessionId: sessionId,
                            });
                            dogsNumber = flowPathDataStore.PetTypesChosen.filter(function (el) { return el === "dog"; });
                            eventData = __assign(__assign({}, addHolderData()), { "Number Of Cats": flowPathDataStore.PetTypesChosen.length - dogsNumber.length, "Number Of Dogs": dogsNumber.length, Adfixus_ID: adfixusID, channel: "PetsyQT", landingPage: landingPage });
                            break;
                        case "Provided_Name_breed":
                            if (!pets)
                                return [2 /*return*/];
                            petSelected = pets.find(function (pet) { return pet.id === petId; });
                            if (petSelected) {
                                eventData = {
                                    id: petId,
                                    petName: petSelected ? petSelected.name : "",
                                    petBreed: petSelected ? petSelected.breed : "",
                                    Session_id: sessionId,
                                    channel: "PetsyQT",
                                    Adfixus_ID: adfixusID,
                                    landingPage: landingPage,
                                };
                            }
                            break;
                        case "Provided_dob_sex":
                            if (!pets)
                                return [2 /*return*/];
                            petSelected = pets.find(function (pet) { return pet.id === petId; });
                            if (petSelected) {
                                eventData = {
                                    id: petId,
                                    petDOB: petSelected ? petSelected.petDOB : "",
                                    petSex: petSelected ? petSelected.petSex : "",
                                    isDesexed: petSelected ? petSelected.isDesexed : "",
                                    Session_id: sessionId,
                                    channel: "PetsyQT",
                                    Adfixus_ID: adfixusID,
                                    landingPage: landingPage,
                                };
                            }
                            break;
                        case "Provided_Policy_date":
                            if (!pets)
                                return [2 /*return*/];
                            petSelected = pets.find(function (pet) { return pet.id === petId; });
                            if (petSelected) {
                                eventData = {
                                    id: petId,
                                    startDate: petSelected ? petSelected.startDate : "",
                                    Session_id: sessionId,
                                    channel: "PetsyQT",
                                    Adfixus_ID: adfixusID,
                                    landingPage: landingPage,
                                };
                            }
                            break;
                        case "Custom_Cover_Details":
                            if (!pets)
                                return [2 /*return*/];
                            setTraskerProfile(adfixusID);
                            pet = pets.find(function (pet) { return pet.customCover && pet.id === petId; });
                            if (pet && pet.customCover && !pet.customCover.promoCode) {
                                delete pet.customCover.promo;
                                delete pet.customCover.promoCode;
                            }
                            cleanedAlternateQuotes = null;
                            if (pet === null || pet === void 0 ? void 0 : pet.alternateQuotes) {
                                cleanedAlternateQuotes = __assign({}, pet.alternateQuotes);
                                delete cleanedAlternateQuotes.quotes;
                            }
                            eventData = {
                                email: (_a = flowPathDataStore.holderEmail) !== null && _a !== void 0 ? _a : "",
                                Session_id: sessionId,
                                id: pet ? pet.id : "",
                                petType: pet ? pet.petType : "",
                                petTypeIndex: pet ? pet.petTypeIndex : "",
                                petOrdinalName: pet ? pet.petOrdinalName : "",
                                petShowedPopup: pet ? pet.isShowedPopup : "",
                                name: pet ? pet.name : "",
                                isValid: pet ? pet.isValid : "",
                                isTouched: pet ? pet.isTouched : "",
                                breed: pet ? pet.breed : "",
                                petDOB: pet ? pet.petDOB : "",
                                petAgeOnStartDatePolicy: pet ? pet.petAgeOnStartDatePolicy : "",
                                petSex: pet ? pet.petSex : "",
                                isDesexed: pet ? pet.isDesexed : "",
                                startDate: pet ? pet.startDate : "",
                                customCover: pet ? pet.customCover : "",
                                alternateQuotes: cleanedAlternateQuotes,
                                coverType: pet ? pet.coverType : "",
                                petAgeCategory: pet ? pet.petAgeCategory : "0",
                                quoteNumber: pet ? pet.customCover.quoteNumber : null,
                                parentQuoteNumber: parentQuoteNumber !== null && parentQuoteNumber !== void 0 ? parentQuoteNumber : null,
                                channel: "PetsyQT",
                                Adfixus_ID: adfixusID,
                                landingPage: landingPage,
                            };
                            break;
                        case "Customer_Full_Details":
                            eventData = {
                                Session_id: sessionId,
                                quoteNumber: quoteNumber,
                                channel: "PetsyQT",
                                Adfixus_ID: adfixusID,
                                landingPage: landingPage,
                            };
                            if (parentQuoteNumber) {
                                eventData["parentQuoteNumber"] = parentQuoteNumber;
                            }
                            break;
                        case "PURCHASED":
                        case "Step_5":
                            eventData = buildPurchasedData();
                            break;
                        case "Retrieve_Saved_Details_Quote":
                            eventData = {
                                email: pets ? pets[0].email : "",
                                channel: "PetsyQT",
                            };
                            break;
                        case "Policy_Purchase_Success":
                            eventData = {
                                email: flowPathDataStore.holderEmail,
                                channel: "PetsyQT",
                                holderDOB: (_b = flowPathDataStore.holderDOB) !== null && _b !== void 0 ? _b : "",
                                sendQuoteAgreeToBeContacted: flowPathDataStore.sendQuoteAgreeToBeContacted,
                                AdfixusDeviceID: adfixusID,
                                fdclid: (_c = flowPathDataStore.fdclid) !== null && _c !== void 0 ? _c : "",
                            };
                            break;
                        case "Initial_Page":
                            tracker.updateJourney({
                                landingUrl: landingPage,
                                sessionId: sessionId,
                            });
                            // eventData.quoteData.push({
                            //   Session_id: sessionId,
                            //   channel: "PetsyQT",
                            //   Adfixus_ID: adfixusID,
                            //   landingPage: pets ? pets[0].url : ""
                            // });
                            break;
                    }
                    tracker.trackEvent(eventName, eventData, trackEventRouterLocation);
                    // return dataReturn
                    return [2 /*return*/, null];
            }
        });
    });
}

var recaptcha;
function setRecaptcha(recaptchaRef) {
    recaptcha = recaptchaRef;
}
var getRecaptcha = function () { return recaptcha; };
function getRecaptchaToken() {
    return __awaiter(this, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(recaptcha.current && recaptcha.current.callbacks)) return [3 /*break*/, 2];
                    return [4 /*yield*/, recaptcha.current.callbacks
                            //@ts-ignore
                            .execute('reCAPTCHA_site_key', { action: 'submit' })];
                case 1:
                    token = _a.sent();
                    return [2 /*return*/, token];
                case 2: return [2 /*return*/, undefined];
            }
        });
    });
}

function useFlowController() {
    var navigate = useNavigate();
    var location = useLocation();
    var flowContext = React__default.useContext(FlowContext);
    var flowConfig = getFlowConfig();
    var flowDataStore = getFlowPathData();
    React__default.useEffect(function () {
        var _a, _b;
        if (!flowConfig || !flowContext) {
            // console.log("[Debug] FlowController useEffect - Missing flowConfig or flowContext");
            return;
        }
        var pathSegment = location.pathname.split("/")[1];
        // console.log("[Debug] FlowController useEffect - Current path segment:", pathSegment);
        var step = flowConfig.find(function (step) { return step.slug === pathSegment; });
        if (!step) {
            // console.log("[Debug] FlowController useEffect - No matching step found for:", pathSegment);
            return;
        }
        var isValid = isStepValid((_a = step === null || step === void 0 ? void 0 : step.slug) !== null && _a !== void 0 ? _a : "", getCurrentUrlKey()) >= 0;
        var newActiveStep = __assign(__assign({}, step), { isValid: isValid });
        var currentStepSlug = (_b = flowContext.activeStep) === null || _b === void 0 ? void 0 : _b.slug;
        // console.log("[Debug] FlowController useEffect - Current:", currentStepSlug, "New:", newActiveStep.slug);
        // Chỉ cập nhật khi slug khác nhau hoặc activeStep chưa được khởi tạo
        if (!flowContext.activeStep || currentStepSlug !== step.slug) {
            // console.log("[Debug] FlowController - Updating activeStep to:", step.slug);
            // Cập nhật biến global trực tiếp
            window.__CURRENT_ACTIVE_STEP__ = newActiveStep;
            // console.log("[Debug] FlowController - Updated global __CURRENT_ACTIVE_STEP__ to:", newActiveStep.slug);
            // Sử dụng React 18 batching có chủ đích
            flowContext.setActiveStep(newActiveStep);
            // Xóa gọi forceUpdate để tránh vòng lặp vô hạn
            // flowContext.forceUpdate();
            // Check lại sau 100ms để đảm bảo state đã được cập nhật đúng
            // setTimeout(() => {
            //   console.log("[Debug] FlowController setTimeout - Current activeStep now:",
            //     flowContext?.activeStep?.slug,
            //     "Expected:", step?.slug,
            //     "Global:", (window as any).__CURRENT_ACTIVE_STEP__?.slug);
            // }, 100);
        }
        else {
            console.log("[Debug] FlowController - No update needed, already at step:", step === null || step === void 0 ? void 0 : step.slug);
        }
    }, [location.pathname, flowConfig, flowContext]);
    function getCurrentUrlKey() {
        var _a;
        return (_a = location.pathname.split("/")[2]) !== null && _a !== void 0 ? _a : "";
    }
    function getStepUrl(stepSlug) {
        if (!flowConfig)
            return stepSlug;
        var step = flowConfig.find(function (element) { return element.slug === stepSlug.replace("/", ""); });
        var urlParam = "";
        if (step === null || step === void 0 ? void 0 : step.isSubStep) {
            urlParam = "/" + getCurrentUrlKey();
        }
        return stepSlug + urlParam;
    }
    // Get the index of the subStepDataObject in the flowDataStore
    // using the subStepDataObjectKeyName and getting the
    // subStepDataObjectKey from the url
    function getStepDataPath(step, dataField) {
        var _a;
        if (step.isSubStep && (step === null || step === void 0 ? void 0 : step.subStepDataObject)) {
            // Sub step
            var index = lodashUtils.findIndex(lodashUtils.get(flowDataStore, (_a = step.subStepDataObject) !== null && _a !== void 0 ? _a : ""), function (element) {
                var _a;
                return element[(_a = step.subStepDataObjectKeyName) !== null && _a !== void 0 ? _a : ""] === getCurrentUrlKey();
            });
            return (step === null || step === void 0 ? void 0 : step.subStepDataObject) + "[" + index + "]." + dataField;
        }
        else {
            // Normal step
            return dataField;
        }
    }
    // Checks if a nextStepRule existis for the current step and uses it if it does.
    // If it does not, it returns the value in nextStepSlug or ''.
    function getNextStepSlug(currentStep) {
        var _a;
        if (currentStep &&
            currentStep.nextStepRule &&
            currentStep.nextStepRule.dataField &&
            currentStep.nextStepRule.rules &&
            currentStep.nextStepRule.rules.length > 0) {
            var slug_1 = "";
            currentStep.nextStepRule.rules.forEach(function (rule) {
                var _a, _b;
                if (lodashUtils.get(flowDataStore, getStepDataPath(currentStep, (_b = (_a = currentStep.nextStepRule) === null || _a === void 0 ? void 0 : _a.dataField) !== null && _b !== void 0 ? _b : "")) === rule.value) {
                    slug_1 = rule.slug;
                }
            });
            return slug_1;
        }
        else {
            // Return the nextStepSlug
            return (_a = currentStep === null || currentStep === void 0 ? void 0 : currentStep.nextStepSlug) !== null && _a !== void 0 ? _a : "";
        }
    }
    function setActiveStepIsValid(value) {
        flowContext === null || flowContext === void 0 ? void 0 : flowContext.setActiveStep(__assign(__assign({}, flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep), { isValid: value }));
    }
    function setActiveStepShowValidations(value) {
        flowContext === null || flowContext === void 0 ? void 0 : flowContext.setActiveStep(__assign(__assign({}, flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep), { showValidations: value }));
    }
    function nextStep() {
        var _a, _b, _c;
        logFlowControllerAction((_b = (_a = flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : "", FlowAction.Next);
        console.log("flowContext.activeStep.slug: ", (_c = flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep) === null || _c === void 0 ? void 0 : _c.slug);
        navigate(getStepUrl(getNextStepSlug(flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep)));
    }
    function nextStepWithUrlParam(url) {
        logFlowControllerAction("", FlowAction.GotoStep, url);
        navigate(url);
    }
    function backStep() {
        var _a, _b;
        logFlowControllerAction((_b = (_a = flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : "", FlowAction.Back);
        navigate(-1);
    }
    function gotoStep(stepSlug, key) {
        var _a, _b;
        var appendToUrl = "";
        if (key)
            appendToUrl = "/" + key;
        logFlowControllerAction((_b = (_a = flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : "", FlowAction.GotoStep, stepSlug);
        if (stepSlug === "step-2" && !stepSlug.includes("/")) {
            stepSlug = "/" + stepSlug;
        }
        console.log("stepSlug: ", stepSlug);
        navigate(getStepUrl(stepSlug + appendToUrl));
    }
    return {
        activeStep: flowContext === null || flowContext === void 0 ? void 0 : flowContext.activeStep,
        setActiveStepIsValid: setActiveStepIsValid,
        setActiveStepShowValidations: setActiveStepShowValidations,
        nextStep: nextStep,
        nextStepWithUrlParam: nextStepWithUrlParam,
        backStep: backStep,
        gotoStep: gotoStep,
    };
}
// === Loging =================================================================
var FlowAction;
(function (FlowAction) {
    FlowAction["Next"] = "nextStep()";
    FlowAction["Back"] = "backStep()";
    FlowAction["GotoStep"] = "gotoStep()";
})(FlowAction || (FlowAction = {}));
function logFlowControllerAction(stepSlug, action, gotoSlug) {
    var messageColor = "";
    switch (action) {
        case FlowAction.Next:
            messageColor = "palegreen";
            break;
        case FlowAction.Back:
            messageColor = "cyan";
            break;
        case FlowAction.GotoStep:
            messageColor = "orange";
            break;
    }
    console.log("%cFlowController :>> %c".concat(stepSlug, " %c").concat(action, " %c").concat(gotoSlug !== null && gotoSlug !== void 0 ? gotoSlug : "", " "), "color: yellow", "color: deepskyblue", "color: " + messageColor, gotoSlug ? "color: orange" : "");
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$u = "body .flc_back-button {\n  position: fixed;\n  top: var(--flc_nav-height, 6rem);\n  width: 100%;\n  height: var(--flc_back-button-height, 3rem);\n  display: flex;\n  padding-left: 0.8em;\n  padding-right: 0.8em;\n  background-color: var(--flc_back-button-background-color);\n  font-size: 0.9rem;\n  top: 0.625rem;\n  background: unset;\n  color: var(--flc-white);\n  border: 2px solid;\n  width: 5.625rem;\n  left: 0.75rem;\n  height: 2.625rem;\n  border-radius: 0.25rem;\n}\nbody .flc_back-button .icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--flc_back-button-arrow-background-color);\n  width: 2em;\n  height: 2em;\n  border-radius: 100%;\n}\nbody .flc_back-button a {\n  text-decoration: none;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  color: var(--flc-white);\n  text-transform: uppercase;\n}\n@media (hover: hover) and (pointer: fine) {\n  body .flc_back-button a:hover {\n    text-decoration: none;\n    color: var(--flc_back-button-font-hover-color);\n  }\n  body .flc_back-button a:hover .icon {\n    color: var(--flc_back-button-arrow-color-hover);\n    background-color: var(--flc_back-button-arrow-background-color-hover);\n  }\n  body .flc_back-button a:hover svg {\n    filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(315deg) brightness(118%) contrast(119%);\n  }\n}\nbody .flc_back-button-flow-step-margin-top {\n  margin-top: var(--flc_back-button-height, 4.5rem);\n}\n@media (max-width: 576px) {\n  body .flc_back-button {\n    left: 0;\n    top: 0;\n    height: var(--flc_nav-height, 4rem);\n    border: none;\n    border-radius: 0;\n    border-right: 1px solid rgba(255, 255, 255, 0.1);\n    font-size: 0;\n    width: 60px;\n    justify-content: center;\n  }\n}";
styleInject(css_248z$u);

function BackButton(props) {
    var backStep = useFlowController().backStep;
    function onClick() {
        backStep();
    }
    return (React.createElement("div", { "data-testid": "BackButton", className: "flc_back-button" },
        React.createElement("a", { href: " ", onClick: function (e) {
                e.preventDefault();
                onClick();
            } },
            React.createElement("div", { className: "" },
                React.createElement("svg", { width: "10", height: "25", viewBox: "0 0 20 35", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M18 2L2.5 17.5L18 33", stroke: "white", strokeWidth: "3" }))),
            React.createElement("span", null,
                "\u00A0\u00A0",
                props.text))));
}

var css_248z$t = "body .flc_bread-crumbs {\n  top: var(--flc_nav-height, 6rem);\n  width: 100%;\n  height: 6rem;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  gap: 2em;\n  color: var(--flc_bread-crumbs-font-color);\n  background-color: var(--flc_bread-crumbs-background-color);\n  font-size: 0.9rem;\n  font-weight: bold;\n  margin-bottom: 2rem;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb {\n  width: 12rem;\n  display: flex;\n  justify-content: center;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb > div {\n  display: flex;\n  padding-right: 0.2rem;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb img {\n  width: 4rem;\n  height: 4rem;\n  margin-right: -0.3rem;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb .circle {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--flc_bread-crumbs-font-color);\n  width: 1.8em;\n  height: 1.8em;\n  border-radius: 50%;\n  color: var(--flc-white);\n  font-size: 0;\n  min-width: 28px;\n  min-height: 28px;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb .circle svg {\n  width: 15px;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb .name {\n  display: inline-flex;\n  color: var(--flc-petsy-primary-text);\n  margin-top: 0.3em;\n  font-weight: 300;\n  line-height: 30px;\n  font-size: 16px;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb.incomplete .circle {\n  opacity: 0.4;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb.incomplete img {\n  opacity: 0.4;\n}\nbody .flc_bread-crumbs .petsy-breadcrumb:nth-child(3) > div {\n  padding-right: 0.6rem;\n}\n@media (max-width: 576px) {\n  body .flc_bread-crumbs .petsy-breadcrumb div {\n    width: 100% !important;\n  }\n  body .flc_bread-crumbs .petsy-breadcrumb div .circle {\n    width: 20px !important;\n    height: 20px;\n    min-width: 20px;\n    min-height: 20px;\n    background-size: 12px;\n  }\n  body .flc_bread-crumbs .petsy-breadcrumb div .name {\n    width: auto !important;\n    font-size: 0.8rem;\n  }\n}";
styleInject(css_248z$t);

function Crumb(props) {
    return (React.createElement("div", { className: "petsy-breadcrumb " + props.state },
        React.createElement("div", null,
            React.createElement("div", { className: "circle" },
                React.createElement("svg", { width: "29", height: "22", viewBox: "0 0 29 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M1.8125 11.9995L9.05956 19.2466L27.1772 1.12891", stroke: "white", strokeWidth: "3" }))),
            React.createElement("div", { className: "name" }, props.name))));
}
function BreadCrumbs(props) {
    // console.log("BreadCrumbs", props);
    return (React.createElement("div", { "data-testid": "BreadCrumbs", className: "flc_bread-crumbs" }, props.breadCrumbConfig && props.breadCrumbConfig.map(function (crumb, index) {
        return (React.createElement(Crumb, { key: index, name: crumb.name, state: crumb.state, icon: crumb.icon, index: index + 1 }));
    })));
}

var css_248z$s = "body .flc_flow-nav {\n  position: sticky;\n  top: 0;\n  z-index: 900;\n}\nbody .flc_flow-nav .hotline {\n  color: var(--flc-white);\n  border: 2px solid;\n  width: 8rem;\n  height: 2.625rem;\n  border-radius: 0.25rem;\n  text-align: center;\n  display: flex;\n  position: fixed;\n  right: 0.75rem;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  top: 0.625rem;\n}\nbody .flc_flow-nav .hotline a {\n  color: white;\n  text-decoration: none;\n}\nbody .flc_flow-nav .item {\n  position: fixed;\n  right: 10.5rem;\n  top: 1rem;\n}\nbody .flc_flow-nav .item a {\n  color: white;\n}\nbody .flc_flow-nav .header {\n  display: flex;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  gap: 1rem;\n  align-items: center;\n  background-color: var(--flc_nav-bkgnd-color, gray);\n  border-bottom: var(--flc_nav-border-bottom, solid 1px black);\n  height: var(--flc_nav-height, 4rem);\n}\nbody .flc_flow-nav .header .logo {\n  width: 100%;\n  text-align: center;\n}\nbody .flc_flow-nav .header .logo a img {\n  height: 35px;\n}\nbody .flc_flow-nav .header .item a {\n  color: var(--flc_nav-link-color, yellow);\n  text-decoration: none;\n}\nbody .flc_flow-nav .header .item a:hover {\n  color: var(--flc_nav-link-hover-color, green);\n}\n@media (max-width: 576px) {\n  body .flc_flow-nav .item {\n    right: 5rem;\n  }\n  body .flc_flow-nav .header {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  body .flc_flow-nav .hotline {\n    top: 0;\n    right: 0;\n    height: var(--flc_nav-height, 4rem);\n    border: none;\n    border-radius: 0;\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n    font-size: 0;\n    width: 60px;\n    background: url(\"/images/phone.png\") no-repeat center center;\n  }\n  body .flc_flow-nav .hotline a {\n    width: 100%;\n    height: 100%;\n    display: block;\n  }\n}";
styleInject(css_248z$s);

function FlowNav(props) {
    var activeStep = useFlowController().activeStep;
    function navItemClick(itemKey) {
        if (props.onItemClick) {
            props.onItemClick(itemKey);
        }
    }
    var _a = React.useState(false), hideOnScroll = _a[0], setHideOnScroll = _a[1];
    useScrollPosition(function (_a) {
        var currPos = _a.currPos;
        var hide = currPos.y >= 100;
        if (hide !== hideOnScroll)
            setHideOnScroll(hide);
    }, [hideOnScroll], undefined, true, 150);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": "FlowNav", className: "flc_flow-nav" },
            React.createElement("div", { className: "header" }, props.logo !== undefined && (React.createElement("div", { className: "logo" },
                React.createElement(Link, { to: props.logoLink ? props.logoLink : "" },
                    React.createElement("img", { className: "", src: props.logo, alt: "Logo" }))))),
            React.createElement("div", null, props.navItems &&
                props.navItems.map(function (navItem, index) {
                    return (React.createElement("div", { key: "flow_nav_item" + index, className: "item" },
                        React.createElement("a", { href: "", onClick: function (e) {
                                e.preventDefault();
                                navItemClick(navItem.itemKey);
                            } }, navItem.name)));
                })),
            React.createElement("div", { className: "hotline" },
                React.createElement("a", { href: "tel:1300952790", "aria-label": "Call Petsy.com.au" },
                    React.createElement("span", null, "1300 952 790"))),
            React.createElement(AnimatePresence, null, (activeStep === null || activeStep === void 0 ? void 0 : activeStep.showBackButton) && (React.createElement(motion.div, { key: "back-button", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.4 } },
                React.createElement(BackButton, { text: "Back", stepSlug: activeStep.slug })))),
            React.createElement("div", null, (activeStep === null || activeStep === void 0 ? void 0 : activeStep.showBreadCrumbs) && (React.createElement("div", null,
                React.createElement(BreadCrumbs, { stepSlug: activeStep.slug, step: activeStep, breadCrumbConfig: activeStep.breadCrumbConfig })))))));
}

var css_248z$r = "body .flc_country-picker {\n  width: 100%;\n}\nbody .flc_country-picker .countries-picked {\n  text-align: center;\n}\nbody .flc_country-picker .badge {\n  font-size: 1.1em;\n  font-weight: 600;\n  margin: 0.3em;\n  color: #eb551d;\n  border: solid 1px #eb551d;\n}";
styleInject(css_248z$r);

function CountryPicker(props) {
    var _a = useState(props.data || ''), countriesText = _a[0], setCountriesText = _a[1];
    var setData = useFlowData().setData;
    function countriesChange(e) {
        var _a;
        setCountriesText(e.target.value);
        // Report the data change to the FlowController so it can be stored and generate relevent events
        setData((_a = props.dataField) !== null && _a !== void 0 ? _a : '', e.target.value);
    }
    return (React__default.createElement("div", { "data-testid": 'CountryPicker', className: 'flc_country-picker my-4' },
        React__default.createElement("div", { className: 'countries-picked mx-auto my-2' },
            React__default.createElement(Badge, { bg: 'light', pill: true }, "Canada"),
            React__default.createElement(Badge, { bg: 'light', pill: true }, "United States"),
            React__default.createElement(Badge, { bg: 'light', pill: true }, "Mexico"),
            React__default.createElement(Badge, { bg: 'light', pill: true }, "Cuba")),
        React__default.createElement("div", { className: 'lookup-control' },
            React__default.createElement(FloatingLabel, { controlId: 'floatingInputGrid', label: "COUNTRIES YOU'RE VISITING" },
                React__default.createElement(Form.Control, { type: 'text', autoComplete: 'off', placeholder: ' ', value: countriesText, onChange: countriesChange })))));
}

var css_248z$q = "body .flc_next-button {\n  min-width: 100%;\n  box-shadow: var(--flc_next-button-shadow, 0 0.5rem 1rem rgba(0, 128, 0, 0.25));\n  font-size: 1.875rem;\n  height: 5.1875rem;\n  font-family: var(--button-font-name);\n  border-radius: 4rem;\n}\nbody .flc_next-button:disabled {\n  box-shadow: none;\n  color: var(--flc_next-button-font-disabled-color);\n  background-color: var(--flc_next-button-disabled-color, gray);\n  border-color: var(--flc_next-button-disabled-color, gray);\n}\nbody .flc_next-button.disabled-hint {\n  display: block;\n  font-weight: normal;\n  font-size: 1.25rem;\n  color: var(--flc-petsy-text-primary);\n  font-family: var(--button-font-name);\n  text-transform: capitalize;\n  text-align: center;\n  padding-top: 1.5rem;\n}\nbody .flc_next-button.shake-button {\n  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  transform: translate3d(0, 0, 0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\nbody .btn-secondary {\n  box-shadow: none;\n  color: var(--flc_next-button-font-disabled-color);\n  background-color: var(--flc_next-button-disabled-color, gray);\n  border-color: var(--flc_next-button-disabled-color, gray);\n}\nbody .btn-secondary:hover {\n  background-color: var(--flc_next-button-disabled-color, gray);\n  border-color: var(--flc_next-button-disabled-color, gray);\n}\n@keyframes shake {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}";
styleInject(css_248z$q);

function NextButton(props) {
    var _a = useFlowController(); _a.activeStep; var setActiveStepShowValidations = _a.setActiveStepShowValidations, nextStep = _a.nextStep, nextStepWithUrlParam = _a.nextStepWithUrlParam;
    var _b = useFlowData(), setData = _b.setData, getData = _b.getData, injectData = _b.injectData;
    var _c = React.useState(false), shake = _c[0], setShake = _c[1];
    var _d = React.useState(0), renderKey = _d[0], setRenderKey = _d[1];
    // on the button click, if a clickNotification data field is set, set that dataField to true.
    // otherwise, move forward to the next step in the flow
    function onClick() {
        if (props.disabled) {
            setShake(true);
            setRenderKey(function (renderKey) { return renderKey + 1; });
            setActiveStepShowValidations(true);
            return;
        }
        var petId = getData("id");
        // console.log("PPP-155-petId", petId);
        // console.log("PPP-155-next button props", props);
        var klaviyoEvent = "";
        switch (props.stepSlug) {
            case "step-1":
                klaviyoEvent = "Clicked_Get_Started";
                break;
            case "edit-cover-1":
                klaviyoEvent = "Provided_Name_breed";
                break;
            case "edit-cover-2":
                klaviyoEvent = "Provided_dob_sex";
                break;
            case "edit-cover-3":
                klaviyoEvent = "Provided_Policy_date";
                break;
            case "step-3":
                klaviyoEvent = "Customer_Full_Details";
                break;
        }
        if (klaviyoEvent) {
            var pets = getFlowDataDirect("pets");
            var currentPets = pets && petId ? pets.filter(function (pet) { return pet.id === petId; }) : null;
            handleSendKlaviyoEvents(klaviyoEvent, currentPets);
        }
        if (props.clickNotification) {
            setData(props.clickNotification, true);
        }
        else {
            invokeFlowStepNextHook(props.stepSlug);
            if (getData("root.quote-slug") && !props.resetPrevSlug) {
                nextStepWithUrlParam(getData("root.quote-slug"));
            }
            else {
                setData("root.quote-slug", "");
                nextStep();
            }
        }
    }
    var label = props.label;
    var disabledLabel = props.disabledLabel;
    var enabledHint = props.enabledHint;
    var disabledHint = props.disabledHint;
    if (props.step) {
        if (label.includes("{")) {
            label = injectData(label);
        }
        if (enabledHint && enabledHint.includes("{")) {
            enabledHint = injectData(enabledHint);
        }
        if (disabledHint && disabledHint.includes("{")) {
            disabledHint = injectData(disabledHint);
        }
    }
    // const [state, setState] = React.useState({
    //   label: props.label,
    //   disabledLabel: props.disabledLabel,
    //   enabledHint: props.enabledHint,
    //   disabledHint: props.disabledHint,
    // });
    // React.useEffect(() => {
    //   if (props.step) {
    //     let tmpLabel = props.label;
    //     let tmpDisabledLabel = props.disabledLabel;
    //     let tmpEnabledHint = props.enabledHint;
    //     let tmpDisabledHint = props.disabledHint;
    //     if (tmpLabel.includes('{')) {
    //       tmpLabel = injectData(tmpLabel);
    //     }
    //     if (tmpDisabledLabel && tmpDisabledLabel.includes('{')) {
    //       tmpDisabledLabel = injectData(tmpDisabledLabel);
    //     }
    //     if (tmpEnabledHint && tmpEnabledHint.includes('{')) {
    //       tmpEnabledHint = injectData(tmpEnabledHint);
    //     }
    //     if (tmpDisabledHint && tmpDisabledHint.includes('{')) {
    //       tmpDisabledHint = injectData(tmpDisabledHint);
    //     }
    //     console.log('props.label :>> ', props.label);
    //     console.log('tmpLabel :>> ', tmpLabel);
    //     setState({
    //       label: tmpLabel,
    //       disabledLabel: tmpDisabledLabel,
    //       enabledHint: tmpEnabledHint,
    //       disabledHint: tmpDisabledHint,
    //     });
    //   }
    // }, []);
    return (React.createElement("div", null,
        React.createElement("button", { key: renderKey, "data-testid": "NextButton", className: "flc_next-button btn btn-" +
                (props.disabled ? "secondary" : "primary") +
                " mt-3 py-3" +
                (shake ? " shake-button" : "") +
                (props.className ? " " + props.className : ""), type: "button", onClick: onClick },
            props.disabled && disabledLabel ? disabledLabel : label,
            !props.disabled && (React.createElement(React.Fragment, null, props.enabledHint && (React.createElement("div", { className: "flc_next-button disabled-hint" }, enabledHint))))),
        props.disabled && (React.createElement(React.Fragment, null, props.disabledHint && (React.createElement("div", { className: "flc_next-button disabled-hint" }, disabledHint))))));
}

var css_248z$p = "body .flc_tip {\n  background-color: var(--flc_tip-background-color, rgb(174, 255, 174));\n  color: var(--flc_tip-font-color, black);\n  padding: 1.05rem;\n  border-radius: 0;\n  text-align: center;\n}\nbody .flc_tip img {\n  vertical-align: sub;\n}\nbody .offcanvas-body p {\n  padding-left: 0;\n  padding-right: 0;\n}";
styleInject(css_248z$p);

function Tip(props) {
    return (React.createElement("div", { "data-testid": "Tip", className: "flc_tip my-4" },
        props.image !== undefined && (React.createElement("img", { className: "d-inline-block me-2", src: props.image, alt: "Tip" })),
        React.createElement("div", { className: "d-inline-block" }, props.children)));
}

var css_248z$o = "body .flc_date-picker {\n  color: var(--h1-color);\n  text-align: center;\n  min-width: 100px;\n  cursor: pointer;\n  display: inline-block;\n  border-radius: 16px;\n}\nbody .flc_date-picker:hover {\n  outline: solid 2px #b9b9b9;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n}\nbody .flc_date-picker .day-name {\n  color: white;\n  background-color: #eb551d;\n  font-weight: 600;\n  border-radius: 16px 16px 0 0;\n  padding: 0.2rem;\n}\nbody .flc_date-picker .date {\n  background-color: #f7f7f7;\n  border-radius: 0 0 16px 16px;\n  border-left: 1px solid #d9d9d9;\n  border-bottom: 1px solid #d9d9d9;\n  border-right: 1px solid #d9d9d9;\n  padding: 0.2rem;\n}\nbody .flc_date-picker .day-number {\n  font-weight: 500;\n  font-size: 2rem;\n}\nbody .flc_date-picker .month-year {\n  font-weight: 600;\n}";
styleInject(css_248z$o);

function DatePicker(props) {
    var renderDate;
    // Allow for undefined date, string date and typed date
    if (!props.date) {
        //renderDate = new Date();
        renderDate = undefined;
    }
    else if (typeof (props.date) === "string") {
        renderDate = new Date(props.date);
    }
    else
        renderDate = props.date;
    return (React.createElement("div", { "data-testid": "DatePicker", className: "flc_date-picker m-3", onClick: props.onClick },
        React.createElement("div", { className: "day-name" }, renderDate ? renderDate.toLocaleString("default", { weekday: "short" }) : props.dateName),
        React.createElement("div", { className: "date" },
            React.createElement("div", { className: "day-number" }, renderDate ? renderDate.getDate() : '\u00a0'),
            React.createElement("div", { className: "month-year" },
                renderDate ? renderDate.toLocaleString("default", { month: "short" }) : '\u00a0',
                " ",
                renderDate ? renderDate.getFullYear() : ' '))));
}

var css_248z$n = "";
styleInject(css_248z$n);

function DateRangePicker(props) {
    var _a, _b;
    var _c = useState(props.data ? new Date((_a = props.data) === null || _a === void 0 ? void 0 : _a.fromDate) : undefined), fromDate = _c[0], setFromDate = _c[1];
    var _d = useState(props.data ? new Date((_b = props.data) === null || _b === void 0 ? void 0 : _b.toDate) : undefined), toDate = _d[0], setToDate = _d[1];
    var setData = useFlowData().setData;
    // Return date as a string in format yyyy-mm-dd
    function getSimpleDate(inputDate) {
        return inputDate ? inputDate.toISOString().split('T')[0] : undefined;
    }
    function sendDataUpdateMessage(fDate, tDate) {
        var _a;
        setData((_a = props.dataField) !== null && _a !== void 0 ? _a : '', {
            fromDate: getSimpleDate(fDate),
            toDate: getSimpleDate(tDate),
        });
    }
    function onClickFromDate() {
        var newFromDate = new Date();
        setFromDate(newFromDate);
        sendDataUpdateMessage(newFromDate, toDate);
    }
    function onClickToDate() {
        if (fromDate) {
            var newToDate = new Date();
            newToDate.setDate(fromDate.getDate() + 37);
            setToDate(newToDate);
            sendDataUpdateMessage(fromDate, newToDate);
        }
    }
    return (React__default.createElement("div", { "data-testid": 'DateRangePicker', className: 'flc_date-range-picker' },
        React__default.createElement(DatePicker, { date: fromDate, dateName: 'From', onClick: onClickFromDate }),
        React__default.createElement(DatePicker, { date: toDate, dateName: 'To', onClick: onClickToDate })));
}

var css_248z$m = "body .flc_age-picker .family-group {\n  border: 1px dotted #707070;\n  border-radius: 16px;\n  padding: 1em;\n  min-width: 260px;\n  text-align: center;\n}\nbody .flc_age-picker .family-group:not(:first-child) {\n  margin-top: 1em;\n}\nbody .flc_age-picker .age-input {\n  display: inline-block;\n  max-width: 100px;\n  font-size: 10px;\n  text-transform: uppercase;\n  text-align: center;\n}\nbody .flc_age-picker .add-link {\n  display: inline-block;\n  text-transform: uppercase;\n  text-decoration: underline;\n  margin-left: 1em;\n  margin-right: 1em;\n  text-align: center;\n  color: #d9d9d9;\n}";
styleInject(css_248z$m);

function AgePicker(props) {
    return (React.createElement("div", { "data-testid": "AgePicker", className: "flc_age-picker m-3" },
        React.createElement("div", { className: "family-group" },
            React.createElement(FloatingLabel, { controlId: "floatingInputGrid", label: "Traveller Age", className: "age-input" },
                React.createElement(Form.Control, { type: "text", placeholder: " " })),
            React.createElement("div", { className: "add-link" },
                "Add",
                React.createElement("br", null),
                "Spouse"),
            React.createElement("div", { className: "add-link" },
                "Add",
                React.createElement("br", null),
                "Child")),
        React.createElement("div", { className: "family-group" },
            React.createElement("div", { className: "add-link" }, "Add Traveller"))));
}

var css_248z$l = "body .flc_icon {\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50% !important;\n  overflow: hidden;\n}\nbody .flc_icon.hover-pointer {\n  cursor: pointer;\n}\nbody .flc_icon.xsmall {\n  width: var(--flc_icon-xsmall-size, 2.25rem);\n  height: var(--flc_icon-xsmall-size, 2.25rem);\n}\nbody .flc_icon.xsmall svg {\n  width: calc(var(--flc_icon-xsmall-size, 2.25rem) * 0.8);\n  height: calc(var(--flc_icon-xsmall-size, 2.25rem) * 0.8);\n}\nbody .flc_icon.small {\n  width: var(--flc_icon-small-size, 2.25rem);\n  height: var(--flc_icon-small-size, 2.25rem);\n}\nbody .flc_icon.small svg {\n  width: calc(var(--flc_icon-small-size, 2.25rem) * var(--flc_icon-svg-scale-factor, 0.6));\n  height: calc(var(--flc_icon-small-size, 2.25rem) * var(--flc_icon-svg-scale-factor, 0.6));\n}\nbody .flc_icon.medium {\n  width: var(--flc_icon-medium-size, 3rem);\n  height: var(--flc_icon-medium-size, 3rem);\n}\nbody .flc_icon.medium svg {\n  width: calc(var(--flc_icon-medium-size, 3rem) * var(--flc_icon-svg-scale-factor, 0.6));\n  height: calc(var(--flc_icon-medium-size, 3rem) * var(--flc_icon-svg-scale-factor, 0.6));\n}\nbody .flc_icon.large {\n  width: var(--flc_icon-large-size, 4rem);\n  height: var(--flc_icon-large-size, 4rem);\n}\nbody .flc_icon.large svg {\n  width: calc(var(--flc_icon-large-size, 4rem) * var(--flc_icon-svg-scale-factor, 0.6));\n  height: calc(var(--flc_icon-large-size, 4rem) * var(--flc_icon-svg-scale-factor, 0.6));\n}\nbody .flc_icon.xlarge {\n  width: var(--flc_icon-xlarge-size, 6rem);\n  height: var(--flc_icon-xlarge-size, 6rem);\n}\nbody .flc_icon.xlarge svg {\n  width: calc(var(--flc_icon-xlarge-size, 6rem) * (var(--flc_icon-svg-scale-factor, 0.6) - 0.1));\n  height: calc(var(--flc_icon-xlarge-size, 6rem) * (var(--flc_icon-svg-scale-factor, 0.6) - 0.1));\n}\nbody .flc_icon.success {\n  color: var(--flc-success-color, green);\n  background-color: var(--flc-success-light-color, lightgreen);\n}\nbody .flc_icon.warning {\n  color: var(--flc-warning-color, red);\n  background-color: var(--flc-warning-light-color, pink);\n}\nbody .flc_icon.info {\n  color: var(--flc-info-color, orange);\n  background-color: var(--flc-info-light-color, lightyellow);\n}\nbody .flc_icon.offer {\n  color: var(--flc-offer-color, purple);\n  background-color: var(--flc-offer-light-color, violet);\n}\nbody .flc_icon.heading {\n  color: var(--flc-primary-color, black);\n  background-color: var(--flc-icon-heading-background-color, lightgrey);\n}\nbody .flc_icon.primary-button {\n  color: var(--flc-icon-heading-background-color, black);\n  background-color: var(--flc-primary-color, lightgrey);\n}\nbody .flc_icon.primary-button-hover {\n  color: var(--flc-icon-heading-background-color, black);\n  background-color: #472cb9;\n}\nbody .flc_icon.plain {\n  color: var(--flc-plain-color, grey);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.success-white-bkgnd {\n  color: var(--flc-success-color, green);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.warning-white-bkgnd {\n  color: var(--flc-warning-color, red);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.info-white-bkgnd {\n  color: var(--flc-info-color, orange);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.offer-white-bkgnd {\n  color: var(--flc-offer-color, purple);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.heading-white-bkgnd {\n  color: var(--flc-primary-color, black);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.plain-white-bkgnd {\n  color: var(--flc-plain-color, grey);\n  background-color: var(--flc-icon-plain-background-color, white);\n}\nbody .flc_icon.plain.small {\n  border: 1px solid var(--flc-icon-plain-border-color, grey);\n}\nbody .flc_icon.plain.medium {\n  border: 2px solid var(--flc-icon-plain-border-color, grey);\n}\nbody .flc_icon.plain.large {\n  border: 2px solid var(--flc-icon-plain-border-color, grey);\n}\nbody .flc_icon.plain.xlarge {\n  border: 3px solid var(--flc-icon-plain-border-color, grey);\n}";
styleInject(css_248z$l);

var Temp = MaskedInput;
var MaskedInputWrapper = React__default.forwardRef(function (props, ref) {
    var renderResult = React__default.createElement(Temp, __assign({}, props, { ref: ref }));
    if (!renderResult || Object.keys(renderResult).length === 0) {
        return React__default.createElement(React__default.Fragment, null); // Return Fragment if renderResult is empty
    }
    return renderResult;
});
var Temp2 = Datepicker;
React__default.forwardRef(function (props, ref) {
    var renderResult = React__default.createElement(Temp2, __assign({}, props, { ref: ref }));
    if (!renderResult || Object.keys(renderResult).length === 0) {
        return React__default.createElement(React__default.Fragment, null); // Return Fragment if renderResult is empty
    }
    return renderResult;
});
var Temp3 = ReactSVG;
var ReactSVGWrapper = React__default.forwardRef(function (props, ref) {
    var renderResult = React__default.createElement(Temp3, __assign({}, props, { ref: ref }));
    if (!renderResult || Object.keys(renderResult).length === 0) {
        return React__default.createElement(React__default.Fragment, null); // Return Fragment if renderResult is empty
    }
    return renderResult;
});

function Icon(props) {
    var _a = React__default.useState(false), isHovered = _a[0], setIsHovered = _a[1];
    return (React__default.createElement(ReactSVGWrapper, { src: props.src, style: props.style, "data-testid": 'Icon', className: 'flc_icon ' +
            (props.colorStyleHover ? 'hover-pointer ' : '') +
            (props.colorStyleHover && isHovered
                ? props.colorStyleHover
                : props.colorStyle) +
            ' ' +
            props.size +
            (props.className ? ' ' + props.className : ''), onClick: function (e) { return props.onClick && props.onClick(e); }, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } }));
}

var IconColorStyle;
(function (IconColorStyle) {
    IconColorStyle["Success"] = "success";
    IconColorStyle["Warning"] = "warning";
    IconColorStyle["Info"] = "info";
    IconColorStyle["Heading"] = "heading";
    IconColorStyle["Offer"] = "offer";
    IconColorStyle["Plain"] = "plain";
    IconColorStyle["PrimaryButton"] = "primary-button";
    IconColorStyle["PrimaryButtonHover"] = "primary-button-hover";
    IconColorStyle["SuccessWhiteBkgnd"] = "success-white-bkgnd";
    IconColorStyle["WarningWhiteBkgnd"] = "warning-white-bkgnd";
    IconColorStyle["InfoWhiteBkgnd"] = "info-white-bkgnd";
    IconColorStyle["HeadingWhiteBkgnd"] = "heading-white-bkgnd";
    IconColorStyle["OfferWhiteBkgnd"] = "offer-white-bkgnd";
    IconColorStyle["PlainWhiteBkgnd"] = "plain-white-bkgnd";
    IconColorStyle["Custom"] = "";
})(IconColorStyle || (IconColorStyle = {}));
var IconBackgroundStyle;
(function (IconBackgroundStyle) {
    IconBackgroundStyle["Circle"] = "circle";
    IconBackgroundStyle["Custom"] = "";
})(IconBackgroundStyle || (IconBackgroundStyle = {}));
var IconSize;
(function (IconSize) {
    IconSize["ExtraSmall"] = "xsmall";
    IconSize["Small"] = "small";
    IconSize["Medium"] = "medium";
    IconSize["Large"] = "large";
    IconSize["ExtraLarge"] = "xlarge";
    IconSize["Custom"] = "custom";
})(IconSize || (IconSize = {}));

var css_248z$k = "body .flc_heading {\n  margin-top: 1em;\n}\nbody .flc_heading h3 {\n  margin-bottom: 0;\n}";
styleInject(css_248z$k);

function Heading(props) {
    var _a;
    var injectData = useFlowData().injectData;
    return (React__default.createElement("div", { "data-testid": 'Heading', className: 'flc_heading d-flex' },
        props.image && (React__default.createElement(Icon, { className: 'me-2', src: (_a = props.image) !== null && _a !== void 0 ? _a : '', colorStyle: IconColorStyle.Heading, size: IconSize.Medium })),
        React__default.createElement("h3", { className: 'align-self-center' }, injectData(props.title))));
}

var css_248z$j = "body .flc_flow-form {\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\nbody .flc_flow-form h3 {\n  display: inline;\n  margin-bottom: 0;\n}\nbody .flc_flow-form form {\n  padding-left: 0;\n  padding-right: 0;\n}\nbody .flc_flow-form input.form-control.is-valid ~ label,\nbody .flc_flow-form input.form-control:focus ~ label {\n  font-size: 1.2rem;\n}\nbody .flc_flow-form input.form-control ~ label {\n  font-size: 1.5rem;\n}\nbody .flc_flow-form .help-message {\n  font-weight: 300;\n  font-size: 0.9em;\n  opacity: 0.6;\n  margin-top: -1em;\n  padding: 0.5rem;\n  color: var(--flc-petsy-text-primary);\n}\nbody .flc_flow-form .form-floating > .form-control:focus ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-1.2rem) translateX(0.15rem);\n}\nbody .flc_flow-form .datepicker-container {\n  position: relative;\n  margin-top: 2em;\n}\nbody .flc_flow-form .datepicker-container.inline {\n  margin-top: 0;\n}\nbody .datepicker-container input {\n  width: 100%;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid var(--text-input-border-color);\n  padding-bottom: 0.5em;\n  font-size: 1rem;\n  font-weight: 300;\n  outline: none;\n  cursor: pointer;\n}\nbody .datepicker-container input:focus-visible {\n  border-bottom: 2px solid var(--text-input-selected-border-color);\n  margin-bottom: -1px;\n}\nbody .datepicker-container.valid input {\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\nbody .mbsc-ios.mbsc-datepicker-inline {\n  border-color: var(--text-input-border-color-darker);\n}\nbody .datepicker-container.inline .date-diff-label {\n  text-align: center;\n  border-bottom: solid 1px var(--text-input-border-color-darker);\n  font-weight: 600;\n}\nbody .datepicker-container.date-box-2 {\n  display: block;\n  margin-bottom: 1rem;\n}\nbody .datepicker-container.date-box-2 input {\n  width: calc(100% - 12rem);\n  margin-left: 3rem;\n  margin-right: 0;\n  display: inline-block;\n}\nbody .datepicker-container.date-box-2 input.untouched ~ label, body .datepicker-container.date-box-2 input.is-invalid ~ label {\n  position: absolute;\n  left: 0;\n  height: 5.25rem;\n  top: 1.6rem;\n  font-size: 1.4rem;\n  padding-left: 1.2rem;\n  align-items: center;\n  color: var(--flc-petsy-text-primary);\n  opacity: 1;\n}\nbody .datepicker-container.date-box-2 input:focus ~ label, body .datepicker-container.date-box-2 input.is-valid ~ label, body .datepicker-container.date-box-2 input:active ~ label {\n  padding-left: 1rem;\n  font-size: 1.2rem;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  top: 0;\n  opacity: 0.6;\n}\nbody .datepicker-container.date-box-2 button {\n  width: 5rem;\n  margin-left: 1rem;\n  display: inline-block;\n  color: white;\n  background-image: url(/images/icons/calendar-purple-icon.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 3rem;\n  background-color: var(--flc-petsy-form-control-input-background);\n  margin-top: -1.5rem;\n}\nbody .react-datepicker-label {\n  position: absolute;\n  z-index: 1;\n  left: 0.1em;\n  top: -0.7em;\n  font-size: 1.0625rem;\n  transition: all 0.1s ease-in-out;\n}\nbody .react-datepicker-label.selected {\n  font-size: 0.9em;\n  left: 0.2em;\n  top: -1.5em;\n  opacity: 0.6;\n  transition: all 0.1s ease-in-out;\n}\nbody .react-datepicker-label.invalid {\n  color: var(--flc-warning-color);\n}\nbody .form-select {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid var(--text-input-border-color);\n  padding-left: 0.2em;\n  border-radius: 0;\n  box-shadow: none;\n}\nbody .form-select:focus {\n  border-bottom: 2px solid var(--text-input-selected-border-color);\n  margin-bottom: -1px;\n  box-shadow: none;\n}\nbody .form-select.is-valid {\n  border-color: var(--text-input-border-color);\n}\nbody .form-select.is-valid:focus {\n  box-shadow: none;\n  border-color: var(--text-input-selected-border-color);\n}\nbody .form-select.is-invalid {\n  border-color: red;\n  border-width: 2px;\n}\nbody .form-select.is-invalid:focus {\n  box-shadow: none;\n}\nbody .form-select option {\n  font-weight: normal;\n}\nbody .flc_flow-form .no-spin::-webkit-inner-spin-button,\nbody .no-spin::-webkit-outer-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0 !important;\n}\nbody .flc_flow-form .no-spin {\n  -moz-appearance: textfield !important;\n}\n@media (max-width: 480px) {\n  body .datepicker-container.inline .date-diff-label {\n    font-size: 1.575em !important;\n  }\n}";
styleInject(css_248z$j);

// Text box: Text, Email, Phone number
function TextBox(props) {
    var _a;
    var inputRef = React__default.useRef(null);
    var _b = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ''), state = _b[0], setState = _b[1];
    var _c = React__default.useState(props.value !== '' && props.value !== undefined), isTouched = _c[0], setIsTouched = _c[1];
    var _d = React__default.useState(false), isInvalid = _d[0], setIsInvalid = _d[1];
    // Custom email validation function
    var validateEmail = function (email) {
        if (!email)
            return true; // Empty email is valid if not required
        var emailRegex = new RegExp(emailValidationPattern);
        return emailRegex.test(email);
    };
    var activeStep = useFlowController().activeStep;
    React__default.useEffect(function () {
        var _a, _b;
        if ((_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.showValidations) !== null && _a !== void 0 ? _a : false) {
            setIsTouched(true);
            var isValid = props.type === 'email'
                ? validateEmail(state)
                : (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.checkValidity();
            setIsInvalid(!(isValid !== null && isValid !== void 0 ? isValid : false));
        }
    }, [activeStep, state, props.type]);
    React__default.useEffect(function () {
        var _a;
        setState((_a = props.value) !== null && _a !== void 0 ? _a : '');
    }, [props.value]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form.Group, { as: Col, className: 'mt-1 my-3', controlId: 'ctrl_' + props.id },
            React__default.createElement(FloatingLabel, { label: props.prompt, className: isInvalid ? 'text-danger' : '' },
                React__default.createElement(Form.Control, { ref: inputRef, className: 'no-spin fgd', id: props.id, key: props.id, name: props.dataField, 
                    // type={props.type}
                    placeholder: props.prompt, maxLength: props.maxLength, minLength: props.minLength, required: props.required, readOnly: props.readOnly, autoComplete: props.autocomplete || '', "aria-describedby": props.type + 'HelpBlock', value: state, "data-private": props.dataPrivate, pattern: props.type === 'email' ? emailValidationPattern : undefined, autoFocus: props.autoFocus, isInvalid: isTouched && state !== "" && isInvalid, isValid: isTouched && state !== "" && !isInvalid, onKeyPress: function (e) {
                        if (props.type === 'email' && e.key === ' ')
                            e.preventDefault();
                    }, onChange: function (e) {
                        if (props.type === 'email')
                            e.target.value = e.target.value
                                ? e.target.value.trim()
                                : e.target.value;
                        setState(e.target.value);
                        if (props.maxLength != undefined &&
                            e.target.value.length > props.maxLength) {
                            setState(e.target.value.substring(0, props.maxLength));
                        }
                        props.onChange &&
                            props.onChange({
                                field: e.target.name,
                                value: e.target.value,
                            });
                        if (isTouched) {
                            if (props.type === 'email') {
                                setIsInvalid(!validateEmail(e.target.value));
                            }
                            else {
                                setIsInvalid(e.target.checkValidity() === false);
                            }
                        }
                    }, onBlur: function (e) {
                        setIsTouched(true);
                        if (props.type === 'email') {
                            setIsInvalid(!validateEmail(e.target.value));
                        }
                        else {
                            setIsInvalid(e.target.checkValidity() === false);
                        }
                    } }),
                React__default.createElement(Form.Control.Feedback, { type: 'invalid', onClick: function () {
                        inputRef.current && inputRef.current.focus();
                    } }, props.invalidMessage)))));
}
// Text box with a mask
function TextBoxMask(props) {
    var _a, _b, _c;
    var _d = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ''), state = _d[0], setState = _d[1];
    var _e = React__default.useState(props.value !== '' && props.value !== undefined), isTouched = _e[0], setIsTouched = _e[1];
    var _f = React__default.useState(false), isInvalid = _f[0], setIsInvalid = _f[1];
    var _g = React__default.useState('form-control'), inputClassName = _g[0], setInputClassName = _g[1];
    useEffect(function () {
        if (!props.required && !props.value) {
            setIsInvalid(false);
            setIsTouched(false);
            return;
        }
        if (isTouched) {
            if (isInvalid) {
                setInputClassName('form-control is-invalid');
            }
            else {
                setInputClassName('form-control is-valid');
            }
        }
    }, [isInvalid]);
    var maskInputRef = React__default.useRef(null);
    var activeStep = useFlowController().activeStep;
    React__default.useEffect(function () {
        var _a;
        if ((_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.showValidations) !== null && _a !== void 0 ? _a : false) {
            setIsTouched(true);
            setIsInvalid(!checkIsValid(state));
        }
    }, [activeStep]);
    function stripMaskChars(value) {
        return value.replaceAll('_', '').replaceAll(' ', '').replaceAll('-', '');
    }
    function checkIsValid(value) {
        var _a;
        var mask = (_a = props.mask) !== null && _a !== void 0 ? _a : '';
        if (mask === 'phone')
            mask = getPhoneNumberMask(value);
        var replaced = stripMaskChars(value);
        if (replaced.length === stripMaskChars(mask).length)
            return true;
        else
            return false;
    }
    var _h = React__default.useState(props.mask === 'phone'
        ? getPhoneNumberMask((_b = props.value) !== null && _b !== void 0 ? _b : '')
        : (_c = props.mask) !== null && _c !== void 0 ? _c : ''), mask = _h[0], setMask = _h[1];
    function getPhoneNumberMask(phoneNumber) {
        if (phoneNumber.length > 0 && phoneNumber.substring(0, 2) === '04')
            return '1111 111 111';
        else
            return '11 1111 1111';
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form.Group, { as: Col, className: 'mt-1 my-3', controlId: 'ctrl_' + props.id },
            React__default.createElement(FloatingLabel, { label: props.prompt, className: isInvalid ? 'text-danger' : '' },
                React__default.createElement(MaskedInputWrapper, { ref: maskInputRef, id: props.id, key: props.id, name: props.dataField, type: props.type, placeholder: '', value: state, required: props.required, autoComplete: 'off', onChange: function (e) {
                        var _a, _b;
                        if (props.mask === 'phone') {
                            var newMask = getPhoneNumberMask(e.target.value);
                            if (newMask !== mask) {
                                setMask(getPhoneNumberMask(e.target.value));
                                // Handles the space inserted when mask is changed
                                if (stripMaskChars(e.target.value) === '04') {
                                    //@ts-ignore
                                    (_a = maskInputRef.current) === null || _a === void 0 ? void 0 : _a.input.selectionStart = 2;
                                    //@ts-ignore
                                    (_b = maskInputRef.current) === null || _b === void 0 ? void 0 : _b.input.selectionEnd = 2;
                                }
                            }
                        }
                        setState(e.target.value);
                        var isValid = checkIsValid(e.target.value);
                        props.onChange &&
                            props.onChange({
                                field: e.target.name,
                                value: stripMaskChars(e.target.value),
                            });
                        if (isTouched)
                            setIsInvalid(!isValid);
                    }, onBlur: function (e) {
                        var isValid = checkIsValid(e.target.value);
                        setIsTouched(true);
                        setIsInvalid(!isValid);
                        if (!props.required && !e.target.value) {
                            setIsInvalid(false);
                            setIsTouched(false);
                            setInputClassName('form-control');
                        }
                    }, className: inputClassName, mask: mask, "aria-describedby": props.type + 'HelpBlock', "data-private": props.dataPrivate }),
                isInvalid && (React__default.createElement("div", { className: 'invalid-feedback d-block' }, props.invalidMessage))))));
}
// Date helper function
function getPetAge(pet_dob, start_date) {
    // const today = moment().startOf("day");
    var today = start_date
        ? moment(start_date, 'DD/MM/YYYY')
        : moment().startOf('day');
    var dob = moment(pet_dob, 'DD/MM/YYYY');
    var years = today.diff(dob, 'year');
    var months = today.diff(dob, 'month');
    var weeks = today.diff(dob, 'week');
    var days = today.diff(dob, 'days');
    return {
        days: days,
        weeks: weeks,
        months: months,
        years: years,
    };
}
// Allows 'today' or 'today+10' or 'today-10' to passed in as a value.
// The number can be any whole number.
// Any unrecognised is treated as a date string and returned.
function calcDate(date) {
    var dt = date.replace(' ', '');
    if (dt.startsWith('today+')) {
        try {
            var days = parseInt(dt.substring(6));
            return moment().add(days, 'day').format('YYYY-MM-DD');
        }
        catch (error) {
            return '';
        }
    }
    else if (dt.startsWith('today-')) {
        try {
            var days = parseInt(dt.substring(6));
            return moment().subtract(days, 'day').format('YYYY-MM-DD');
        }
        catch (error) {
            return '';
        }
    }
    else if (dt.startsWith('today')) {
        try {
            var days = parseInt(dt.substring(5));
            return moment().format('YYYY-MM-DD');
        }
        catch (error) {
            return '';
        }
    }
    else
        return dt;
}
function checkIfStringIsValidDate(date) {
    var dateCheck = moment(date);
    return dateCheck.isValid();
}
function getDateClassName(isTouched, isInvalid) {
    var className = 'form-control ';
    if (!isTouched) {
        return (className = 'form-control untouched');
    }
    if (!isInvalid) {
        className = 'form-control is-valid';
    }
    else {
        className = 'form-control is-invalid';
    }
    return className;
}
// DatePicker: Date
function DateBox2(props) {
    var _a, _b, _c, _d;
    var _e = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ''), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = React__default.useState(props.value !== '' && props.value !== undefined), isTouched = _f[0], setIsTouched = _f[1];
    var _g = React__default.useState(false), openPicker = _g[0], setOpenPicker = _g[1];
    var _h = React__default.useState(new Date()), date = _h[0]; _h[1];
    var _j = React__default.useState(false), isInvalid = _j[0], setIsInvalid = _j[1];
    React__default.useRef();
    var type = props.type === 'date-calendar' ? ['calendar'] : ['date'];
    var minDate = calcDate((_b = props.minDate) !== null && _b !== void 0 ? _b : '');
    var maxDate = calcDate((_c = props.maxDate) !== null && _c !== void 0 ? _c : '');
    var defaultDate = calcDate((_d = props.defaultDate) !== null && _d !== void 0 ? _d : '');
    var show = function () {
        setOpenPicker(true);
    };
    var activeStep = useFlowController().activeStep;
    React__default.useEffect(function () {
        var _a;
        if ((_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.showValidations) !== null && _a !== void 0 ? _a : false) {
            setIsTouched(true);
            var isValid = !!selectedDate;
            setIsInvalid(!(isValid !== null && isValid !== void 0 ? isValid : false));
        }
    }, [activeStep]);
    var onClose = function () {
        setOpenPicker(false);
    };
    var autoButtons = React__default.useMemo(function () {
        return [
            {
                text: 'Close',
                handler: 'cancel',
            },
        ];
    }, []);
    function handleInput(e) {
        var v = e.target.value.replace(/\D/g, '');
        if (v.length === 8) {
            v = v.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
            e.target.value = v;
        }
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: 'datepicker-container date-box-2 form-floating' },
            React__default.createElement(Datepicker, { inputComponent: 'input', showOnClick: false, showOnFocus: false, isOpen: openPicker, onClose: onClose, defaultValue: date, value: selectedDate, controls: type, touchUi: true, inputProps: {
                    className: getDateClassName(isTouched, isInvalid),
                    onInput: handleInput,
                }, theme: 'ios', themeVariant: 'light', display: 'center', dateFormat: 'DD/MM/YYYY', buttons: autoButtons, returnFormat: 'iso8601', min: minDate, max: maxDate, defaultSelection: defaultDate, onChange: function (e) {
                    setSelectedDate(e.value);
                    setIsTouched(true);
                    checkIfStringIsValidDate(e.value)
                        ? setIsInvalid(false)
                        : setIsInvalid(true);
                    props.onChange &&
                        props.onChange({
                            field: props.dataField,
                            value: e.value,
                        });
                } }),
            React__default.createElement(Button, { variant: 'outline', color: 'primary', className: 'flc_next-button btn', onClick: show }),
            React__default.createElement("label", null,
                " ",
                props.prompt),
            React__default.createElement("div", { className: 'invalid-feedback' }, "Please enter a valid date"))));
}
function getDateDiffYearsAndMonths(fromDate, toDate) {
    var months = fromDate.diff(toDate, 'month');
    var years = Math.floor(months / 12);
    var remainingMonths = months % 12;
    var yearsText = years > 0 ? years + ' year' + (years > 1 ? 's' : '') : '';
    var monthsText = remainingMonths > 0
        ? remainingMonths + ' month' + (remainingMonths > 1 ? 's' : '')
        : '';
    var andText = yearsText && monthsText ? ', ' : '';
    return yearsText + andText + monthsText + ' old';
}
function DateBoxInline(props) {
    var _a, _b, _c, _d;
    var _e = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ''), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = React__default.useState(props.value !== '' && props.value !== undefined), isTouched = _f[0], setIsTouched = _f[1];
    var _g = React__default.useState(false), isInvalid = _g[0]; _g[1];
    var datepickerRef = React__default.useRef();
    var type = props.type === 'date-calendar-inline' ? ['calendar'] : ['date'];
    var minDate = calcDate((_b = props.minDate) !== null && _b !== void 0 ? _b : '');
    var maxDate = calcDate((_c = props.maxDate) !== null && _c !== void 0 ? _c : '');
    var defaultDate = calcDate((_d = props.defaultDate) !== null && _d !== void 0 ? _d : '');
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form.Group, { as: Col, className: 'mt-1 my-3', controlId: 'ctrl_' + props.id },
            React__default.createElement("div", { className: 'datepicker-container inline' +
                    (isTouched && !isInvalid ? ' valid' : '') },
                React__default.createElement(Datepicker, { ref: datepickerRef, controls: type, touchUi: true, inputComponent: 'input', theme: 'ios', themeVariant: 'light', display: 'inline', dateFormat: 'DD/MM/YYYY', returnFormat: 'iso8601', value: selectedDate, min: minDate, max: maxDate, defaultSelection: defaultDate, onChange: function (e) {
                        setSelectedDate(e.value);
                        setIsTouched(true);
                        props.onChange &&
                            props.onChange({
                                field: props.dataField,
                                value: e.value,
                            });
                    } }),
                props.showAgeText && (React__default.createElement("div", { className: 'date-diff-label' }, getDateDiffYearsAndMonths(moment(new Date()), moment(selectedDate))))),
            React__default.createElement(Form.Control.Feedback, { type: 'invalid' }, props.invalidMessage))));
}
// Dropdown
function SelectBox(props) {
    var _a;
    var _b = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ''), state = _b[0], setState = _b[1];
    var _c = React__default.useState(props.value !== '' && props.value !== undefined), touched = _c[0], setTouched = _c[1];
    var _d = React__default.useState(false), isInvalid = _d[0], setIsInvalid = _d[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form.Group, { as: Col, className: 'mt-1 my-3', controlId: 'ctrl_' + props.id },
            React__default.createElement(FloatingLabel, { label: props.prompt, className: isInvalid ? 'text-danger' : '' },
                React__default.createElement(Form.Select, { id: props.id, key: props.id, name: props.dataField, 
                    // type={props.type}
                    // placeholder={props.prompt}
                    required: props.required, 
                    // aria-describedby={props.type + 'HelpBlock'}
                    value: state, isInvalid: isInvalid, isValid: touched && !isInvalid, onChange: function (e) {
                        setState(e.target.value);
                        if (props.maxLength != undefined &&
                            e.target.value.length > props.maxLength) {
                            setState(e.target.value.substring(0, props.maxLength));
                        }
                        props.onChange &&
                            props.onChange({
                                field: e.target.name,
                                value: e.target.value,
                            });
                        if (touched)
                            setIsInvalid(e.target.checkValidity() === false);
                    }, onBlur: function (e) {
                        setTouched(true);
                        setIsInvalid(e.target.checkValidity() === false);
                    } }, props.selectItems &&
                    props.selectItems.map(function (item, index) { return (React__default.createElement("option", { key: item.value, value: item.value }, item.text)); })),
                React__default.createElement(Form.Control.Feedback, { type: 'invalid' }, props.invalidMessage)))));
}
// Button choice: ButtonChoice
// Checkbox
function FlowForm(props) {
    // TODO: Dropdown & other control types
    var _a = React__default.useState(false), validated = _a[0], setValidated = _a[1];
    var activeStep = useFlowController().activeStep;
    var _b = useFlowData(), getData = _b.getData, setData = _b.setData, injectData = _b.injectData;
    function handleValidate(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = event.currentTarget;
        if (form.checkValidity() === false) ;
        setValidated(true);
    }
    function handleChange(dataChange) {
        var field = dataChange.field, value = dataChange.value;
        // Trim value for specific fields
        if (['accountName', 'bsb', 'accountNumber'].includes(field)) {
            dataChange.value = value ? value.trim() : value;
        }
        // Update isSavedQuote for specific fields
        if (['name', 'petDOB'].includes(field)) {
            setFlowDataDirect('isSavedQuote', false);
        }
        setData(field, value);
        if (props.onChange) {
            props.onChange(dataChange);
        }
        // Calculate pet age category and update related fields
        var calculatePetAgeCategory = function (dobValue, startDateValue) {
            if (startDateValue === void 0) { startDateValue = null; }
            var dob = moment(dobValue, 'YYYY-MM-DD');
            var startDate = startDateValue
                ? moment(startDateValue, 'YYYY-MM-DD')
                : moment().startOf('day');
            var petAge = getPetAge(dob.format('DD/MM/YYYY'), startDate.format('DD/MM/YYYY')).days;
            var petType = getData('petType');
            var petAgeCategory = 0;
            if (petAge >= 42 && petAge <= 184) {
                petAgeCategory = petType === 'dog' ? 1 : 2; // PUPJ/KITJ
            }
            else if (petAge >= 185 && petAge <= 364) {
                petAgeCategory = petType === 'dog' ? 3 : 4; // PUP/KIT
            }
            return { petAge: petAge, petAgeCategory: petAgeCategory };
        };
        if (field === 'petDOB') {
            var currentPetAgeCategory = getData('petAgeCategory');
            var _a = calculatePetAgeCategory(value), petAge = _a.petAge, petAgeCategory = _a.petAgeCategory;
            var updates = {
                petAgeCategory: petAgeCategory,
                'customCover.vetConsultationFees': petAgeCategory > 0 ? 'yes' : undefined,
                isShowedPopup: currentPetAgeCategory !== petAgeCategory ? false : undefined,
            };
            Object.entries(updates).forEach(function (_a) {
                var key = _a[0], val = _a[1];
                return val !== undefined && setData(key, val);
            });
        }
        if (field === 'petDOB' || field === 'startDate') {
            var dob = field === 'petDOB' ? value : getData('petDOB');
            var startDate = field === 'startDate' ? value : getData('startDate');
            var _b = calculatePetAgeCategory(dob, startDate), petAge = _b.petAge, petAgeCategory = _b.petAgeCategory;
            var updates = {
                petAgeOnStartDatePolicy: petAge,
                petAgeCategory: petAgeCategory,
                'customCover.optionalExtras': petAge > 1094 ? 'no' : undefined,
                alternateQuotes: null
            };
            Object.entries(updates).forEach(function (_a) {
                var key = _a[0], val = _a[1];
                return val !== undefined && setData(key, val);
            });
        }
        // if (dataChange.field === "petDOB") {
        //   let currentPetAgeCategory = getData("petAgeCategory");
        //   let petType = getData("petType");
        //   let dob = moment(dataChange.value, "YYYY-MM-DD");
        //   const petAge = getPetAge(dob.format('DD/MM/YYYY')).days;
        //   let petAgeCategory = 0; //Standard
        //   if (petAge >= 42 && petAge <= 184) {
        //     if (petType === 'dog') {
        //       petAgeCategory = 1; //PUPJ
        //     } else {
        //       petAgeCategory = 2; //KITJ
        //     }
        //   } else if (petAge >= 185 && petAge <= 364) {
        //     if (petType === 'dog') {
        //       petAgeCategory = 3; //PUP
        //     } else {
        //       petAgeCategory = 4; //KIT
        //     }
        //   }
        //   setData("petAgeCategory", petAgeCategory);
        //   if (petAgeCategory > 0) {
        //     setData("customCover.vetConsultationFees", 'yes');
        //   }
        //   if (currentPetAgeCategory !== petAgeCategory) {
        //     setData("isShowedPopup", false);
        //   }
        // }
        // if (dataChange.field === "petDOB" || dataChange.field === "startDate") {
        //   //calculate age of pet on start date of the policy
        //   let dob = getData("petDOB");
        //   let startDate = getData("startDate");
        //   let petType = getData("petType");
        //   if (dataChange.field === "petDOB") {
        //     dob = dataChange.value;
        //   } else {
        //     startDate = dataChange.value;
        //   }
        //   dob = moment(dob, "YYYY-MM-DD");
        //   startDate = startDate ? moment(startDate, "YYYY-MM-DD") : moment().startOf("day");
        //   let petAge = getPetAge(dob.format('DD/MM/YYYY'), startDate.format('DD/MM/YYYY')).days;
        //   setData("petAgeOnStartDatePolicy", petAge);
        //   let petAgeCategory = 0; //Standard
        //   if (petAge >= 42 && petAge <= 184) {
        //     if (petType === 'dog') {
        //       petAgeCategory = 1; //PUPJ
        //     } else {
        //       petAgeCategory = 2; //KITJ
        //     }
        //   } else if (petAge >= 185 && petAge <= 364) {
        //     if (petType === 'dog') {
        //       petAgeCategory = 3; //PUP
        //     } else {
        //       petAgeCategory = 4; //KIT
        //     }
        //   }
        //   setData("petAgeCategory", petAgeCategory);
        //   // 1094 = 2years + 364 days (1 year = 365 days)
        //   if (petAge > 1094) {
        //     setData("customCover.optionalExtras", 'no');
        //   }
        // }
    }
    return (React__default.createElement("div", { "data-testid": 'FlowForm', className: 'flc_flow-form p-0 ' + props.className === undefined
            ? ''
            : props.className },
        props.title && (React__default.createElement(Heading, { stepSlug: props.stepSlug, step: props.step, title: props.title, image: props.titleImage })),
        React__default.createElement(Form, { noValidate: true, validated: validated, onSubmit: handleValidate }, props.formConfig.map(function (item, index) {
            var itemClone = lodashUtils.cloneDeep(item);
            if (props.step)
                itemClone.prompt = injectData(item.prompt);
            if (item.type) {
                return (React__default.createElement("div", { key: 'flow-form-item-fragment' + index },
                    (item.type === 'text' ||
                        item.type === 'email' ||
                        item.type === 'number') && (React__default.createElement(TextBox, __assign({ key: 'flow-form-item' + index }, itemClone, { showValidations: activeStep === null || activeStep === void 0 ? void 0 : activeStep.showValidations, value: getData(itemClone.dataField), onChange: handleChange }))),
                    item.type === 'text-mask' && (React__default.createElement(TextBoxMask, __assign({ key: 'flow-form-item' + index }, itemClone, { value: getData(itemClone.dataField), onChange: handleChange }))),
                    (item.type === 'date-calendar' ||
                        item.type === 'date-picker') && (React__default.createElement(DateBox2, __assign({ key: 'flow-form-item' + index }, itemClone, { showValidations: activeStep === null || activeStep === void 0 ? void 0 : activeStep.showValidations, value: getData(itemClone.dataField), onChange: handleChange }))),
                    (item.type === 'date-calendar-inline' ||
                        item.type === 'date-picker-inline') && (React__default.createElement(DateBoxInline, __assign({ key: 'flow-form-item' + index }, itemClone, { value: getData(itemClone.dataField), onChange: handleChange }))),
                    item.type === 'select' && (React__default.createElement(SelectBox, __assign({ key: 'flow-form-item' + index }, itemClone, { value: getData(itemClone.dataField), onChange: handleChange }))),
                    item.helpMessage && (React__default.createElement("div", { className: 'help-message' }, itemClone.helpMessage))));
            }
            else {
                return (React__default.createElement("div", { key: 'flow-form-item-fragment' + index }, "CONTROL NOT FOUND"));
            }
        }))));
}

var css_248z$i = "body .flc_info-list {\n  color: var(--flc_infolist-font-color);\n  background: var(--flc_infolist-bg-color);\n  border-radius: var(--flc-border-radius);\n  margin-top: var(--flc-infolist-tbmargin);\n  margin-bottom: var(--flc-infolist-tbmargin);\n}\nbody .flc_info-list .flc_InfoListItem {\n  display: flex;\n  padding-left: var(--flc_infolist-item-padding);\n  padding-right: var(--flc_infolist-item-padding);\n  padding-top: var(--flc_infolist-item-padding);\n  padding-bottom: 0px;\n}\nbody .flc_info-list .flc_InfoListItem .flc_infoListItem_icon {\n  display: flex;\n  flex: 0;\n  padding-right: var(--flc_infolist-item-padding);\n}\nbody .flc_info-list .flc_InfoListItem .flc_infoListItem_icon .flc_icon {\n  background: var(--flc_infolist-icon-bg);\n}\nbody .flc_info-list .flc_InfoListItem .flc_InfoListItem_label {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\nbody .flc_info-list .flc_InfoListItem .flc_InfoListItem_label em {\n  font-weight: var(--flc_infolist-em-weight);\n  font-style: normal;\n}\nbody .flc_info-list .flc_InfoListItem:last-child {\n  padding-bottom: var(--flc_infolist-item-padding);\n}\nbody .flc_info-list.success {\n  color: var(--flc-success-color, green);\n  background-color: var(--flc-success-light-color, lightgreen);\n}\nbody .flc_info-list.warning {\n  color: var(--flc-warning-color, red);\n  background-color: var(--flc-warning-light-color, pink);\n}\nbody .flc_info-list.info {\n  color: var(--flc-info-color, orange);\n  background-color: var(--flc-info-light-color, lightyellow);\n}\nbody .flc_info-list.offer {\n  color: var(--flc-offer-color, purple);\n  background-color: var(--flc-offer-light-color, violet);\n}\nbody .flc_info-list.heading {\n  color: var(--flc-primary-color, black);\n  background-color: var(--flc-icon-heading-background-color, lightgrey);\n}\nbody .flc_info-list.plain {\n  color: var(--flc-plain-color, grey);\n  background-color: var(--flc-icon-plain-background-color, white);\n}";
styleInject(css_248z$i);

function InfoList(props) {
    var injectData = useFlowData().injectData;
    return (React__default.createElement("div", { "data-testid": 'InfoList', className: 'flc_info-list ' + props.colorOption }, props.infoItems.map(function (infoItem, index) {
        return (React__default.createElement("div", { key: 'info-list-item' + index, className: 'flc_InfoListItem' },
            React__default.createElement("div", { className: 'flc_infoListItem_icon' },
                React__default.createElement(Icon, { className: '', src: infoItem.icon, size: IconSize.Medium })),
            React__default.createElement("div", { className: 'flc_InfoListItem_label' }, props.step && (React__default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: injectData(infoItem.label),
                } })))));
    })));
}

var OptionElementType;
(function (OptionElementType) {
    OptionElementType["Image"] = "image";
    OptionElementType["Text"] = "text";
    OptionElementType["Button"] = "button";
    OptionElementType["Radio"] = "radio";
})(OptionElementType || (OptionElementType = {}));
var OptionElementTextAlign;
(function (OptionElementTextAlign) {
    OptionElementTextAlign["Center"] = "center";
    OptionElementTextAlign["Left"] = "left";
    OptionElementTextAlign["Right"] = "right";
})(OptionElementTextAlign || (OptionElementTextAlign = {}));
var OptionalLayout;
(function (OptionalLayout) {
    OptionalLayout["Stacked"] = "stacked";
    OptionalLayout["OneLine"] = "oneline";
    OptionalLayout["RadioStacked"] = "radio-stacked";
    OptionalLayout["RadioOneLine"] = "radio-oneline";
})(OptionalLayout || (OptionalLayout = {}));

var css_248z$h = "body .flc_options {\n  flex-direction: column;\n  flex-wrap: wrap;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  justify-items: center;\n  align-content: center;\n}\nbody .flc_options.align-left {\n  text-align: left;\n  align-items: flex-start;\n  justify-items: flex-start;\n  justify-content: flex-start;\n}\nbody .flc_options.annualExcess .buttonDiv button {\n  width: 7.5rem !important;\n}\nbody .flc_options .radioDiv {\n  cursor: pointer;\n}\nbody .flc_options .radioDiv .radio-item {\n  cursor: pointer;\n  margin-right: 1rem;\n}\nbody .flc_options .radioDiv .radio-item .radio-icon {\n  cursor: pointer;\n}\nbody .flc_options .radioDiv .radio-item .radio-icon::before {\n  content: \"\";\n  display: block;\n  width: 1.3rem;\n  height: 1.3rem;\n  border-radius: 50%;\n  border: 2px solid rgb(58, 42, 128);\n  transition: border 0.3s linear;\n}\nbody .flc_options .radioDiv .radio-item label {\n  margin-left: 0.5rem;\n  cursor: pointer;\n  color: rgb(65, 61, 79);\n  transition: color 0.3s linear;\n}\nbody .flc_options .radioDiv .radio-item:hover .radio-icon label {\n  color: rgba(65, 61, 79, 0.8);\n}\nbody .flc_options .radioDiv .radio-item.selected .radio-icon::before {\n  border: 6px solid rgb(58, 42, 128);\n}\nbody .flc_options .buttonDiv {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\nbody .flc_options .buttonDiv button {\n  width: 100%;\n  padding: 1rem 1rem;\n  border-radius: var(--flc-border-radius, 0.75rem);\n  font-size: var(--flc_options-button-font-size);\n  font-weight: var(--flc_options-button-font-weight);\n  border-width: 0.125rem;\n}\nbody .flc_options .buttonDiv button.oneline {\n  padding: 1rem 0.5rem;\n}\nbody .flc_options .buttonDiv button .OptionElement {\n  margin-top: var(--flc_options-button-option-margin);\n  margin-bottom: var(--flc_options-button-option-margin);\n}\nbody .flc_options .buttonDiv button .OptionElement:first-child {\n  margin-top: 0;\n}\nbody .flc_options .buttonDiv button .OptionElement:last-child {\n  margin-bottom: 0;\n}\nbody .flc_options .buttonDiv button.oneline .OptionElement {\n  margin-top: 0;\n  margin-bottom: 0;\n}\nbody .flc_options .buttonDiv button.oneline .OptionElement:first-child {\n  margin: auto;\n  margin-right: 0;\n  padding-right: 0.25rem;\n}\nbody .flc_options .buttonDiv button.oneline .OptionElement:last-child {\n  margin: auto;\n  margin-left: 0;\n  padding-left: 0.25rem;\n}\nbody .flc_options .buttonDiv button.oneline .btnIcon svg {\n  padding: 0rem 0rem;\n  width: var(--flc_options-oneline-svg-size);\n  height: var(--flc_options-oneline-svg-size);\n}\nbody .flc_options .buttonDiv button:focus {\n  box-shadow: none;\n}\nbody .flc_options .buttonDiv button .btnIcon svg {\n  padding: 0px;\n  width: var(--flc_options-default-svg-size);\n  height: var(--flc_options-default-svg-size);\n}\nbody .flc_options .buttonDiv button.default {\n  border: 0.125rem solid var(--flc_options-button-border-default-color);\n  background: none;\n  color: var(--flc_options-button-font-color);\n}\nbody .flc_options .buttonDiv button.default.unselected {\n  border: 0.125rem solid var(--flc_options-button-border-unselected-color);\n  background: none;\n  color: var(--flc_options-button-unselected-font-color);\n}\nbody .flc_options .buttonDiv button.default:hover {\n  color: var(--flc_options-button-font-color);\n  background: var(--flc_options-button-hover-bg-default);\n  border: 0.125rem solid var(--flc_options-button-border-hover-color);\n}\nbody .flc_options .buttonDiv button.default.selected {\n  border: 0.125rem solid var(--flc_options-button-border-selected-color);\n  background: var(--flc_options-button-border-selected-bg-color);\n  color: var(--flc_options-button-selected-font-color);\n}\nbody .flc_options .OptionElement.text-center {\n  text-align: center;\n}\nbody .flc_options .OptionElement.text-left {\n  text-align: left;\n}\nbody .flc_options .OptionElement.text-right {\n  text-align: right;\n}\nbody .flc_options .innerButton {\n  border-radius: 2rem;\n  font-size: var(--flc_options-innerbutton-font-size);\n  padding: 0.5rem 0rem;\n  margin: 0rem;\n}\nbody .flc_options .innerButton.filled {\n  background-color: var(--flc_options-innerbutton-fill);\n  color: var(--flc_options-innerbutton-outline);\n}\nbody .flc_options .innerButton.outline {\n  color: var(--flc_options-innerbutton-fill);\n  background-color: var(--flc_options-innerbutton-outline);\n  border: 0.0625rem solid var(--flc_options-innerbutton-fill);\n}\nbody .flc_options .itemLabel {\n  padding: 0px;\n}\nbody .flc_options.readonly .buttonDiv {\n  pointer-events: none;\n}\nbody .flc_options .underlineItemLabel {\n  padding: 0px;\n  color: rgba(58, 42, 128, 0.3);\n  font-size: 10px;\n}\nbody .flc_flow-step .flc_options .buttonDiv button.hilight {\n  height: 7.2rem;\n}\nbody .flc_flow-step .flc_options .buttonDiv button.hilight .itemLabel {\n  color: #ff6600;\n}\nbody .flc_flow-step .flc_options .buttonDiv button.hilight .underlineItemLabel {\n  color: rgba(58, 42, 128, 0.3);\n  text-decoration: line-through;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n}";
styleInject(css_248z$h);

function Options(props) {
    var _a = useFlowData(), getData = _a.getData, setData = _a.setData;
    var petAgeCategory = getData("petAgeCategory");
    getData("petAgeOnStartDatePolicy");
    var _b = useState(""), selectedOption = _b[0], setSelectedOption = _b[1];
    var _c = useState(true), isValidPetAge = _c[0], setIsValidPetAge = _c[1];
    var layoutClass = props.layout == "oneline" ? " " + props.layout + " d-flex" : " " + props.layout + " ";
    var btnStyle = {
        width: 100 / props.optionList.length + "%",
    };
    var btnStyleAutoWidth = {
        width: "unset",
    };
    var isAutoWidth = props.autoWidth != undefined && props.autoWidth == true;
    var isReadOnly = props.readOnly != undefined && props.readOnly == true;
    var className = props.className ? props.className : "";
    // should be called ONCE on rendering
    // get the selected option (if any) and save into state
    useEffect(function () {
        var dataField = props.dataField;
        if (dataField) {
            var data = getData(dataField);
            if (data && data.length > 0) {
                setSelectedOption(data);
            }
        }
        var petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");
        // 1094 = 2years + 364 days (1 year = 365 days)
        if (props.isCheckPetAge && petAgeOnStartDatePolicy > 1094) {
            setIsValidPetAge(false);
        }
        // Subscribe to data changes to update selectedOption when data changes externally
        var handleDataChange = function (dataPath, field, data) {
            if (dataField) {
                // Check if the changed field matches our dataField
                // dataPath could be "customCover.annualBenefitLimit" and dataField is "customCover.annualBenefitLimit"
                // or field could be "annualBenefitLimit" when dataField is "customCover.annualBenefitLimit"
                var matches = dataPath === dataField ||
                    field === dataField ||
                    dataPath.endsWith("." + dataField) ||
                    (dataField.includes(".") && field === dataField.split(".").pop());
                if (matches) {
                    // Read the latest value from store to ensure we have the correct value
                    var currentData = getData(dataField);
                    var newValue = currentData !== null && currentData !== undefined && currentData !== ""
                        ? currentData.toString()
                        : "";
                    // Update selectedOption with the latest value from store
                    setSelectedOption(newValue);
                }
            }
        };
        subscribeDataChange("Options_" + (props.dataField || ""), handleDataChange);
        return function () {
            unsubscribeDataChange("Options_" + (props.dataField || ""));
        };
    }, [props.dataField]);
    // track any changes to the state, and persist in the flow data store
    useEffect(function () {
        var _a;
        var dataField = (_a = props.dataField) !== null && _a !== void 0 ? _a : "";
        var data = getData(dataField);
        if (dataField &&
            selectedOption !== null &&
            selectedOption.length > 0 &&
            selectedOption !== data) {
            setData(dataField, selectedOption);
        }
    }, [selectedOption]);
    // if no option has been selected as yet - return no style
    // otherwise return either selected/unselected if the data value matches selectedOption
    function buttonSelected(dataValue) {
        if (!selectedOption) {
            return "";
        }
        return dataValue == selectedOption ? " selected " : " unselected ";
    }
    var isHilight = props.dataField === "customCover.annualBenefitLimit" && petAgeCategory > 0 ? true : false;
    var isRadioStacked = props.layout === OptionalLayout.RadioStacked;
    var isRadio = props.layout === OptionalLayout.RadioStacked || props.layout === OptionalLayout.RadioOneLine;
    return (React__default.createElement(React__default.Fragment, null, isValidPetAge && (React__default.createElement("div", { "data-testid": "Options", className: "".concat(isRadioStacked ? "align-left" : "", " ").concat(className, " ").concat(isAutoWidth ? "flc_options aw " : "flc_options " + (isReadOnly ? " readonly" : "")) },
        props.autoWidth,
        React__default.createElement("div", { className: isRadioStacked || isAutoWidth ? "d-block" : "d-flex" }, props.optionList != null &&
            props.optionList.map(function (item, index) {
                var _a;
                var elementListStyle = {
                    width: props.layout == "oneline" ? 100 / item.optionElements.length + "%" : "100%",
                };
                var randomId = Math.floor(Math.random() * (999 - 100 + 1)) + 100;
                var key = index.toString() + randomId.toString();
                return (React__default.createElement("div", { key: "op_div" + key, style: isRadioStacked
                        ? { width: "100%" }
                        : isAutoWidth
                            ? btnStyleAutoWidth
                            : btnStyle, className: "".concat(isRadio ? "radioDiv pb-1" : "buttonDiv pt-3 pb-3", " d-inline-flex") }, isRadio ? (React__default.createElement(RadioElement, { className: "radio-item ".concat(buttonSelected(item.dataValue)), text: (_a = item.optionElements[0].text) !== null && _a !== void 0 ? _a : "", onClick: function () { return setSelectedOption(item.dataValue); } })) : (React__default.createElement(Button$1, { key: "op_btn" + key, className: "default" +
                        (isHilight ? " hilight " : " ") +
                        buttonSelected(item.dataValue) +
                        layoutClass, value: item.dataValue, onClick: function () { return setSelectedOption(item.dataValue); } }, item.optionElements.map(function (optionElement, index) {
                    var mainText = optionElement.text;
                    var underText = "";
                    if (props.dataField === "customCover.annualBenefitLimit") {
                        switch (petAgeCategory) {
                            case 1:
                            case 2:
                                mainText = optionElement.text20;
                                underText = "Was " + (optionElement.text ? optionElement.text : "");
                                break;
                            case 3:
                            case 4:
                                mainText = optionElement.text10;
                                underText = "Was " + (optionElement.text ? optionElement.text : "");
                                break;
                        }
                    }
                    return (React__default.createElement(OptionElement, { key: "option_element" + index, style: elementListStyle, elementType: optionElement.elementType, text: mainText, textUnderline: underText, src: optionElement.src, buttonStyle: optionElement.buttonStyle, textAlign: optionElement.textAlign, petAgeCategory: props.dataField === "customCover.annualBenefitLimit" &&
                            petAgeCategory
                            ? petAgeCategory
                            : 0 }));
                })))));
            }))))));
}
function GetTextHtml(mainText, underLineText) {
    if (underLineText) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: "underlineItemLabel", dangerouslySetInnerHTML: {
                    __html: underLineText !== null && underLineText !== void 0 ? underLineText : "",
                } }),
            React__default.createElement("div", { className: "itemLabel", dangerouslySetInnerHTML: {
                    __html: mainText !== null && mainText !== void 0 ? mainText : "",
                } })));
    }
    else {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: "itemLabel", dangerouslySetInnerHTML: {
                    __html: mainText !== null && mainText !== void 0 ? mainText : "",
                } })));
    }
}
function OptionElement(props) {
    var elementTextAlign = props.textAlign == null ? "" : "text-" + props.textAlign;
    return (React__default.createElement("div", { className: "OptionElement " + elementTextAlign, style: props.style },
        props.elementType == "image" &&
            React__default.createElement(ReactSVG, {
                src: props.src == null ? "" : props.src,
                "data-testid": "Icon",
                className: "d-block btnIcon ",
            }),
        props.elementType == "text" && GetTextHtml(props.text, props.textUnderline),
        props.elementType == "button" && (React__default.createElement("div", { className: "innerButton " + props.buttonStyle }, props.text))));
}
function RadioElement(props) {
    return (React__default.createElement("div", { className: "".concat(props.className), onClick: props.onClick },
        React__default.createElement("div", { className: "d-flex" },
            React__default.createElement("div", { className: "radio-icon" }),
            React__default.createElement("label", null,
                props.text,
                " "))));
}

var AlignmentEnum;
(function (AlignmentEnum) {
    AlignmentEnum["left"] = "left";
    AlignmentEnum["right"] = "right";
    AlignmentEnum["center"] = "center";
})(AlignmentEnum || (AlignmentEnum = {}));

var css_248z$g = "body .flc_summary .summaryRow {\n  width: 100%;\n  border-bottom: 1px solid var(--flc_summary-border-color);\n  padding-top: var(--flc_summary-row-padding);\n  padding-bottom: var(--flc_summary-row-padding);\n  display: flex;\n  justify-content: space-between;\n}\nbody .flc_summary .summaryRow:last-child {\n  border-bottom: none;\n}\nbody .flc_summary .summaryRow:last-child .text-end.detail {\n  width: 70% !important;\n}\nbody .flc_summary .label {\n  color: var(--flc_summary-label-font-color);\n  display: block;\n  font-size: 1.25rem;\n}\nbody .flc_summary .detail {\n  display: block;\n  color: var(--flc_summary-detail-font-color);\n  font-weight: var(--flc_summary-detail-font-weight);\n  width: auto;\n  font-size: 1.25rem;\n}\nbody .flc_summary .detail span.new {\n  color: #21b07d;\n}\nbody .flc_summary .detail span.was {\n  color: rgba(58, 42, 128, 0.3);\n  padding-left: 0.5rem;\n  text-decoration: line-through;\n}";
styleInject(css_248z$g);

function Summary(props) {
    var _a, _b, _c;
    var _d = useFlowData(), getData = _d.getData, getDataFromArray = _d.getDataFromArray;
    var _e = useState(''), detailClassName = _e[0], setDetailClassName = _e[1];
    var _f = useState(0), promocodeDuration = _f[0], setPromocodeDuration = _f[1];
    var _g = useState(false), showPromocodeAtBottom = _g[0], setShowPromocodeAtBottom = _g[1];
    var currentPromoCode = (_a = getData("root.promoCode")) !== null && _a !== void 0 ? _a : "";
    var currentPromoCodeType = (_b = getData("root.promoCodeType")) !== null && _b !== void 0 ? _b : "";
    var selectedPromoCode = (_c = getData("root.selectedPromoCode")) !== null && _c !== void 0 ? _c : null;
    var labelColStyle = {
        width: props.labelColWidth + '%',
    };
    var detailColStyle = {
        width: 100 - props.labelColWidth + '%',
    };
    useEffect(function () {
        var checkPromoCodeBottom = props.summaryConfig.find(function (item) { return item.dataField === 'promoCodeBottom'; });
        if (checkPromoCodeBottom) {
            setShowPromocodeAtBottom(true);
        }
        if (props.dataAlignment != undefined) {
            if (props.dataAlignment == AlignmentEnum.center) {
                setDetailClassName('text-center');
            }
            if (props.dataAlignment == AlignmentEnum.left) {
                setDetailClassName('text-start');
            }
            if (props.dataAlignment == AlignmentEnum.right) {
                setDetailClassName('text-end');
            }
        }
        if (selectedPromoCode && currentPromoCodeType && currentPromoCodeType < 3) {
            if (currentPromoCodeType === 1) {
                setPromocodeDuration(0);
            }
            else {
                setPromocodeDuration(selectedPromoCode.period);
            }
        }
    }, []); // Only re-run the effect if count changes
    function getSummaryData(dataField, format) {
        var _a, _b, _c;
        var result = '';
        if (props.getDataFromArray) {
            result = getDataFromArray((_a = props.arrayDataField) !== null && _a !== void 0 ? _a : '', (_b = props.arrayKeyField) !== null && _b !== void 0 ? _b : '', (_c = props.arrayKey) !== null && _c !== void 0 ? _c : '', dataField);
        }
        else {
            result = getData(dataField);
        }
        if (dataField === "promoCode" && result === "MULTIPET") {
            return "";
        }
        else if (dataField === "customCover.annualBenefitLimit") {
            switch (props.petAgeCategory) {
                case 1:
                case 2:
                    return "<span class=\"new\">".concat(formatString(parseFloat(result) + (parseFloat(result) * 0.2), StringFormats.CurrencyNoCents), "</span><span class=\"was\">WAS ").concat(formatString(result, StringFormats.CurrencyNoCents), "</span>");
                case 3:
                case 4:
                    return "<span class=\"new\">".concat(formatString(parseFloat(result) + (parseFloat(result) * 0.1), StringFormats.CurrencyNoCents), "</span><span class=\"was\">WAS ").concat(formatString(result, StringFormats.CurrencyNoCents), "</span>");
                default:
                    if (format)
                        return formatString(result, format);
                    else
                        return result;
            }
            return result;
        }
        else if (format)
            return formatString(result, format);
        else
            return result;
    }
    return (React__default.createElement("div", { "data-testid": 'Summary', className: 'flc_summary' },
        currentPromoCode && showPromocodeAtBottom && React__default.createElement("div", { className: 'flc_coupon summary' },
            React__default.createElement("div", { className: "first-col" },
                React__default.createElement("div", { className: "img-wrapper" },
                    React__default.createElement("img", { src: "/images/promotion-code-icon.png" })),
                React__default.createElement("div", { className: "coupon-value-wrapper" },
                    React__default.createElement("span", null, (selectedPromoCode === null || selectedPromoCode === void 0 ? void 0 : selectedPromoCode.email) ? "Petsy corporate discount" :
                        ((currentPromoCode === null || currentPromoCode === void 0 ? void 0 : currentPromoCode.match(/^FNF\d+FREE$/)) ? "Petsy Perks for Pals" : currentPromoCode))))),
        (currentPromoCodeType && currentPromoCodeType < 3) && React__default.createElement("div", { className: 'promocode-duration' },
            "This discount applies for ",
            !promocodeDuration ? 'lifetime' : "".concat(promocodeDuration, " month ")),
        React__default.createElement("div", null, props.summaryConfig.map(function (item, index) {
            var data = item.dataField
                ? getSummaryData(item.dataField, item.format)
                : item.staticText;
            if (!item.showIfEmpty && (!data || data === '$0.00'))
                return '';
            if (item.dataField === 'totalAmounts.totalDiscountedByYear' && (!currentPromoCodeType || currentPromoCodeType > 2))
                return '';
            if (item.dataField === 'totalAmounts.totalInstallmentDiscountAmount' || item.minus) {
                data = "-" + data;
            }
            if (item.dataField === 'customCover.promoCode') {
                if (selectedPromoCode === null || selectedPromoCode === void 0 ? void 0 : selectedPromoCode.email) {
                    data = "Petsy corporate discount";
                }
                else if (currentPromoCode === null || currentPromoCode === void 0 ? void 0 : currentPromoCode.match(/^FNF\d+FREE$/)) {
                    data = "Petsy Perks for Pals";
                }
            }
            return (React__default.createElement("div", { key: 'flc_summary' + index, className: 'summaryRow' },
                React__default.createElement("div", { style: labelColStyle, className: 'label' }, item.label),
                React__default.createElement("div", { style: detailColStyle, className: detailClassName + ' detail', dangerouslySetInnerHTML: {
                        __html: data,
                    } })));
        }))));
}
var MemoizedSummary = React__default.memo(Summary, function (prevProps, nextProps) {
    // This stops re rendering regardless of the component when the props have changed.
    // If not memoized, it will re render on every mouse hover.
    return true;
});

var css_248z$f = "body .flc_info-box {\n  margin-top: var(--flc_infobox-margin);\n  margin-bottom: var(--flc_infobox-margin);\n  border: var(--flc_infobox-infoitem-border);\n  border-radius: var(--flc-border-radius);\n  padding: var(--flc_infobox-infoitem-padding);\n  color: var(--flc_infobox-infoitem-color);\n  display: flex;\n}\nbody .flc_info-box .flc_info-box_IconDiv {\n  display: flex;\n  width: 4rem;\n  max-width: 4rem;\n  max-height: 4rem;\n  border: none;\n  margin-right: 1rem;\n  position: relative;\n}\nbody .flc_info-box .flc_info-box_IconDiv .img {\n  width: 2.5rem;\n  height: 2.5rem;\n  border: none;\n  margin: auto;\n}\nbody .flc_info-box .flc_info-box_IconDiv .img svg {\n  width: 2.5rem;\n  max-height: 2.5rem;\n}\nbody .flc_info-box .flc_info-box_IconDiv .flc_icon {\n  width: var(--flc_infobox-infoitem-tick-size);\n  height: var(--flc_infobox-infoitem-tick-size);\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\nbody .flc_info-box .flc_info-box_Content {\n  display: block;\n  width: 100%;\n  font-size: var(--flc_infobox-infoitem--heading-size);\n}\nbody .flc_info-box .flc_info-box_Content .flc_info-box_Text {\n  font-size: var(--flc_infobox-infoitem--text-size);\n}\nbody .flc_info-box .flc_info-box_Heading {\n  display: block;\n  width: 100%;\n  color: var(--flc_infobox-infoitem--heading-color);\n  font-weight: var(--flc_infobox-infoitem--heading-weight);\n}\nbody .flc_info-box .flc_info-box_Text {\n  display: block;\n  width: 100%;\n}";
styleInject(css_248z$f);

function InfoBox(props) {
    var showTick = props.tickSrc != undefined && props.tick;
    return (React__default.createElement("div", { "data-testid": 'InfoBox', className: 'flc_info-box' },
        React__default.createElement("div", { className: 'flc_info-box_IconDiv' },
            React__default.createElement(ReactSVG, {
                className: 'img',
                src: props.icon,
            }),
            showTick.toString() == 'true' && (React__default.createElement(Icon, { size: IconSize.Custom, src: props.tickSrc == undefined ? '' : props.tickSrc, className: 'smallTickIcon', colorStyle: IconColorStyle.Success }))),
        React__default.createElement("div", { className: 'flc_info-box_Content' },
            React__default.createElement("div", { className: 'flc_info-box_Heading' }, props.heading),
            React__default.createElement("div", { className: 'flc_info-box_Text' }, props.text))));
}

var css_248z$e = "body .flc_option-toggle {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\nbody .flc_option-toggle .option {\n  display: inline-flex;\n  z-index: 10;\n  padding-top: 0.6em;\n  padding-bottom: 0.6em;\n}\nbody .flc_option-toggle .optionLabel {\n  margin: auto;\n  user-select: none;\n}\nbody .flc_option-toggle .switch {\n  width: 100%;\n  background: var(--flc_option-toggle-bg-color);\n  display: flex;\n  justify-content: flex-start;\n  border-radius: 2rem;\n  padding: var(--flc_option-toggle-handle-x-margin);\n  padding-top: var(--flc_option-toggle-handle-y-margin);\n  padding-bottom: var(--flc_option-toggle-handle-y-margin);\n  cursor: pointer;\n  position: relative;\n  color: var(--flc_option-toggle-text-non-selected);\n}\nbody .flc_option-toggle .switch .selected {\n  color: var(--flc_option-toggle-text);\n  -webkit-transition: color 0.5s;\n  -moz-transition: color 0.5s;\n  -ms-transition: color 0.5s;\n  -o-transition: color 0.5s;\n  transition: color 0.5s;\n}\nbody .flc_option-toggle .handleParent {\n  position: absolute;\n  width: calc(100% - var(--flc_option-toggle-handle-x-margin) * 2);\n  height: calc(100% - var(--flc_option-toggle-handle-y-margin) * 2);\n  display: block;\n  left: 0;\n  top: 0;\n  margin-left: var(--flc_option-toggle-handle-x-margin);\n  margin-right: var(--flc_option-toggle-handle-x-margin);\n  margin-top: var(--flc_option-toggle-handle-y-margin);\n  margin-bottom: var(--flc_option-toggle-handle-y-margin);\n}\nbody .flc_option-toggle .handle {\n  height: 100%;\n  background-color: var(--flc_option-toggle-hande-background);\n  border-radius: 2rem;\n  position: absolute;\n  z-index: 1;\n}\nbody .flc_option-toggle .switch.index1-2 .handle {\n  left: 0%;\n}\nbody .flc_option-toggle .switch.index2-2 .handle {\n  left: 50%;\n}\nbody .flc_option-toggle .switch.index1-3 .handle {\n  left: 0%;\n}\nbody .flc_option-toggle .switch.index2-3 .handle {\n  left: 33.3%;\n}\nbody .flc_option-toggle .switch.index3-3 .handle {\n  left: 66.6%;\n}\nbody .flc_option-toggle .switch.index1-4 .handle {\n  left: 0%;\n}\nbody .flc_option-toggle .switch.index2-4 .handle {\n  left: 25%;\n}\nbody .flc_option-toggle .switch.index3-4 .handle {\n  left: 50%;\n}\nbody .flc_option-toggle .switch.index4-4 .handle {\n  left: 75%;\n}";
styleInject(css_248z$e);

function OptionToggle(props) {
    var _a = useFlowData(), getData = _a.getData, setData = _a.setData;
    var _b = useState(String), selectedOption = _b[0], setSelectedOption = _b[1];
    var _c = useState(String), handleClass = _c[0], setHandleClass = _c[1];
    // should be called ONCE on rendering
    // get the selected option (if any) and save into state
    useEffect(function () {
        var dField = props.dataField;
        if (dField) {
            var data = getData(dField);
            if (data && data.length > 0) {
                setSelectedOption(data);
            }
        }
        if (selectedOption == null ||
            selectedOption == '' ||
            selectedOption.length == 0) {
            if (props.defaultOption !== undefined) {
                setSelectedOption(props.defaultOption);
                var index = props.optionToggleList.findIndex(function (x) { return x.value === props.defaultOption; });
                setHandleClass('index' +
                    (index + 1).toString() +
                    '-' +
                    props.optionToggleList.length.toString());
            }
            else {
                setSelectedOption(props.optionToggleList[0].value);
            }
        }
    }, []);
    // track any changes to the state, and persist in the flow data store
    useEffect(function () {
        var dataField = props.dataField;
        if (dataField) {
            setData(dataField, selectedOption.toString());
        }
        if (props.onChange && selectedOption) {
            props.onChange(selectedOption);
        }
    }, [selectedOption]);
    var spring = {
        type: '',
        stiffness: 700,
        damping: 30,
    };
    var optionDiv = {
        width: 100 / props.optionToggleList.length + '%',
    };
    var handleStyle = { width: 100 / props.optionToggleList.length + '%' };
    function clickSelection(index) {
        setHandleClass('index' +
            (index + 1).toString() +
            '-' +
            props.optionToggleList.length.toString());
        var sel = props.optionToggleList[index];
        setSelectedOption(sel.value);
    }
    function isSelected(index) {
        var sel = props.optionToggleList[index];
        if (sel.value == selectedOption) {
            return 'selected';
        }
        return '';
    }
    return (React__default.createElement("div", { "data-testid": 'OptionToggle', className: 'flc_option-toggle ' },
        React__default.createElement("div", { className: '' },
            React__default.createElement("div", { className: handleClass + ' switch' },
                props.optionToggleList.map(function (optionItem, index) {
                    return (React__default.createElement("div", { key: 'option_toggle' + index, style: optionDiv, className: isSelected(index) + ' option', onClick: function () { return clickSelection(index); } },
                        React__default.createElement("div", { className: 'optionLabel' }, optionItem.label)));
                }),
                React__default.createElement("div", { className: 'handleParent' },
                    React__default.createElement(motion.div, { className: 'handle', style: handleStyle, layout: true, transition: spring }))))));
}

var css_248z$d = "body .flc_tick-box {\n  display: flex;\n  padding-top: var(--flc_tick-box-padding-top-bottom);\n  padding-bottom: var(--flc_tick-box-padding-top-bottom);\n  padding-left: 0.5em;\n  border-radius: var(--flc-border-radius);\n}\nbody .flc_tick-box .tick-col {\n  width: var(--flc_tick-box-tick-col-width);\n  margin-right: 0.5rem;\n  display: block;\n  padding-top: 0.125rem;\n}\nbody .flc_tick-box .tick-col .tb-unticked {\n  color: var(--flc_tick-box-tick-circle-color);\n}\nbody .flc_tick-box .tick-col .tb-ticked {\n  color: var(--flc_tick-box-tick-background-color);\n}\nbody .flc_tick-box .tick-col .tb-ticked.success {\n  color: var(--flc_tick-box-tick-background-color-success);\n}\nbody .flc_tick-box .tick-col .tb-ticked.warning {\n  color: var(--flc_tick-box-tick-background-color-warning);\n}\nbody .flc_tick-box .tick-col .tb-ticked.info {\n  color: var(--flc_tick-box-tick-background-color-info);\n}\nbody .flc_tick-box .tick-col .tb-ticked.offer {\n  color: var(--flc_tick-box-tick-background-color-offer);\n}\nbody .flc_tick-box .label-col {\n  width: 100%;\n  user-select: none;\n}\nbody .flc_tick-box .label-col a {\n  font-weight: var(--flc_tick-box-label-link-font-weight);\n  text-decoration: var(--flc_tick-box-label-link);\n}\nbody .flc_tick-box .label-col a:hover {\n  text-decoration: underline;\n}\nbody .flc_tick-box .checkbox-wrapper-33 {\n  --s-xsmall: 0.625em;\n  --s-small: 1.2em;\n  --border-width: 1px;\n  --c-primary: #5f11e8;\n  --c-primary-20-percent-opacity: rgb(95 17 232 / 20%);\n  --c-primary-10-percent-opacity: rgb(95 17 232 / 10%);\n  --t-base: 0.4s;\n  --t-fast: 0.2s;\n  --e-in: ease-in;\n  --e-out: cubic-bezier(0.11, 0.29, 0.18, 0.98);\n}\nbody .flc_tick-box .checkbox-wrapper-33 .visuallyhidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox + .checkbox {\n  margin-top: var(--s-small);\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__symbol {\n  display: inline-block;\n  display: flex;\n  margin-right: calc(var(--s-small) * 0.7);\n  margin-top: 0.3rem;\n  border: var(--border-width) solid var(--c-primary);\n  position: relative;\n  border-radius: 0.2em;\n  width: 1.3rem;\n  height: 1.3rem;\n  transition: box-shadow var(--t-base) var(--e-out), background-color var(--t-base);\n  box-shadow: 0 0 0 0 var(--c-primary-10-percent-opacity);\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__symbol:after {\n  content: \"\";\n  position: absolute;\n  top: 0.5em;\n  left: 0.5em;\n  width: 0.25em;\n  height: 0.25em;\n  background-color: var(--c-primary-20-percent-opacity);\n  opacity: 0;\n  border-radius: 3em;\n  transform: scale(1);\n  transform-origin: 50% 50%;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox .icon-checkbox {\n  width: 0.7rem;\n  height: 0.7rem;\n  margin: auto;\n  fill: none;\n  stroke-width: 3;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-miterlimit: 10;\n  color: var(--c-primary);\n  display: inline-block;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox .icon-checkbox path {\n  transition: stroke-dashoffset var(--t-fast) var(--e-in);\n  stroke-dasharray: 30px, 31px;\n  stroke-dashoffset: 31px;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__textwrapper {\n  margin: 0;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__trigger:checked + .checkbox__symbol:after {\n  -webkit-animation: ripple-33 1.5s var(--e-out);\n  animation: ripple-33 1.5s var(--e-out);\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__trigger:checked + .checkbox__symbol .icon-checkbox path {\n  transition: stroke-dashoffset var(--t-base) var(--e-out);\n  stroke-dashoffset: 0px;\n}\nbody .flc_tick-box .checkbox-wrapper-33 .checkbox__trigger:focus + .checkbox__symbol {\n  box-shadow: 0 0 0 0.25em var(--c-primary-20-percent-opacity);\n}\n@-webkit-keyframes ripple-33 {\n  from {\n    transform: scale(0);\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: scale(5);\n  }\n}\n@keyframes ripple-33 {\n  from {\n    transform: scale(0);\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: scale(5);\n  }\n}\nbody .flc_tick-box:hover {\n  cursor: pointer;\n  background-color: var(--flc_tick-box-tick-background-color-hover);\n}";
styleInject(css_248z$d);

function TickBox(props) {
    var _a;
    var _b = useFlowData(), getData = _b.getData, setData = _b.setData;
    var _c = useState(false), selected = _c[0], setSelected = _c[1];
    // should be called ONCE on rendering
    // get the selected option (if any) and save into state
    useEffect(function () {
        var dField = props.dataField;
        if (dField) {
            var data = getData(dField);
            if (data != undefined) {
                setSelected(data);
            }
        }
    }, []);
    useEffect(function () {
        var dField = props.dataField;
        if (dField) {
            setData(dField, selected);
        }
        if (props.onChange)
            props.onChange(selected);
    }, [selected]);
    function toggleSelected() {
        // console.log("toggleSelected");
        setSelected(function (prev) { return !prev; });
    }
    // Hàm xử lý sự kiện cho input để ngăn sự kiện bubbling
    function handleInputChange(e) {
        // Ngăn sự kiện bubbling lên phần tử cha
        e.stopPropagation();
        toggleSelected();
    }
    return (React__default.createElement("div", { "data-testid": 'TickBox', className: 'flc_tick-box' + (props.className ? ' ' + props.className : ''), onClick: toggleSelected },
        React__default.createElement("div", { className: 'tick-col', onClick: function (e) { return e.stopPropagation(); } },
            React__default.createElement("div", { className: "checkbox-wrapper-33" },
                React__default.createElement("label", { className: "checkbox" },
                    React__default.createElement("input", { className: "checkbox__trigger visuallyhidden", type: "checkbox", checked: selected, onChange: handleInputChange, onClick: function (e) { return e.stopPropagation(); } }),
                    React__default.createElement("span", { className: "checkbox__symbol" },
                        React__default.createElement("svg", { "aria-hidden": "true", className: "icon-checkbox", width: "28px", height: "28px", viewBox: "0 0 28 28", version: "1", xmlns: "http://www.w3.org/2000/svg" },
                            React__default.createElement("path", { d: "M4 14l8 7L24 7" })))))),
        props.labelHTML && (React__default.createElement("div", { className: 'label-col', dangerouslySetInnerHTML: {
                __html: (_a = props.labelHTML) !== null && _a !== void 0 ? _a : '',
            } })),
        props.children && props.children));
}

var css_248z$c = "body .flc_labelled-icons {\n  display: flex;\n}\nbody .flc_labelled-icons .flc_icon {\n  margin-bottom: var(--flc_labelled-icons-margin-bottom);\n}\nbody .flc_labelled-icons a.labelLink {\n  text-decoration: var(--flc_labelled-icons-link-text-decoration);\n}\nbody .flc_labelled-icons div.strong {\n  font-weight: var(--flc_labelled-icons-text-strong);\n}";
styleInject(css_248z$c);

function LabelledIcons(props) {
    var divStyle = {
        width: 100 / props.laballedIconList.length + '%',
    };
    return (React__default.createElement("div", { "data-testid": 'LabelledIcons', className: 'flc_labelled-icons' }, props.laballedIconList &&
        props.laballedIconList.map(function (label, index) {
            return (React__default.createElement("div", { key: 'labeled-icon' + index, style: divStyle, className: label.className },
                React__default.createElement(Icon, { src: label.src, colorStyle: label.iconStyle, size: label.iconSize }),
                React__default.createElement("br", null),
                React__default.createElement("a", { className: 'labelLink', href: label.hrefLink }, label.label)));
        })));
}

var css_248z$b = "body .flc_text-block .tip-link {\n  text-decoration-style: dashed;\n  text-decoration-thickness: 1px;\n  cursor: help;\n}\nbody .text-block-test-span {\n  background-color: greenyellow;\n}";
styleInject(css_248z$b);

// TODO: Support injection of flow data.
/*
  TextBlock displays a block of text inside a <p> tag and allows normal links,
  help tips, and spans with custom classes to be added.

  Normal link: |*link text|link|http://somelink*|
  Help tip: |*link text|tip|nameOfTheHelpTip*|
  Span: |*span text|span|class-name*|

  Example:
  {
    "type": "TextBlock",
    "props": {
      "className": "text-start",
      "text": "|*You|tip|breedsTip*| understand |*and|link|https://somelink*| have |*complied|span|someclass*| with |*Your Duty to take reasonable care not to make a misrepresentation|tip|misrepresentation*|. A misrepresentation includes |*a statement|span|text-block-test-span*| that is false, partially false, or which does not fairly reflect the truth."
    }
  }
*/
function TextBlock(props) {
    var _a = React__default.useState(false), showTipWindow = _a[0], setShowTipWindow = _a[1];
    var _b = React__default.useState(), activeTipItem = _b[0], setActiveTipItem = _b[1];
    var handleCloseTipWindow = function () { return setShowTipWindow(false); };
    var tips = getFlowHelpTips();
    function injectLinks(input) {
        var result = [];
        var currentIndex = 0;
        if (input.indexOf('|*') >= 0) {
            var fieldNames = lodashUtils.words(input, /\|\*(.*?)\*\|/g); // |* *|}
            fieldNames.forEach(function (element, elementNo) {
                var elementIndex = input.indexOf(element, currentIndex);
                if (elementIndex > 0)
                    // Text before the first element
                    result.push({
                        text: input.substring(currentIndex, elementIndex),
                        type: '',
                        data: '',
                    });
                var elementSplit = element.slice(2, -2).split('|');
                if (elementSplit.length === 3) {
                    var linkText = elementSplit[0];
                    var type = elementSplit[1];
                    var data = elementSplit[2];
                    result.push({
                        text: linkText,
                        type: type,
                        data: data,
                    });
                }
                else {
                    result.push({
                        text: element,
                        type: '',
                        data: '',
                    });
                }
                currentIndex = elementIndex + element.length;
            });
        }
        if (currentIndex < input.length)
            // Text after the last element
            result.push({
                text: input.substring(currentIndex),
                type: '',
                data: '',
            });
        return result;
    }
    function TipLink(props) {
        return (React__default.createElement("a", { href: '', className: 'tip-link', onClick: function (e) {
                e.preventDefault();
                setActiveTipItem(lodashUtils.get(tips, props.tipName));
                setShowTipWindow(true);
            } }, props.text));
    }
    function NormalLink(props) {
        return (React__default.createElement("a", { href: props.url, target: '_blank' }, props.text));
    }
    function Span(props) {
        return React__default.createElement("span", { className: props.className }, props.text);
    }
    var injectedArray = React__default.useMemo(function () { return injectLinks(props.text); }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("p", { "data-testid": 'TextBlock', className: 'flc_text-block' + (props.className ? ' ' + props.className : '') }, injectedArray.map(function (item, index) {
            var _a, _b, _c;
            if (item.type.toLowerCase() === 'tip')
                return (React__default.createElement(TipLink, { key: 'tip_link' + index, text: item.text, tipName: (_a = item.data) !== null && _a !== void 0 ? _a : '' }));
            else if (item.type.toLowerCase() === 'link')
                return (React__default.createElement(NormalLink, { key: 'normal_link' + index, text: item.text, url: (_b = item.data) !== null && _b !== void 0 ? _b : '' }));
            else if (item.type.toLowerCase() === 'span')
                return (React__default.createElement(Span, { key: 'span' + index, text: item.text, className: (_c = item.data) !== null && _c !== void 0 ? _c : '' }));
            else
                return item.text;
        })),
        React__default.createElement(Offcanvas, { show: showTipWindow, onHide: handleCloseTipWindow }, activeTipItem)));
}

var flowComponentsList = [
    { name: 'CountryPicker', type: CountryPicker },
    { name: 'DateRangePicker', type: DateRangePicker },
    { name: 'AgePicker', type: AgePicker },
    { name: 'NextButton', type: NextButton },
    { name: 'BackButton', type: BackButton },
    { name: 'Tip', type: Tip },
    { name: 'FlowForm', type: FlowForm },
    { name: 'Summary', type: Summary },
    { name: 'Options', type: Options },
    { name: 'InfoList', type: InfoList },
    { name: 'Heading', type: Heading },
    { name: 'InfoBox', type: InfoBox },
    { name: 'OptionToggle', type: OptionToggle },
    { name: 'TickBox', type: TickBox },
    { name: 'LabelledIcons', type: LabelledIcons },
    { name: 'TextBlock', type: TextBlock },
];
// Gets the Flow component type given it's string name
function getFlowComponentType(name) {
    var _a;
    return (_a = flowComponentsList.find(function (element) { return element.name === name; })) === null || _a === void 0 ? void 0 : _a.type;
}

var css_248z$a = "body .flc_flow-step {\n  font-size: 1rem;\n  max-width: 720px;\n  margin: auto !important;\n  width: 100%;\n}";
styleInject(css_248z$a);

// The container for a step in a flow.  It renders flow components from the passed json.
// Properties:
//   flowStep?: FlowTypes.IFlowStep;
//   children?: React.ReactNode;
function FlowStep(props) {
    var _a, _b, _c, _d;
    var _e = useFlowData(), getData = _e.getData, injectData = _e.injectData;
    var flowControls = (_a = props.flowStep) === null || _a === void 0 ? void 0 : _a.flowControls;
    var hasTitleCondition = ((_b = props.flowStep) === null || _b === void 0 ? void 0 : _b.titleCondition) != undefined;
    // Adds an instance of a Flow component from the given flowControl json
    function AddComponent(flowControl, key) {
        var _a, _b, _c;
        // Checks the flow component list and the additionalComponents list for a component
        function getComponent(typeName) {
            var _a;
            // First check inbuilt flow components
            var result = getFlowComponentType(typeName);
            if (result)
                return result;
            // Next check the additionalComponents list
            if (props.additionalComponents) {
                result = (_a = props.additionalComponents.find(function (element) { return element.name === typeName; })) === null || _a === void 0 ? void 0 : _a.type;
            }
            return result;
        }
        // Plain html components
        var htmlElements = ["h1", "h2", "h3", "h4", "p", "div", "a", "img"];
        if (htmlElements.includes(flowControl.type)) {
            if (flowControl.type == "img") {
                return React.createElement(flowControl.type, __assign({ key: "fc_" + key }, flowControl.props));
            }
            else {
                return React.createElement(flowControl.type, __assign({ key: "fc_" + key, dangerouslySetInnerHTML: {
                        __html: injectData((_a = flowControl.content) !== null && _a !== void 0 ? _a : ""),
                    } }, flowControl.props));
            }
        }
        else {
            // Flow components
            return React.createElement(getComponent(flowControl.type), __assign(__assign({ key: "fc_" + key }, flowControl.props), { stepSlug: (_b = props.flowStep) === null || _b === void 0 ? void 0 : _b.slug, step: props.flowStep, dataField: flowControl.dataField, data: getData((_c = flowControl.dataField) !== null && _c !== void 0 ? _c : ""), disabled: !props.isValid, helperText: props.helperText }), flowControl.content);
        }
    }
    function getTopMarginClass() {
        var _a, _b;
        if ((_a = props.flowStep) === null || _a === void 0 ? void 0 : _a.showBreadCrumbs) {
            return " flc_bread-crumbs-flow-step-margin-top";
        }
        else if ((_b = props.flowStep) === null || _b === void 0 ? void 0 : _b.showBackButton) {
            return " flc_back-button-flow-step-margin-top";
        }
        else
            return "";
    }
    function getTitle() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (((_a = props.flowStep) === null || _a === void 0 ? void 0 : _a.titleCondition) == undefined)
            return (_c = (_b = props.flowStep) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : "";
        var field = (_d = props.flowStep) === null || _d === void 0 ? void 0 : _d.titleCondition.split("==");
        if (field.length == 1)
            return (_f = (_e = props.flowStep) === null || _e === void 0 ? void 0 : _e.titleOptionTrue) !== null && _f !== void 0 ? _f : "";
        var field1 = field[0] ? field[0].trim() : field[0];
        var field2 = field[1] ? field[1].trim() : field[1];
        var fieldData = "";
        if (field1.indexOf("{") > -1) {
            fieldData = getFlowDataDirect(field1.slice(1, -1).toString());
        }
        if (fieldData == undefined || fieldData == null)
            return "";
        if (parseFloat(fieldData) == parseFloat(field2))
            return (_h = (_g = props.flowStep) === null || _g === void 0 ? void 0 : _g.titleOptionTrue) !== null && _h !== void 0 ? _h : "";
        else
            return (_k = (_j = props.flowStep) === null || _j === void 0 ? void 0 : _j.titleOptionFalse) !== null && _k !== void 0 ? _k : "";
    }
    // Return the built flow step
    return (React.createElement(Container, { fluid: "sm", "data-testid": "FlowStep", className: "flc_flow-step" + getTopMarginClass() },
        React.createElement(Row, null,
            React.createElement(Col, null,
                (React.createElement("h1", { className: (_c = props.flowStep) === null || _c === void 0 ? void 0 : _c.className, dangerouslySetInnerHTML: {
                        __html: hasTitleCondition ? injectData((_d = getTitle()) !== null && _d !== void 0 ? _d : "") : React.useMemo(function () { var _a; return injectData((_a = getTitle()) !== null && _a !== void 0 ? _a : ""); }, []),
                    } })),
                flowControls &&
                    flowControls.map(function (flowControl, controlIndex) {
                        return AddComponent(flowControl, controlIndex);
                    }),
                props.children))));
}

function getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
function getAFXProfile() {
    var a = "afx_profile";
    a = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(a).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    return a ? (a = JSON.parse(a), a.acid) : "(not set)";
}
// Executes the given async function with a timeout.
// From https://advancedweb.hu/how-to-add-timeout-to-a-promise-in-javascript/
// Usage
/*
    const timeoutError = Symbol();
    try {
      const result = await timeout(prom, 1000, timeoutError);
      // handle result
    }catch (e) {
      if (e === timeoutError) {
        // handle timeout
      }else {
        // other error
        throw e;
      }
    }
*/
var timeout = function (prom, time, exception) {
    var timer;
    return Promise.race([
        prom,
        new Promise(function (_r, rej) { return (timer = setTimeout(rej, time, exception)); }),
    ]).finally(function () { return clearTimeout(timer); });
};

function logEvent(event, logDataStoreContents, message, requestJson, responseJson) {
    return __awaiter(this, void 0, void 0, function () {
        var clientDateTime, dataStoreJson, url, eventLog, pets, holderDOB, sendQuoteAgreeToBeContacted, fdclid, petsData_1, passDatas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clientDateTime = moment().format("YYYY-MM-DD hh:mm:ss");
                    dataStoreJson = getFlowPathData();
                    url = getFlowCache("appConfig.flowTelemetryEndpoint");
                    eventLog = {};
                    if (["save-quote-fields"].includes(event)) {
                        url += "?q=".concat(event);
                        pets = dataStoreJson.pets, holderDOB = dataStoreJson.holderDOB, sendQuoteAgreeToBeContacted = dataStoreJson.sendQuoteAgreeToBeContacted, fdclid = dataStoreJson.fdclid;
                        petsData_1 = [];
                        pets.forEach(function (pet) {
                            var _a;
                            var petData = {
                                id: pet.id,
                                isDesexed: pet.isDesexed,
                                policyNumber: (_a = pet.policyNumber) !== null && _a !== void 0 ? _a : null,
                            };
                            petsData_1.push(petData);
                        });
                        passDatas = {
                            pets: petsData_1,
                            holderDOB: holderDOB ? holderDOB : "",
                            sendQuoteAgreeToBeContacted: sendQuoteAgreeToBeContacted,
                            AdfixusDeviceID: message,
                            Channel: "PetsyQT",
                            fdclid: fdclid,
                        };
                        dataStoreJson = logDataStoreContents ? JSON.stringify(passDatas) : undefined;
                        eventLog = {
                            sessionId: getFlowDataDirect("sessionId"),
                            dataStoreJson: dataStoreJson,
                        };
                    }
                    else {
                        dataStoreJson = logDataStoreContents ? JSON.stringify(dataStoreJson) : undefined;
                        eventLog = {
                            sessionId: getFlowDataDirect("sessionId"),
                            clientDateTime: clientDateTime,
                            event: event,
                            message: message,
                            dataStoreJson: dataStoreJson,
                            requestJson: JSON.stringify(requestJson),
                            responseJson: JSON.stringify(responseJson),
                        };
                    }
                    return [4 /*yield*/, logToEndpoint(url, eventLog)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function logToEndpoint(url, params) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: "POST",
                        mode: "cors",
                        credentials: "same-origin",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json", // Your headers
                        },
                        body: JSON.stringify(params),
                    })
                        .then(function (returnedData) {
                        result = returnedData;
                    })
                        .catch(function (err) {
                        console.error("flow-logger logToEndpoint() error", err);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function getSavedQuote(quoteId) {
    return __awaiter(this, void 0, void 0, function () {
        var result, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFlowCache("appConfig.flowTelemetryEndpoint") + "?q=saved-quote&quoteNo=" + quoteId;
                    return [4 /*yield*/, fetch(url, {
                            // await fetch(url, {
                            method: "GET",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json", // Your headers
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    console.log("HTTP-Error: " + response);
                    alert("HTTP-Error: " + response.status);
                    _a.label = 4;
                case 4: return [2 /*return*/, result];
            }
        });
    });
}
function sendSms(params) {
    return __awaiter(this, void 0, void 0, function () {
        var result, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFlowCache("appConfig.flowTelemetryEndpoint") + "?q=send-sms";
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json", // Your headers
                            },
                            body: JSON.stringify(params),
                        })
                            .then(function (returnedData) {
                            result = returnedData;
                        })
                            .catch(function (err) {
                            console.error("flow-logger sendSms() error", err);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function sendKlaviyoEvent(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFlowCache("appConfig.flowTelemetryEndpoint") + "?q=klaviyo";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(params),
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response.json()]; // trả về response để sử dụng sau
                case 3:
                    err_1 = _a.sent();
                    console.error("flow-logger sendKlaviyoEvent() error", err_1);
                    throw err_1; // ném lỗi ra ngoài để có thể bắt lỗi từ hàm gọi
                case 4: return [2 /*return*/];
            }
        });
    });
}
function checkQuoteExpired(params) {
    return __awaiter(this, void 0, void 0, function () {
        var result, url;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFlowCache("appConfig.flowTelemetryEndpoint") + "?q=check-quote-expired";
                    console.log("quoteFoundAndLoaded 0.2: ", params);
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json", // Your headers
                            },
                            body: JSON.stringify(params),
                        })
                            .then(function (returnedData) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, returnedData.json()];
                                    case 1:
                                        result = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (err) {
                            console.error("flow-logger checkQuoteExpired() error", err);
                            return null;
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function saveCountVisit(params) {
    return __awaiter(this, void 0, void 0, function () {
        var result, url;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFlowCache("appConfig.flowTelemetryEndpoint") + "?q=counter-visits";
                    // console.log("quoteFoundAndLoaded 0.2: ", params);
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json", // Your headers
                            },
                            body: JSON.stringify(params),
                        })
                            .then(function (returnedData) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, returnedData.json()];
                                    case 1:
                                        result = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (err) {
                            console.error("flow-logger saveCountVisit() error", err);
                            return null;
                        })];
                case 1:
                    // console.log("quoteFoundAndLoaded 0.2: ", params);
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function getSavedCover(sdid) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(getFlowCache("appConfig.flowTelemetryEndpoint"), "?q=saved-cover&id=").concat(sdid);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: "GET",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok || response.status === 204) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, response.json()]; // trả về response để sử dụng sau
                case 3:
                    err_2 = _a.sent();
                    console.error("flow-logger getSavedCover() error", err_2);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getPromotionCode(code) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(getFlowCache("appConfig.flowTelemetryEndpoint"), "?q=promotion&code=").concat(code, "&channel=PetsyQT");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: "GET",
                            mode: "cors",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok || response.status === 204) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, response.json()]; // trả về response để sử dụng sau
                case 3:
                    err_3 = _a.sent();
                    console.error("flow-logger getPromotionCode() error", err_3);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}

var css_248z$9 = "";
styleInject(css_248z$9);

var css_248z$8 = "body .flc_flow-footer {\n  max-width: 720px;\n  margin: auto;\n  padding: 0 4rem;\n}\nbody .flc_flow-footer .ts-and-cs-p {\n  font-family: var(--fine-print-font-name);\n  font-size: 0.75rem;\n  margin: 1rem 0 1rem 0;\n  margin-right: auto;\n  margin-left: auto;\n  text-align: left;\n  color: var(--flc-petsy-text-primary);\n  width: 100%;\n}\nbody .flc_flow-footer .hr-separator {\n  opacity: 0.5;\n  margin-bottom: 4rem;\n  margin-top: 1rem;\n  margin-right: -3rem;\n  margin-left: -3rem;\n}\nbody .flc_flow-footer .elementor-widget-container {\n  margin-bottom: 2rem;\n  max-height: 80px;\n  margin-left: auto;\n  margin-right: auto;\n}";
styleInject(css_248z$8);

function FlowFooter(props) {
    return (React.createElement(AnimatePresence, null,
        React.createElement(motion.div, { "data-testid": "FlowFooter", className: "flc_flow-footer" },
            React.createElement("div", { className: "hr-separator" },
                React.createElement("hr", null)),
            props.termsAndConditions &&
                props.termsAndConditions.map(function (tc, index) {
                    var _a;
                    return (React.createElement("div", { key: index, className: "ts-and-cs-p", dangerouslySetInnerHTML: {
                            __html: (_a = tc.text) !== null && _a !== void 0 ? _a : "",
                        } }));
                }),
            React.createElement("p", { className: "ts-and-cs-p text-left pb-3 px-0" },
                "Petsy Flow v",
                props.appVersion),
            React.createElement("div", { className: "elementor-widget-container" },
                React.createElement("iframe", { src: "https://lp.petsy.com.au/if/default?bg=FFFFFF&badge=000000", width: "100%", height: "60px", className: "dava-iframe", title: "dava zmysel iframe", "data-lf-yt-playback-inspected-ywvko4xm2kbaz6bj": "true", "data-lf-vimeo-playback-inspected-ywvko4xm2kbaz6bj": "true" })))));
}

// Thư viện theo dõi Petsy
var PetsyTracker = /** @class */ (function () {
    function PetsyTracker(config) {
        if (config === void 0) { config = {}; }
        this.apiUrl = config.apiUrl || "https://api.staging.petsy.com.au/petsy";
        this.apiKey = config.apiKey || "";
        this.source = config.source || "Petsy";
        this.defaultEvent = config.defaultEvent || "Clicked_Get_Started";
        this.profile = {
            email: config.email || "",
            firstName: config.firstName || "",
            lastName: config.lastName || "",
            phoneNumber: config.phoneNumber || "",
            address1: config.address1 || "",
            address2: config.address2 || "",
            suburb: config.suburb || "",
            state: config.state || "",
            postcode: config.postcode || "",
            adfixusID: config.adfixusID || "",
            sessionRewindUrl: config.sessionRewindUrl || "",
        };
        this.journey = {
            url: window.location.origin,
            landingUrl: config.landingUrl || window.location.pathname,
            sessionId: config.sessionId || this.generateSessionId(),
        };
        this.eventData = {};
        // Thiết lập theo dõi điều hướng
        if (config.isRunNavigationTracking) {
            this.setupNavigationTracking();
        }
    }
    // Tạo session ID duy nhất
    PetsyTracker.prototype.generateSessionId = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    // Cập nhật dữ liệu hồ sơ
    PetsyTracker.prototype.updateProfile = function (data) {
        this.profile = __assign(__assign({}, this.profile), data);
    };
    PetsyTracker.prototype.getProfile = function () {
        return this.profile;
    };
    /**
     * Lấy Session Rewind replay URL từ window.sessionRewind.getSessionUrl (callback hoặc đồng bộ)
     * và ghi vào profile. Retry ngắn nếu SDK chưa sẵn sàng.
     */
    PetsyTracker.prototype.syncSessionRewindUrlFromWindow = function () {
        var _this = this;
        var retries = 0;
        var maxRetries = 150;
        var delayMs = 400;
        var tryBind = function () {
            var sr = window.sessionRewind;
            var getSessionUrl = sr === null || sr === void 0 ? void 0 : sr.getSessionUrl;
            if (typeof getSessionUrl !== "function") {
                if (retries < maxRetries) {
                    retries += 1;
                    setTimeout(tryBind, delayMs);
                }
                return;
            }
            if (getSessionUrl.length > 0) {
                try {
                    getSessionUrl(function (sessionUrl) {
                        if (sessionUrl && typeof sessionUrl === "string" && sessionUrl.trim()) {
                            _this.updateProfile({ sessionRewindUrl: sessionUrl });
                        }
                    });
                }
                catch (_a) {
                    if (retries < maxRetries) {
                        retries += 1;
                        setTimeout(tryBind, delayMs);
                    }
                }
                return;
            }
            try {
                var syncUrl = getSessionUrl();
                if (syncUrl && String(syncUrl).trim()) {
                    _this.updateProfile({ sessionRewindUrl: String(syncUrl) });
                }
                else if (retries < maxRetries) {
                    retries += 1;
                    setTimeout(tryBind, delayMs);
                }
            }
            catch (_b) {
                if (retries < maxRetries) {
                    retries += 1;
                    setTimeout(tryBind, delayMs);
                }
            }
        };
        tryBind();
    };
    // Cập nhật dữ liệu hành trình
    PetsyTracker.prototype.updateJourney = function (data) {
        this.journey = __assign(__assign({}, this.journey), data);
    };
    /**
     * Nếu SDK đã sẵn sàng, thử getSessionUrl() đồng bộ (không tham số) để kịp đưa URL vào payload.
     */
    PetsyTracker.prototype.refreshSessionRewindUrlSyncIfPossible = function () {
        var _a;
        if ((_a = this.profile.sessionRewindUrl) === null || _a === void 0 ? void 0 : _a.trim()) {
            return;
        }
        var sr = window.sessionRewind;
        var getSessionUrl = sr === null || sr === void 0 ? void 0 : sr.getSessionUrl;
        if (typeof getSessionUrl !== "function" || getSessionUrl.length > 0) {
            return;
        }
        try {
            var syncUrl = getSessionUrl();
            if (syncUrl && String(syncUrl).trim()) {
                this.updateProfile({ sessionRewindUrl: String(syncUrl) });
            }
        }
        catch (_b) {
            /* ignore */
        }
    };
    // Loại bỏ các trường rỗng khỏi profile (sessionRewindUrl luôn giữ — kể cả "" — để không mất key trên API)
    PetsyTracker.prototype.removeEmptyFields = function (profile) {
        var cleanedProfile = {};
        Object.entries(profile).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key === "sessionRewindUrl") {
                cleanedProfile.sessionRewindUrl =
                    value !== undefined && value !== null && typeof value === "string" ? value : "";
                return;
            }
            if (value !== undefined && value !== null && value !== "") {
                cleanedProfile[key] = value;
            }
        });
        return cleanedProfile;
    };
    // Gửi sự kiện theo dõi đến API
    PetsyTracker.prototype.trackEvent = function (eventName, customEventData, routerLocation) {
        if (eventName === void 0) { eventName = this.defaultEvent; }
        if (customEventData === void 0) { customEventData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var cleanedProfile, id, EVENT_URL_MAP, key, eventsNeedId, pathname, search, payload, headers, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refreshSessionRewindUrlSyncIfPossible();
                        cleanedProfile = this.removeEmptyFields(this.profile);
                        id = customEventData.id;
                        console.log("customEventData: ", customEventData);
                        EVENT_URL_MAP = {
                            Initial_Page: "/step-1",
                            Clicked_Get_Started: "/step-1",
                            Provided_Name_breed: "/edit-cover-1/",
                            Provided_dob_sex: "/edit-cover-2/",
                            Provided_Policy_date: "/edit-cover-3/",
                            Custom_Cover_Details: "/custom-cover/",
                            Customer_Full_Details: "/step-3",
                            Step_5: "/step-5",
                            PURCHASED: "/success",
                        };
                        if (eventName in EVENT_URL_MAP) {
                            key = eventName;
                            eventsNeedId = [
                                "Provided_Name_breed",
                                "Provided_dob_sex",
                                "Provided_Policy_date",
                                "Custom_Cover_Details",
                            ];
                            if (eventName === "Initial_Page") {
                                pathname = routerLocation !== undefined ? routerLocation.pathname : window.location.pathname;
                                search = routerLocation !== undefined ? routerLocation.search : window.location.search;
                                this.journey.url = window.location.origin + pathname + search;
                                this.journey.landingUrl = pathname;
                            }
                            else if (eventName === "Clicked_Get_Started") {
                                this.journey.url = window.location.origin + this.journey.landingUrl;
                            }
                            else if (eventName === "PURCHASED") {
                                this.journey.url =
                                    window.location.origin + EVENT_URL_MAP[key] + "?id=" + this.journey.sessionId;
                            }
                            else {
                                this.journey.url =
                                    window.location.origin +
                                        EVENT_URL_MAP[key] +
                                        (eventsNeedId.includes(eventName) ? id : "");
                            }
                        }
                        payload = {
                            source: this.source,
                            event: eventName,
                            profile: cleanedProfile,
                            journey: {
                                url: this.journey.url,
                                landingUrl: this.journey.landingUrl,
                                sessionId: this.journey.sessionId,
                            },
                            eventData: customEventData,
                        };
                        console.log("this.apiKey", this.apiKey);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        headers = {
                            "Content-Type": "application/json",
                        };
                        if (this.apiKey) {
                            headers["x-api-key"] = this.apiKey;
                        }
                        return [4 /*yield*/, fetch(this.apiUrl, {
                                method: "POST",
                                headers: headers,
                                body: JSON.stringify(payload),
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("L\u1ED7i HTTP! tr\u1EA1ng th\u00E1i: ".concat(response.status));
                        }
                        console.log("Gửi sự kiện theo dõi thành công:", eventName);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Lỗi khi gửi sự kiện theo dõi:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Thiết lập theo dõi điều hướng cho ứng dụng SPA
    PetsyTracker.prototype.setupNavigationTracking = function () {
        var _this = this;
        // Ghi đè history.pushState để theo dõi điều hướng trong SPA
        var pushState = history.pushState;
        history.pushState = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            pushState.apply(history, args);
            _this.trackEvent("Page_Navigated", {
                landingPage: window.location.pathname,
            });
        };
        // Ghi đè history.replaceState để hoàn thiện
        var replaceState = history.replaceState;
        history.replaceState = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            replaceState.apply(history, args);
            _this.trackEvent("Page_Navigated", {
                landingPage: window.location.pathname,
            });
        };
        // Theo dõi tải trang ban đầu
        window.addEventListener("load", function () {
            _this.trackEvent("Initial_Page", {
                landingPage: window.location.pathname,
            });
        });
    };
    return PetsyTracker;
}());

function FlowRunner(props) {
    var _a;
    // @ts-ignore
    var appVersion = __APP_VERSION__;
    useNavigate(); // Thay thế useHistory
    var location = useLocation();
    var activeStep = useFlowController().activeStep;
    var _b = useFlowData(), getData = _b.getData; _b.setData;
    var _c = useState(false), isActiveStepValid = _c[0], setIsActiveStepValid = _c[1];
    // Using to force re-render when test data added
    var _d = useState(0), devState = _d[0], setDevState = _d[1];
    setFlowConfig(props.flowConfig);
    var flowDataStore = getFlowPathData();
    // Scroll window to the top on route change
    useEffect(function () {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 250);
    }, [location]);
    useEffect(function () {
        var _a;
        setIsActiveStepValid((_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.isValid) !== null && _a !== void 0 ? _a : false);
    }, [activeStep]);
    function getNavItems() {
        var navItems = [];
        //@ts-ignore
        if (window.flowSettings.isTest)
            navItems.push({ name: "Dev", itemKey: "dev" });
        return navItems;
    }
    function navItemClick(itemKey) {
        switch (itemKey) {
            case "services":
            case "team":
                alert(itemKey);
                break;
            case "dev":
                setShowDevWindow(true);
                break;
        }
    }
    // Dev tools
    var _e = useState(false), showDevWindow = _e[0], setShowDevWindow = _e[1];
    var handleCloseDevWindow = function () { return setShowDevWindow(false); };
    var showDevPopout = function () { return setShowDevWindow(true); };
    // **************
    var allowedStartRoutes = [];
    //@ts-ignore
    if (window.flowSettings.isTest)
        allowedStartRoutes = ["/step-1", "/options"];
    else
        allowedStartRoutes = ["/step-1"];
    // Cho phép tất cả các đường dẫn bắt đầu bằng /step-1
    if (location.pathname.startsWith("/step-1")) {
        allowedStartRoutes.push(location.pathname);
    }
    // Recaptcha: store the ref so other components can access it
    var recaptchaRef = React__default.useRef(null);
    function setSessionGuid() {
        var sessionId = getData("root.sessionId");
        if (!sessionId) {
            sessionId = getGuid();
            setFlowDataDirect("sessionId", sessionId);
        }
        return sessionId;
    }
    useEffect(function () {
        window.devTools = showDevPopout;
        if (props.helpTips)
            setFlowHelpTips(props.helpTips);
        if (recaptchaRef.current)
            setRecaptcha(recaptchaRef);
        lodashUtils.set(getFlowCache(), "appConfig", props.appConfig);
        setSessionGuid();
        if (props.onFlowStart)
            props.onFlowStart();
        //lấy adfixusID
        var adfixusID = getAFXProfile();
        if (adfixusID === "(not set)") {
            adfixusID = "";
        }
        var tracker = new PetsyTracker({
            apiKey: props.appConfig.trackingApiKey,
            apiUrl: props.appConfig.trackingApiUrl,
            source: "PetsyQT",
            adfixusID: adfixusID,
        });
        setPetsyTracker(tracker);
        tracker.syncSessionRewindUrlFromWindow();
    }, []);
    var pathRedirect = "/step-1";
    var refValue = (_a = location.pathname.match(/ref.*/)) === null || _a === void 0 ? void 0 : _a[0];
    if (location.pathname.includes("step-1")) {
        var landingPage = getData("landingPage");
        !landingPage ? setFlowDataDirect("landingPage", location.pathname) : "";
        pathRedirect = location.pathname;
    }
    else if (refValue) {
        pathRedirect = "/step-1".concat(location.pathname);
    }
    return (React__default.createElement(React__default.Fragment, null,
        props.recaptchaKey && (
        // @ts-ignore - React 18 compatibility issue
        React__default.createElement(Recaptcha, { ref: recaptchaRef, sitekey: props.recaptchaKey })),
        React__default.createElement(FlowNav, { logo: "/images/logo-tag-line.svg", logoLink: "/step-1", navItems: getNavItems(), onItemClick: navItemClick }),
        React__default.createElement("div", { key: "ds_" + devState, "data-testid": "FlowRunner", className: "flc_flow-runner" },
            React__default.createElement(AnimatePresence, { mode: "wait", initial: false },
                React__default.createElement(Routes, { location: location, key: location.pathname },
                    React__default.createElement(Route, { path: "/step-1/*", element: React__default.createElement(motion.div, { initial: { opacity: 0, scaleY: 0.8, scaleX: 0.8 }, animate: { opacity: 1, scaleY: 1, scaleX: 1 }, exit: { opacity: 0, scaleY: 1, scaleX: 1 }, transition: { duration: 0.1 } },
                            React__default.createElement(FlowStep, { key: "step_0", flowStep: props.flowConfig[0], isValid: isActiveStepValid, additionalComponents: props.additionalComponents, helperText: props.helperText })) }),
                    lodashUtils.isEmpty(flowDataStore.pets) &&
                        !allowedStartRoutes.some(function (route) { return location.pathname.startsWith(route); }) && (React__default.createElement(Route, { path: "*", element: React__default.createElement(Navigate, { to: "".concat(pathRedirect).concat(location.search), replace: true }) })),
                    props.flowConfig.map(function (step, stepIndex) {
                        return [
                            "edit-cover-1",
                            "edit-cover-2",
                            "edit-cover-3",
                            "edit-cover-4",
                            "custom-cover",
                        ].includes(step.slug) ? (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Route, { key: "".concat(stepIndex, "-base"), path: "/" + step.slug, element: React__default.createElement(motion.div, { initial: { opacity: 0, scaleY: 0.8, scaleX: 0.8 }, animate: { opacity: 1, scaleY: 1, scaleX: 1 }, exit: { opacity: 0, scaleY: 1, scaleX: 1 }, transition: { duration: 0.1 } },
                                    React__default.createElement(FlowStep, { key: "step_" + stepIndex, flowStep: step, isValid: isActiveStepValid, additionalComponents: props.additionalComponents, helperText: props.helperText })) }),
                            React__default.createElement(Route, { key: "".concat(stepIndex, "-with-id"), path: "/" + step.slug + "/:id", element: React__default.createElement(motion.div, { initial: { opacity: 0, scaleY: 0.8, scaleX: 0.8 }, animate: { opacity: 1, scaleY: 1, scaleX: 1 }, exit: { opacity: 0, scaleY: 1, scaleX: 1 }, transition: { duration: 0.1 } },
                                    React__default.createElement(FlowStep, { key: "step_" + stepIndex, flowStep: step, isValid: isActiveStepValid, additionalComponents: props.additionalComponents, helperText: props.helperText })) }))) : (React__default.createElement(Route, { key: stepIndex, path: "/" + step.slug, element: React__default.createElement(motion.div, { initial: { opacity: 0, scaleY: 0.8, scaleX: 0.8 }, animate: { opacity: 1, scaleY: 1, scaleX: 1 }, exit: { opacity: 0, scaleY: 1, scaleX: 1 }, transition: { duration: 0.1 } },
                                React__default.createElement(FlowStep, { key: "step_" + stepIndex, flowStep: step, isValid: isActiveStepValid, additionalComponents: props.additionalComponents, helperText: props.helperText })) }));
                    }))),
            React__default.createElement(FlowFooter, __assign({}, props.helperText, { appVersion: appVersion }))),
        React__default.createElement(Offcanvas, { show: showDevWindow, onHide: handleCloseDevWindow },
            React__default.createElement(Offcanvas.Header, { closeButton: true },
                React__default.createElement(Offcanvas.Title, null,
                    "Dev Info - Petsy Flow v",
                    appVersion)),
            React__default.createElement(Offcanvas.Body, { style: { fontSize: "0.8em" } },
                React__default.createElement("div", { className: "" },
                    React__default.createElement("a", { href: "", onClick: function (e) {
                            e.preventDefault();
                            if (props.onAddTestData) {
                                props.onAddTestData(flowDataStore);
                                setDevState(function (state) { return state + 1; }); // Trigger repaint
                            }
                        } }, "Add test data"),
                    React__default.createElement("a", { className: "ms-3", href: "", onClick: function (e) {
                            e.preventDefault();
                            logEvent("path-data", true, "Path data log");
                            alert("Path data logged.");
                        } }, "Log path data"),
                    React__default.createElement("hr", null),
                    React__default.createElement(EnumObject, { object: flowDataStore })),
                "Current data change subscriptions: ",
                getCurrentDataChangeSubscriptions().length,
                React__default.createElement("ul", null, getCurrentDataChangeSubscriptions().map(function (subscription, index) { return (React__default.createElement("li", { key: "data_change_sub" + index }, subscription)); }))))));
}
// Util function component to enumerate all properties and values on the passed object
function EnumObject(props) {
    function getNode(obj, ulClassName) {
        return (React__default.createElement("ul", { className: ulClassName }, lodashUtils.map(Object.getOwnPropertyDescriptors(obj), function (value, key) { return (React__default.createElement("li", { key: key }, value.value && typeof value.value === "object" ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("b", null,
                key,
                ": "),
            React__default.createElement(EnumObject, { object: value.value }))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("b", null,
                key,
                ":"),
            " ",
            String(obj[key]))))); })));
    }
    return React__default.createElement(React__default.Fragment, null, getNode(props.object, props.className));
}

var css_248z$7 = "body .flc_toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 65px;\n  height: 30px;\n}\nbody .flc_toggle-switch input[type=checkbox]:focus:checked + .switch {\n  box-shadow: 0 0 0 4px var(--flc_toggle-on-focus-color, #46db88);\n}\nbody .flc_toggle-switch input[type=checkbox]:focus + .switch {\n  box-shadow: 0 0 0 4px #a7a7a7;\n}\nbody .flc_toggle-switch input[type=checkbox] {\n  min-width: 65px;\n  min-height: 30px;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n}\nbody .flc_toggle-switch .switch {\n  position: absolute;\n  cursor: pointer;\n  color: white;\n  background-color: #707070;\n  border-radius: 25px;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transition: background-color 0.2s ease;\n  font-size: 0.9em;\n  font-weight: bold;\n  padding-left: 0.4em;\n  padding-right: 0.4em;\n  user-select: none;\n  -webkit-user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\nbody .flc_toggle-switch .switch::before {\n  position: absolute;\n  content: \"\";\n  left: 2px;\n  top: 2px;\n  width: calc(30px - 4px);\n  height: calc(30px - 4px);\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\nbody .flc_toggle-switch input[type=checkbox]:checked + .switch::before {\n  transform: translateX(calc(65px - 30px));\n  background-color: white;\n}\nbody .flc_toggle-switch input[type=checkbox]:checked + .switch {\n  background-color: var(--flc_toggle-on-bkgnd-color, #35c274);\n  color: white;\n  justify-content: flex-start;\n}";
styleInject(css_248z$7);

function ToggleSwitch(props) {
    var _a = useState(props.checked), isToggled = _a[0], setIsToggled = _a[1];
    var onToggle = function (e) {
        setIsToggled(!isToggled);
        if (props.onChange != null)
            props.onChange(e);
    };
    return (React__default.createElement("div", null,
        React__default.createElement("label", { className: "flc_toggle-switch" },
            React__default.createElement("input", { type: "checkbox", checked: isToggled, onChange: onToggle }),
            React__default.createElement("span", { className: "switch" }, isToggled ? "ON" : "OFF"))));
}

var css_248z$6 = "body .flc_price {\n  font-size: 5rem;\n  font-weight: bold;\n}\nbody .flc_price .symbol {\n  font-size: 0.7em;\n  position: relative;\n  bottom: 0.3em;\n}\nbody .flc_price .dollars {\n  font-size: 1em;\n}\nbody .flc_price .cents {\n  font-size: 0.6em;\n  position: relative;\n  bottom: 0.4em;\n}\nbody .flc_price.cross-out {\n  position: relative;\n  display: inline-block;\n}\nbody .flc_price.cross-out svg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}";
styleInject(css_248z$6);

function Price(props) {
    if (props.isBold === undefined)
        props.isBold = false;
    if (props.isSymbolAndCentsSmall === undefined)
        props.isSymbolAndCentsSmall = true;
    if (props.isCrossOut === undefined)
        props.isCrossOut = false;
    var styles = {
        fontSize: "".concat(props.sizeEm == null ? 1 : props.sizeEm, "em"),
        fontWeight: props.isBold ? 'bold' : 'normal',
    };
    function getDollars(price) {
        return Math.trunc(props.price);
    }
    function getCents(price) {
        return (props.price - Math.trunc(props.price)).toFixed(2).slice(-3);
    }
    var crossOutColor = props.crossOutColor === undefined ? '#FF0000' : props.crossOutColor;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: props.className +
                ' flc_price' +
                (props.isCrossOut ? ' cross-out' : ''), style: styles },
            props.isCrossOut && (React__default.createElement("svg", null,
                React__default.createElement("line", { stroke: crossOutColor, strokeWidth: '0.1em', x1: '0', y1: '60%', x2: '100%', y2: '40%' }))),
            React__default.createElement("span", { className: props.isSymbolAndCentsSmall ? 'symbol' : '' }, "$"),
            React__default.createElement("span", { className: 'dollars' }, getDollars(props.price)),
            React__default.createElement("span", { className: props.isSymbolAndCentsSmall ? 'cents' : '' }, getCents(props.price)))));
}

var css_248z$5 = "body .flc_product-option {\n  font-size: 1em;\n  padding: 1em;\n  border-width: 3px;\n  border-style: solid;\n  border-radius: 16px;\n  min-width: 320px;\n  min-height: 150px;\n  color: #707070;\n  background-color: #ffffff;\n}\nbody .flc_product-option.selected {\n  border-color: #35c274;\n  background-color: #e5fff1;\n}\nbody .flc_product-option a {\n  color: #eb551d;\n  font-weight: 600;\n  text-decoration: none;\n}\nbody .flc_product-option a:hover {\n  color: #b43000;\n}\nbody .flc_product-option .header {\n  display: flex;\n}\nbody .flc_product-option .title {\n  width: 70%;\n  min-height: 2.7em;\n  font-size: 1.4em;\n  font-weight: 600;\n  line-height: 1.2em;\n  font-family: \"Exo 2\";\n}\nbody .flc_product-option .toggle {\n  width: 30%;\n  text-align: right;\n}\nbody .flc_product-option .content {\n  width: 100%;\n}\nbody .flc_product-option-promotion {\n  display: inline-block;\n  color: white;\n  background-color: red;\n  padding: 0.2em 0.6em;\n  margin-left: 20px;\n  border-radius: 10px 10px 0 0;\n  font-weight: 600;\n}\nbody .flc_product-option .images {\n  display: flex;\n  justify-content: center;\n  padding-top: 1em;\n}\nbody .flc_product-option .images img {\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  margin-top: auto;\n}\nbody .flc_product-option .read-more {\n  text-transform: uppercase;\n  text-align: center;\n  padding-top: 1.6em;\n  padding-bottom: 0;\n}\nbody .flc_product-option .read-more-content {\n  text-transform: none;\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.2s ease;\n}\nbody .flc_product-option .expanded > .read-more-content {\n  max-height: 200px;\n  transition: max-height 0.2s ease;\n}";
styleInject(css_248z$5);

function ProductOption(props) {
    var _a = React__default.useState(props.isSelected), isSelected = _a[0], setIsSelected = _a[1];
    return (React__default.createElement("div", { className: 'flc_product-option-container' },
        props.isPromotion && (React__default.createElement("div", { className: 'flc_product-option-promotion' }, props.promotionText)),
        React__default.createElement("div", { className: 'flc_product-option ' + (isSelected ? 'selected' : '') },
            React__default.createElement("div", { className: 'header' },
                React__default.createElement("div", { className: 'title' }, props.title),
                React__default.createElement("div", { className: 'toggle' },
                    React__default.createElement(ToggleSwitch, { checked: isSelected, onChange: function (e) {
                            setIsSelected(e.target.checked);
                        } }))),
            React__default.createElement(Price, { sizeEm: isSelected ? 1.3 : 1.3, price: 123.45, isBold: isSelected, isSymbolAndCentsSmall: true, isCrossOut: false }),
            props.isPromotion && (React__default.createElement("span", { className: 'ms-2' },
                "Was",
                React__default.createElement(Price, { className: 'ms-1', sizeEm: 1.2, price: 155.2, isBold: false, isSymbolAndCentsSmall: true, isCrossOut: true }))),
            React__default.createElement("div", { className: 'content' }, props.children))));
}
function ProductOptionImages(props) {
    return React__default.createElement("div", { className: 'images' }, props.children);
}
var IconWrapper = function (_a) {
    var Icon = _a.icon, props = __rest(_a, ["icon"]);
    return React__default.createElement(Icon, __assign({}, props));
};
function ProductOptionReadMore(props) {
    var _a = React__default.useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    return (React__default.createElement("div", { className: 'read-more ' + (isExpanded ? 'expanded' : '') },
        React__default.createElement("a", { href: '', onClick: function (e) {
                e.preventDefault();
                setIsExpanded(!isExpanded);
            } },
            "Details ",
            React__default.createElement(IconWrapper, { icon: CaretDownFill, size: 16 })),
        props.children));
}
function ProductOptionReadMoreContent(props) {
    return React__default.createElement("div", { className: 'read-more-content' }, props.children);
}

var css_248z$4 = "body .flc_quantity-chooser {\n  color: black;\n  border: 2px solid var(--flc-unselected-border-color);\n  background-color: var(--flc-unselected-background-color);\n  border-radius: 12px;\n  text-align: center;\n  overflow: hidden;\n  font-size: min(0.7rem + 1.5vw, 20px);\n  font-weight: bold;\n  position: relative;\n  display: inline-block;\n}\nbody .flc_quantity-chooser.selected {\n  color: var(--flc-selected-font-color);\n  border: 2px solid var(--flc-selected-border-color);\n  background-color: var(--flc-selected-background-color);\n}\nbody .flc_quantity-chooser .button {\n  display: inline-block;\n  border-top: 1.5px solid var(--flc-unselected-border-color);\n  cursor: pointer;\n  width: 50%;\n  height: 2.5em;\n  line-height: 2.3em;\n  margin: auto;\n  font-size: 25px;\n  font-weight: normal;\n  user-select: none;\n}\nbody .flc_quantity-chooser .button.first {\n  border-right: 1.5px solid var(--flc-unselected-border-color);\n}\nbody .flc_quantity-chooser.selected .button {\n  border-color: var(--flc-selected-border-color);\n}\nbody .flc_quantity-chooser .button:active:hover {\n  background-color: var(--flc-primary-color);\n  color: white;\n}\n@media (hover: hover) and (pointer: fine) {\n  body .flc_quantity-chooser .button:hover {\n    background-color: var(--flc-hover-background-color, lightgrey);\n  }\n}\nbody .flc_quantity-chooser .qty {\n  background-color: var(--flc-primary-color);\n  color: white;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  text-align: center;\n  display: flex;\n  width: 11vw;\n  max-width: 60px;\n  height: 11vw;\n  max-height: 60px;\n  top: 16px;\n  right: 16px;\n}";
styleInject(css_248z$4);

function QuantityChooser(props) {
    var _a, _b;
    var _c = useState({
        qty: (_a = props.value) !== null && _a !== void 0 ? _a : 0,
        image: getImage((_b = props.value) !== null && _b !== void 0 ? _b : 0),
    }), state = _c[0], setState = _c[1];
    function onClick(button) {
        setState(function (currentState) {
            var add = 0;
            if (button === 'plus') {
                if (props.totalQty && props.totalQty >= 5)
                    add = 0;
                else
                    add = 1;
            }
            else if (button === 'minus' && currentState.qty > 0)
                add = -1;
            if (add === 0)
                return currentState;
            var newState = __assign(__assign({}, currentState), { qty: currentState.qty + add, image: getImage(currentState.qty + add) });
            return newState;
        });
    }
    useEffect(function () {
        if (props.onChange)
            props.onChange(state.qty);
    }, [state]);
    function getImage(qty) {
        if (qty > 0)
            return props.imageSelected;
        else
            return props.image;
    }
    return (React__default.createElement("div", { "data-testid": 'QuantityChooser', className: 'flc_quantity-chooser flex-fill ' +
            (props.className ? props.className : '') +
            ' ' +
            (state.qty > 0 ? 'selected' : '') },
        React__default.createElement(AnimatePresence, null, state.qty > 0 && (React__default.createElement(motion.div, { className: 'qty', initial: { scale: 0.5 }, animate: { scale: 1 }, exit: { scale: 0.5 }, transition: { duration: 0.1 }, key: state.qty },
            "x",
            state.qty))),
        React__default.createElement("div", { className: 'img-label-container', onClick: function () { return onClick('plus'); } },
            React__default.createElement("div", { className: 'pt-3 pb-3 item-image' },
                React__default.createElement(Image, { src: state.image })),
            React__default.createElement("div", { className: 'mt-1 pb-3 item-name' }, props.itemName)),
        React__default.createElement("div", { className: 'btn-container' },
            React__default.createElement("div", { className: "button first item-btn", onClick: function () { return onClick('minus'); } }, "\u2013"),
            React__default.createElement("div", { className: "button item-btn ".concat(props.totalQty && props.totalQty >= 5 ? 'btn-disabled' : ''), onClick: function () { return onClick('plus'); } }, "+"))));
}

var css_248z$3 = "body .flc_popup-tip {\n  color: var(--flc-paragrpah-text-color, green);\n  display: block;\n  cursor: help;\n  width: 1.7rem;\n  height: 1.7rem;\n  margin-top: -0.4rem;\n}\nbody .flc_popup-tip.has-label {\n  margin-left: 0.5rem !important;\n  border-bottom: 2px dashed;\n  cursor: pointer;\n  width: unset !important;\n}";
styleInject(css_248z$3);

function PopupTip(props) {
    var _a = React.useState(false), showTipWindow = _a[0], setShowTipWindow = _a[1];
    var handleCloseTipWindow = function () { return setShowTipWindow(false); };
    var popover = props.tip ? props.tip : undefined;
    var label = props.label ? props.label : undefined;
    console.log("label: ", label);
    console.log("popover: ", popover);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flc_popup-tip " + props.className + " " + (label != undefined ? " has-label" : ""), onClick: function (e) {
                e.preventDefault();
                setShowTipWindow(true);
            } },
            label && React.createElement("span", null, label),
            !label && React.createElement(ReactSVGWrapper, { src: "/images/icons/Tooltip_purple.svg" }),
            props.children && React.createElement("div", null, props.children)),
        React.createElement(Offcanvas, { show: showTipWindow, onHide: handleCloseTipWindow }, popover)));
}

var css_248z$2 = "@charset \"UTF-8\";\nbody .flc_product-review {\n  display: flex;\n  margin-bottom: 0;\n  padding: 0 1rem;\n  color: var(--flc-petsy-text-primary);\n  align-items: stretch;\n}\nbody .flc_product-review.review-top .flc_product-review-comment-details {\n  min-height: 17rem;\n}\nbody .flc_product-review.review-top .flc_product-review-comment-details .flc_product-review-comment {\n  height: 82%;\n}\nbody .flc_product-review.review-bottom .flc_product-review-comment-details {\n  min-height: 17rem;\n}\nbody .flc_product-review.review-bottom .flc_product-review-comment-details .flc_product-review-comment {\n  height: 82%;\n}\nbody .flc_product-tag-line-logo-container {\n  width: 30%;\n  text-align: center;\n  height: 9rem;\n}\nbody .flc_product-tag-line-logo-container img {\n  width: 10rem;\n  padding: 0.625rem;\n}\nbody .flc_product-tag-line-logo-container .flc_product-review-tag-line p {\n  font-size: 0.625rem;\n  margin-left: -13%;\n  font-weight: bold;\n}\nbody .flc_product-review-comments {\n  width: 70%;\n  display: flex;\n}\nbody .flc_product-review .flc_product-review-comment-details:nth-child(1) {\n  margin-right: 2%;\n}\nbody .flc_product-review-comment-details {\n  font-size: 0.75rem;\n  width: 16.4375rem;\n  padding: min(1.3rem, 0.4rem + 0.7vw);\n  padding-top: 0.75rem;\n  padding-bottom: 1.5rem;\n  justify-content: center;\n  background: #ffffff;\n  box-shadow: 0 3px 0.5rem rgba(0, 0, 0, 0.18);\n  border-radius: 1.25rem;\n  min-height: 8.6875rem;\n  max-height: 17rem;\n}\nbody .flc_product-review-name-date {\n  height: 10%;\n}\nbody .flc_product-review-name-date .separator {\n  display: none;\n}\nbody .flc_product-review-name-date p {\n  margin: 0;\n  padding: 0;\n  font-weight: bold;\n  font-family: var(--heading-font-name);\n  font-size: min(1rem, 0.4rem + 1.2vw);\n  text-align: left;\n  line-height: 1.2rem;\n}\nbody .flc_product-review-comment {\n  min-height: 5rem;\n  max-height: 20rem;\n  line-height: 1rem;\n  height: 76%;\n}\nbody .flc_product-review-rating span::before {\n  content: \"★\";\n  position: relative;\n  font-size: 1.1rem;\n  line-height: 0.5rem;\n}\nbody .flc_product-review-rating {\n  height: 13%;\n}\nbody .flc_product-review-rating span {\n  color: #feca02;\n}";
styleInject(css_248z$2);

function ProductReview(props) {
    var _a = React.useState([]), productReviews = _a[0], setProductReview = _a[1];
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (props.isTop) {
            setProductReview((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.helperText) === null || _a === void 0 ? void 0 : _a.productReview) === null || _b === void 0 ? void 0 : _b.top) !== null && _c !== void 0 ? _c : []);
        }
        else {
            setProductReview((_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.helperText) === null || _d === void 0 ? void 0 : _d.productReview) === null || _e === void 0 ? void 0 : _e.footer) !== null && _f !== void 0 ? _f : []);
        }
    }, []);
    return (React.createElement("div", { "data-testid": "ProductReview", className: "flc_product-review " + props.className + " " + (props.isTop ? "review-top" : "review-bottom") },
        React.createElement("div", { className: "flc_product-tag-line-logo-container" },
            React.createElement("div", { className: "flc_product-review-tag-line" },
                React.createElement("p", null, props.tagLine)),
            React.createElement("div", null,
                React.createElement(Image, { src: props.logo }))),
        React.createElement("div", { className: "flc_product-review-comments" }, productReviews.map(function (productReview, index) {
            return (React.createElement("div", { className: "flc_product-review-comment-details", key: index },
                React.createElement("div", { className: "flc_product-review-rating" },
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null)),
                React.createElement("div", { className: "flc_product-review-comment", dangerouslySetInnerHTML: { __html: productReview.review } }),
                React.createElement("div", { className: "flc_product-review-name-date" },
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: productReview.reviewer } }),
                    React.createElement("span", { className: "separator" }, " \u00A0 - \u00A0"),
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: productReview.date } }))));
        }))));
}

var css_248z$1 = "body .flc_label-with-condition {\n  color: green;\n}";
styleInject(css_248z$1);

function LabelWithCondition(props) {
    var _a, _b;
    var _c = useFlowData(); _c.getData; var injectData = _c.injectData;
    var labelValue = injectData((_a = getLabel()) !== null && _a !== void 0 ? _a : ""); //  React.useMemo(() => injectData(getLabel() ?? ""), []);
    function getLabel() {
        var _a, _b, _c, _d;
        if (props.condition == undefined)
            return (_a = props.conditionTrueLabel) !== null && _a !== void 0 ? _a : "";
        var field = props.condition.split("==");
        if (field.length == 1)
            return (_b = props.conditionTrueLabel) !== null && _b !== void 0 ? _b : "";
        var field1 = field[0] ? field[0].trim() : field[0];
        var field2 = field[1] ? field[1].trim() : field[1];
        var fieldData = "";
        if (field1.indexOf("{") > -1) {
            fieldData = getFlowDataDirect(field1.slice(1, -1).toString());
        }
        if (fieldData == undefined || fieldData == null)
            return "";
        if (parseFloat(fieldData) == parseFloat(field2))
            return (_c = props.conditionTrueLabel) !== null && _c !== void 0 ? _c : "";
        else
            return (_d = props.conditionFalseLabel) !== null && _d !== void 0 ? _d : "";
    }
    return (React.createElement("div", { "data-testid": "LabelWithCondition", className: "flc_label-with-condition " },
        React.createElement("div", { className: (_b = props.className) !== null && _b !== void 0 ? _b : "", dangerouslySetInnerHTML: {
                __html: labelValue,
            } })));
}

var css_248z = "";
styleInject(css_248z);

function TextMask(props) {
    var _a, _b, _c;
    var _d = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : ""), state = _d[0], setState = _d[1];
    var _e = React__default.useState(props.value !== "" && props.value !== undefined), isTouched = _e[0], setIsTouched = _e[1];
    var _f = React__default.useState(false), isInvalid = _f[0], setIsInvalid = _f[1];
    var _g = React__default.useState("form-control"), inputClassName = _g[0], setInputClassName = _g[1];
    var maskInputRef = React__default.useRef(null);
    useEffect(function () {
        if (isTouched) {
            if (isInvalid) {
                setInputClassName("form-control is-invalid");
            }
            else {
                setInputClassName("form-control is-valid");
            }
        }
    }, [isInvalid]);
    function stripMaskChars(value) {
        return value.replaceAll("_", "").replaceAll(" ", "").replaceAll("-", "");
    }
    function checkIsValid(value) {
        var _a;
        var mask = (_a = props.mask) !== null && _a !== void 0 ? _a : "";
        if (mask === "phone")
            mask = getPhoneNumberMask(value);
        var replaced = stripMaskChars(value);
        if (replaced.length === stripMaskChars(mask).length)
            return true;
        else
            return false;
    }
    var _h = React__default.useState(props.mask === "phone"
        ? getPhoneNumberMask((_b = props.value) !== null && _b !== void 0 ? _b : "")
        : (_c = props.mask) !== null && _c !== void 0 ? _c : ""), mask = _h[0], setMask = _h[1];
    function getPhoneNumberMask(phoneNumber) {
        if (stripMaskChars(phoneNumber).length > 2 &&
            stripMaskChars(phoneNumber).substring(0, 2) === "04")
            return "1111 111 111";
        else
            return "11 1111 1111";
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form.Group, { as: Col, className: "mt-1 my-3", controlId: "ctrl_" + props.id },
            React__default.createElement(FloatingLabel, { label: props.prompt, className: isInvalid ? "text-danger" : "" },
                React__default.createElement(Form.Control, { ref: maskInputRef, as: MaskedInputWrapper, id: props.id, key: props.id, name: props.dataField, type: props.type, placeholder: props.prompt, value: state, required: props.required, autoComplete: "off", onChange: function (e) {
                        var _a, _b, _c, _d;
                        if (props.mask === "phone") {
                            var newMask = getPhoneNumberMask(e.target.value);
                            if (newMask !== mask) {
                                setMask(getPhoneNumberMask(e.target.value));
                                // Handles the space inserted when mask is changed
                                if (stripMaskChars(e.target.value).substring(0, 2) === "04" &&
                                    stripMaskChars(e.target.value).length == 3) {
                                    //@ts-ignore
                                    (_a = maskInputRef.current) === null || _a === void 0 ? void 0 : _a.input.selectionStart = 3;
                                    //@ts-ignore
                                    (_b = maskInputRef.current) === null || _b === void 0 ? void 0 : _b.input.selectionEnd = 3;
                                }
                                if (stripMaskChars(e.target.value).substring(0, 2) === "04" &&
                                    stripMaskChars(e.target.value).length == 4) {
                                    //@ts-ignore
                                    (_c = maskInputRef.current) === null || _c === void 0 ? void 0 : _c.input.selectionStart = 4;
                                    //@ts-ignore
                                    (_d = maskInputRef.current) === null || _d === void 0 ? void 0 : _d.input.selectionEnd = 4;
                                }
                            }
                        }
                        setState(e.target.value);
                        var isValid = checkIsValid(e.target.value);
                        props.onChange &&
                            props.onChange({
                                field: e.target.name,
                                value: stripMaskChars(e.target.value),
                            });
                        if (isTouched)
                            setIsInvalid(!isValid);
                    }, onBlur: function (e) {
                        var isValid = checkIsValid(e.target.value);
                        setIsInvalid(!isValid);
                        if (props.required != undefined
                            ? props.required == false && e.target.value === ""
                            : false) {
                            setIsInvalid(false);
                            setIsTouched(false);
                        }
                        props.onBlur &&
                            props.onBlur({
                                field: e.target.name,
                                value: stripMaskChars(e.target.value),
                            });
                    }, className: inputClassName, isInvalid: isInvalid, isValid: isTouched && !isInvalid, mask: mask, "aria-describedby": props.type + "HelpBlock", "data-private": props.dataPrivate }),
                React__default.createElement(Form.Control.Feedback, { type: "invalid" }, props.invalidMessage)))));
}

var FlowControllerMessage;
(function (FlowControllerMessage) {
    FlowControllerMessage["Next"] = "next";
    FlowControllerMessage["Back"] = "back";
    FlowControllerMessage["SubStep"] = "sub_step";
    FlowControllerMessage["GotoStep"] = "goto_step";
    // GetData = 'get_data',
    // SetData = 'set_data',
})(FlowControllerMessage || (FlowControllerMessage = {}));

var commonTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get FlowControllerMessage () { return FlowControllerMessage; }
});

export { AgePicker, BackButton, CountryPicker, DatePicker, DateRangePicker, FlowFooter, FlowForm, FlowNav, FlowProvider, FlowRunner, FlowStep, commonTypes as FlowTypes, Heading, Icon, IconColorStyle, IconSize, InfoBox, InfoList, LabelWithCondition, LabelledIcons, MemoizedSummary, NextButton, OptionElementTextAlign, OptionElementType, OptionToggle, OptionalLayout, Options, PopupTip, Price, ProductOption, ProductOptionImages, ProductOptionReadMore, ProductOptionReadMoreContent, ProductReview, QuantityChooser, StringFormats, Summary, TextMask, TickBox, Tip, ToggleSwitch, checkQuoteExpired, clearDataChangeSubscriptions, emailValidationPattern, formatString, getCurrentDataChangeSubscriptions, getFlowCache, getFlowDataDirect, getFlowPathData, getFlowTelemetry, getGuid, getPetsyTracker, getPromotionCode, getRecaptcha, getRecaptchaToken, getSavedCover, getSavedQuote, handleSendKlaviyoEvents, invokeFlowStepNextHook, logEvent, registerFlowStepNextHook, saveCountVisit, sendKlaviyoEvent, sendSms, setFlowDataDirect, subscribeDataChange, timeout, unregisterFlowStepNextHook, unsubscribeDataChange, updateQuoteNumberToPets, useFlowController, useFlowData };
//# sourceMappingURL=index.esm.js.map
